var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCateringTitleText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CateringTitleText_2",
    "data-name": "CateringTitleText 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 546.47 186.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .CateringTitleText-1 {\n        font-family: nexa-rust-sans-black-2, 'nexa-rust-sans-black-2';\n        font-size: 87.28px;\n        font-weight: 800;\n      }\n\n      .CateringTitleText-1, .CateringTitleText-2 {\n        fill: #ee3337;\n      }\n\n      .CateringTitleText-2 {\n        font-family: RedSoxNationNormal, RedSoxNation;\n        font-size: 52.65px;\n      }\n\n      .CateringTitleText-3 {\n        fill: #f0e2cb;\n      }\n\n      .CateringTitleText-4 {\n        letter-spacing: -.15em;\n      }\n\n      .CateringTitleText-5 {\n        letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CateringTitleText_1",
    "data-name": "CateringTitleText 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "CateringTitleText-2",
    transform: "translate(43.55 79.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Exceptional")), /*#__PURE__*/React.createElement("text", {
    className: "CateringTitleText-1",
    transform: "translate(0 166.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "CateringTitleText-5",
    x: 34.91,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "CateringTitleText-4",
    x: 99.93,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 164.87,
    y: 0
  }, "tering")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M539.73,76.02c.06-.02-.09-.18-.1-.21-.05.1.14.25.1.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "539.26 77.02 539.22 76.94 539.24 77.19 539.26 77.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M538.55,77.59c.3.22.22-.25.43-.26l.07.05-.13-.27c-.13.16-.2.47-.37.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.68,77.33c.11.08,0,.16.11-.05-.02,0-.03,0-.04-.01-.01.02-.03.03-.07.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.75,77.28c.07-.07-.12-.04,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.47,77.64v-.18c-.06-.04-.16.02-.17-.05-.05.14.02.18.17.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.56,77.92v-.08s-.04-.01,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.6,77.65l-.03.18c.05.03.13.11.02-.07.06.09.01,0,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.7,77.64c.1,0,.2-.02.19.16.15-.2-.05-.37-.19-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M538.76,77.9l.14.02-.02-.14c0,.07-.2.04-.13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.76,78.05c.05.06.17.12.24.18v-.13c-.06,0-.16.02-.24-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537,78.23v.19c.09-.07.06-.13,0-.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "537.81 78.22 537.8 77.87 537.78 78.26 537.81 78.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.35 78.41 536.29 78.23 536.37 78.52 536.35 78.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.12,78.69c-.06-.15-.23-.12-.25-.23-.05.09-.02.24,0,.37.01-.1.08-.15.24-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.91,79.04c0-.05-.01-.13-.03-.21,0,.05,0,.12.03.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.79,78.56s-.14-.1-.23-.08l.19.12.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.75,78.6h0s-.08.06-.1.07c.01,0,.04-.03.1-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.8,78.55h-.01s.03.02.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.41,78.33c.02.14-.02.35.23.37-.06-.15-.2-.16-.23-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.03,78.69l.14-.06s-.12-.08-.13-.15v.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "537.03 78.79 537.03 78.69 536.98 78.72 537.03 78.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.23,79c.02.11-.02.17-.07.23.09-.03.17-.08.22-.14-.04-.06-.1-.17-.16-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.49,78.81v.02s.03,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "535.61 79.79 535.65 79.81 535.63 79.78 535.61 79.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.42,79.11c.07-.02.06-.08.04-.15-.02.05-.04.1-.08.14.02.02.03.04.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.83,79.26c.06,0,.11,0,.16,0-.07-.02-.19-.05-.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.43,78.8h0s-.03-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.43,78.8s.02.1.03.15c.02-.04.02-.08.02-.13-.02,0-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.44,80.9c-.14-.14-.15-.39.1-.34,0-.2-.54-.59-.89-.75.06.06.12.12.1.3.11.04.41-.06.45.16-.06.21-.16.06-.3.06.23.11.09.42.38.64l.02-.21s.07.14.14.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.86,79.62l.02-.06c-.07.02-.16,0-.34-.04,0,.14.04.21.08.26l.23-.19v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.07,79.37c.12.19.09.35.31.45.11-.14-.04-.21-.04-.36-.16.24-.03-.14-.26-.08.01-.07.04-.11.07-.15-.05.02-.11.03-.17.04h.01s0,0,0,0h0s.04.02.02.02h0s.03.05.05.07c-.09.03-.05-.03-.05-.07l-.02-.02h0s-.12.29-.12.29c.06-.02.11-.08.19-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.85,79.14s-.03-.02-.04-.03c0,.03.01.05.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.67,79.13s-.05-.11.01-.14c.09,0,.07.08.12.12-.01-.07,0-.21-.17-.2v.03c-.13.02-.42-.07-.43-.11.16.12.28.2.46.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.9,79.28l-.09.24.21.05-.08-.08c.12-.06,0-.14-.04-.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "535.52 79.73 535.38 79.55 535.51 79.88 535.52 79.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "535.32 79.98 535.18 79.83 535.21 79.97 535.32 79.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M526.66,94.98v.09s0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M526.97,94.59l-.07-.07c.03.05.05.08.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M530.5,85.78c-.21-.03-.5-.12-.32,0l.19.11c.01-.08.06-.11.13-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M528.5,90.64l.07.02c-.05-.06-.09-.12-.13-.18.02.05.04.1.06.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.18,91.23l-.19.02c.06,0,.12,0,.19-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M525.12,97.26l.12.2c.08-.1-.04-.13-.12-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.28,82.39c-.12.01-.19.04-.24.08.16,0,.36.05.24-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M524.96,93.41c0,.06.03.1.07.13,0-.06-.02-.1-.07-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.88,82.67s.04,0,.07,0c.01-.07.03-.14.09-.19-.12,0-.22.03-.16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M517.85,104.09s-.02,0-.03,0c.02.02.03.02.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M514.3,104.66s.04-.07.07-.11c-.03,0-.05.04-.07.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.41,80.83c.03-.06-.01-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.26,81.17s.02.06.06.09c-.04-.04-.05-.07-.06-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.51,84.03h0s.04.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.55,80.82s-.07,0-.1.02c.02,0,.05,0,.1-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.46,80.77s.04-.02.05-.03c-.02-.03-.04-.04-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.36,80.91s.05-.05.09-.06c-.02,0-.03,0-.04-.01-.01.02-.03.04-.05.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M521.43,100.18h-.02c.02.11.03.08.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "531.29 88.47 531.29 88.46 531.28 88.46 531.29 88.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M531.29,88.75c-.16-.24-.1-.26,0-.29l-.55-.31.55.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M525.96,95.96h.25c.13.35-.05.39.26.44-.52-.44.34-.55-.17-.98h.18s0,.05-.02.07c.39.04-.29-.43-.05-.58.1-.04.22-.03.24.07v-.27s.13.04.08.08l.15-.29h.01c-.06-.09-.12-.27-.15-.35.13,0,.03.08.11.11l-.02-.24c.18.05.23.27.14.35.64.28-.05-.22.48-.26l-.03.19c.37.15.34-.04.65-.05-.13-.04-.71-.07-.73-.32.07-.01.14-.05.09-.22.19.15.21.03.27-.08l.25.2c0-.16-.13-.25-.19-.4.12-.1.33.02.52.12.19-.16-.42-.1-.29-.37.22-.09.2-.28.19-.59.17-.05.14.14.25.15l-.13-.25s.08.03.11.06c-.02-.14-.25-.2-.22-.38-.26-.25.62.03.42-.37.1.01.14.14.25.2-.04-.38,0-.31-.16-.7l.29-.03c-.28-.03-.4-.34-.49-.61-.12-.03-.23-.05-.29-.06v-.31c.08,0,.15.09.23.21-.01-.03-.02-.06-.03-.08.15,0,.27.14.37.3-.07-.01-.14-.03-.21-.04.12.17.26.34.41.44-.02-.04-.03-.08-.02-.12.03.04.06.08.09.09.03.01,0-.05-.05-.13l.32.16-.11-.1.38-.14c-.15-.41-.45-.89-.34-1.29.15.23.33.27.58.46-.33-.11-.06.32-.24.44.09-.06.19.04.22.1l-.03-.46c.2.16.2.05.34.04-.44-.24-.11-.41-.15-.62.14.09.26.22.12.34.42.07-.32-.55.05-.51-.02.04-.06.04,0,.1-.06-.17.18-.29.26-.16l-.02.04c.22-.19.52-.69.2-.98.05.03.39.34.45.4l-.84-1.26c.27.25,1.06.64,1.09.95.08-.02.18-.05.16-.25-.07,0-.49-.22-.48-.29.43.1.25.03.65.07-.1,0-.52-.4-.44-.47.06.06.46.33.48.4l-.28-.55c.04.12.37.3.54.34-.1-.04.15-.18.15-.27h-.17c.25-.18-.45-.71-.24-.93.07.1.51.51.66.43-.19-.23-.91-1.09-.92-1.44l.16.06-.02-.28c.26.37.76,1.21.93,1.58.17-.01.17.09.26-.05.16.05.13.22.11.26l.32-.26c-.28-.19-.08-.44-.31-.6v.55c-.27-.19-.59-.78-.37-.97.15.03.44.41.53.47-.07-.1,0-.35.07-.32l.07.2c.2-.04-.19-.48.18-.43.06-.04.46.12.31-.02-.37-.16-1.31-.87-1.49-1.11.03,0,.5-.04.7.02.3.1.46.57.72.66-.07-.06-.12-.18-.13-.22.1,0,.2.2.26.06-.25-.23.21-.22-.18-.24.01-.18.15-.08.24-.22-.21-.1-.49-.59-.47-.77.06.06.17.11.22.13.22-.21.44-.24.62-.45.08.03.24,0,.32.13-.02-.07-.09-.17-.04-.24.33.06-.09.18.26.31-.15-.14-.07-.35-.08-.52-.26-.17-.23.18-.21.35-.32-.27-.53-.72-.48-1.07.07-.25.27.1.25.03.34-.29-.31-.77.16-.84.3.07.41.35.57.45-.05.21-.32.11-.4.21l.2-.04c.03.1,0,.24-.11.24.26.07.53-.52.92-.62-.03-.1-.03-.24-.14-.28l-.04.1c-.23-.07-.09-.35-.25-.32-.02-.21-.09-.49.14-.56l.25.18c-.07-.06-.22-.02-.19.08-.04-.16.51.05.28-.29l-.25-.04c-.02-.21-.14-.57.06-.63-.28-.15,0,.05-.35-.09.4.22-.33.34.14.52-.39-.18-.28.05-.66-.05.08.06.18.08.05.16.02.03.03.06.04.08,0,0,0,0-.01,0h.01s0,.02,0,0c.06,0,.12.02.17.04.12.21-.05.39-.01.53-.1.04-.06-.11-.17-.14l.05.21c-.18-.14-.44-.07-.4-.31l-.14.14c-.17,0-.31.09-.31.22-.1.04.03.33-.05.16l-.09.32-.04-.03c-.21.21-.11.71-.64.71-.02.11-.03.24-.19.32l-.17-.1c-.03.14-.4.17-.28.34-.5-.22-.48.42-.69.53l.19.16c-.11.11-.14.27-.18.49l.18.13c.04.24-.39.23-.53.45-.06-.07,0-.1.07-.11-.6-.07-.11.75-.57.74.02.11-.03.13-.11.13,0,0,0-.01,0-.02,0,0-.01.01-.02.02-.05,0-.1,0-.15,0,.06,0,.11.01.15,0-.03.05-.06.13-.06.23l-.21-.12s0,.01,0,.02c-.12,0,.05.12.22.2,0,.06.02.11.05.17-.35-.18-.02.25-.41.07.13.17-.12.41.19.7-.05-.03-.08-.03-.06-.06-.09.04-.19.08-.14.22l-.27-.15.21.4c-.22-.02-.34-.04-.45-.28.12.45-.03.27.11.68l-.15-.13c-.05.07.08.34-.08.29-.42-.07-.61.74-1.19.93.53.27-.35.03,0,.31-.13-.06-.23-.05-.28-.19-.04.28-.4.18-.2.54-.13-.06-.13-.16-.21-.19.01.03.05.14-.03.11-.08-.03-.07-.1-.1-.17-.13.22.19.5.5.75-.23,0-.25.06-.09.29-.13-.04-.29-.06-.23-.22-.07.06-.48.33-.23.53-.08-.03-.09.09-.08.13-.14.15-.17.15-.26.32h.07c.26.28-.03.17-.09.33l-.03-.03c-.44.13.01.21-.46.31l.2.13c.39.34-.44.07-.4.36l.15.02c.07.2-.75-.17-.87-.11-.05,0-.03-.07-.04-.12-.42.05.23.22.15.44-.16-.07-.31-.3-.43-.2-.15-.02.17.68-.21.65.13.04.26.09.28.23-.06.16-.65.04-.41.41-.04,0-.07-.02-.1-.04.01.16-.1.42.03.61-.72-.42-.16.84-.75.37l-.2.32-.05-.06c-.19.15-.1.34,0,.52-.07.01-.1-.07-.13-.1-.34.18-.34.22-.23.68l-.21-.14c.06.15-.62.13-.62.58-.02-.02-.05-.06-.06-.1-.02.49-1.11.24-.53.94v.33c.27-.2.25.3.46.3-.05.13-.43.07-.36-.08h.05c-.31-.35-.4.2-.63-.02-.41.5-1.03.76-1.47,1.16l.31.21-.16.13c-.1-.02-.25-.15-.14-.25-.2-.09-.05.3,0,.36-.31.1-.22-.39-.29-.33l-.07.1h.05c.03.19.14.31,0,.42-.13.03-.2-.12-.24-.1-.02-.02-.04-.02-.06.04l-.21.15.27.14c.01.18-.19.15.12.31-.48-.25-.85.52-1.04.47.02.27-.11.37-.27.48.08.01.31.24.15.33-.38-.56-.43-.02-.85-.3.3.17-.34.38.11.6-.15.05-.17-.19-.35-.24-.1.42-.71.37-.99.73.05.07.2.12.21.29l-.47-.18c-.04.09.28.43-.05.31.07.04.17.1.14.16-.96.29-1.04,1.45-2.23,1.68.21,0,.17.08.12.16.07-.02.17.13.27.2-.17.03-.33.07-.5.11.22.25-.22.36.02.57l.02-.13c.22.34.81.28,1.19.59-.25-.39.74.04.43-.53.11.02.09.14.19.18-.12-.18-.1-.27.07-.32l.03.05c.24-.35.51-.34.93-.57l-.19-.14c.09-.05.16-.01.24,0-.17-.34-.22.19-.42-.17.43.25.53-.5.97-.16.12-.1-.22-.17-.1-.28l.13.08-.1-.17c.1-.05.26.06.35.15-.03,0-.03.07-.04.1.21.04.24-.29.32-.28l-.18.03c.24-.39.78-.58.92-1.09l-.1-.07c.12-.37.28-.07.5-.38v.03c0-.13.03-.24.12-.29.01.16.3.08.3.27.14-.42.03-.26-.06-.73l.16.1c-.05-.18-.1-.25,0-.41,0,.22.27.13.29.41.56.04.16-.69.7-.37-.21-.5-.45.01-.44-.13-.17-.07-.15-.38-.02-.42.1-.07.61.35.83.12-.02.02,0,.05-.02.07.17.01.04-.29.29-.24-.16-.28.15-.12-.11-.42l-.14.27c.04-.19-.17-.63.17-.66.04.07.06.2.06.28.14.03.05-.16.19-.13.26.3-.19.31-.1.65.18.06.04-.44.27-.07-.29-.48.27-.17.13-.62l.16.18c0-.05-.03-.18.02-.22l.14.3c-.06-.31.4-.08.42-.3-.24.25-.26-.14-.49-.16.07-.52.63.26.87-.17-.02.07-.27.08-.28-.07.1-.03.24-.06.37-.02.18-.27-.21-.13-.23-.33.28.12.02-.19.04-.36l.18.16c.36-.16-.31-.41.05-.52l.16.33.05-.18.18.21c-.03-.27.05-.28.23-.36-.16-.08-.31-.31-.21-.43.18.01.13.2.26,0,.08.14.18.3-.05.23.05.06.08.14.13.2.2.02.23-.19.28-.26-.03.02-.06.04-.1.03l-.04-.47c.1.02.13.1.16.18.02-.07-.03-.18.02-.26.13.15.29.27.27.44l.04-.38c.08.04.28.03.31.11.2-.06-.02-.57.25-.65-.02-.03-.03-.08-.02-.13.17-.14.48-.13.44-.5l.36.11c.06-.21-.47-.13-.36-.47.06-.25.29.12.42.12-.06-.2-.22-.59.14-.58,0,.1-.07.11-.09.18ZM527.34,93.93c.01.07.08.24-.06.18-.19-.21-.06-.16.06-.18ZM529.08,90.63c.04.08-.02.1-.13.09.01-.05.05-.08.13-.09ZM534.08,81.5s0,0,0,.01c-.14.02-.09.01,0-.01ZM534.3,81.4s-.04-.06-.07-.08c.04.05,0,.09-.05.12.06.03.11.04.11-.05ZM519.82,99.49l.07.02c-.02.12-.04.05-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.1,91.16s-.08-.04-.12-.06c.02.04.06.07.12.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "525.09 97.22 525.09 97.22 525.12 97.26 525.09 97.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.71,85.29c-.05.01-.1,0-.15-.01.04.04.1.05.15.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.78,80.25l-.05.15c.04-.06.09-.04.14-.04-.04-.04-.12-.07-.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.71,80.39s.03-.03.02-.07l-.08-.07c-.06.07-.03.17.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.46,80.7c.16.13.16.02.21-.08,0,0,0,.01-.01.01-.19-.21-.19-.08-.19.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.67,80.6s.03-.05.06-.07c-.07-.09-.04.01-.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.39,81.1c.07,0-.17-.19-.09-.16-.16-.21.02.44.09.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536 81.09 535.79 80.95 535.91 81.13 536 81.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.35,81.54l.16-.07s-.04-.06-.04-.09c-.07.07-.18.11-.12.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.47,81.38s.06-.07.05-.12c-.02.02-.05.07-.05.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "535.91 81.3 535.85 81.3 535.76 81.37 535.91 81.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.21,82.77l-.05.18c.05.07.12.07.14,0-.02-.07,0-.14-.08-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.06,82.83c-.07,0-.11-.03-.19-.07l.23.21-.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.8,83.25c.05.07.03.35.15.17-.05-.07,0-.24-.15-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "532.88 84.97 532.91 84.93 532.5 84.62 532.88 84.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.47,87.48c.22-.08-.22-.23,0-.28-.07-.11-.19.04-.24-.06.03.17-.07.18.23.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.24,87.14s-.01-.06-.02-.1c0,.05.01.08.02.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "513.77 104.92 513.6 104.99 513.8 105 513.77 104.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M513.93,105.36l-.29-.15.2.23s.02-.1.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M528.08,94.04l-.06-.05c-.08-.04-.1-.01-.15.03l.21.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "526.81 95.3 526.83 95.28 526.57 95.15 526.81 95.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M526.17,96.71s.04-.14.09-.18c-.04.14-.38-.04-.09.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M520.74,111.9s.09.17.11.2c.02-.07-.15-.24-.11-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "520.94 111.17 520.98 111.24 520.93 111.02 520.94 111.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M521.39,110.84c-.25-.26-.13.17-.28.12l-.06-.06.13.26c.07-.11.08-.35.21-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.09,111.29c-.1-.1-.02-.13-.08,0,.01,0,.02.01.03.02,0,0,.02-.02.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.04,111.31s.1.07,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.21,111.09v.15c.07.06.14.03.15.09.02-.1-.04-.16-.15-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.12,110.84v.07s.04.03,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.11,111.04v-.14s-.11-.13,0,.06c-.06-.09-.01,0,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.04,111.03c-.08-.04-.16-.04-.16-.19-.09.13.07.32.16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M521.2,110.52l-.11-.05.03.13c-.01-.06.15.01.08-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.71,110.96c-.04-.06-.14-.15-.2-.22v.1c.06.02.13.03.2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.51,110.73v-.16c-.08.03-.05.09,0,.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "521.89 110.51 521.94 110.81 521.91 110.49 521.89 110.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "522.98 110.77 523.04 110.95 522.96 110.68 522.98 110.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.14,110.62c.06.14.18.17.21.27.03-.06,0-.19-.03-.3,0,.08-.05.1-.18.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.28,110.41s.02.11.03.18c0-.04,0-.1-.03-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.64,110.52s.11.12.18.14l-.15-.15-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.66,110.5h0s.06-.02.07-.03c0,0-.03.01-.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.63,110.53h0s-.02-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.19,110.53c-.03-.13-.02-.29-.21-.38.06.14.16.19.21.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.44,110.33h-.1c.03.06.1.12.11.18v-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "522.44 110.25 522.44 110.33 522.48 110.33 522.44 110.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.03,110.34c-.02-.1,0-.13.04-.17-.07,0-.12,0-.16.04.03.06.09.17.13.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.84,110.4v-.02s-.02-.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.46 109.89 523.43 109.86 523.45 109.89 523.46 109.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.88,110.18c-.06-.01-.04.05-.02.11.01-.03.03-.06.05-.08-.02-.03-.03-.04-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.33,110.25s-.08-.04-.12-.06c.06.04.15.11.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.89,110.43h0s.02.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.89,110.43s-.02-.09-.03-.14c0,.03-.01.06-.01.1.01.01.03.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.79,108.69c.11.17.13.37-.06.25.01.17.44.67.71.92-.05-.07-.09-.14-.09-.28-.09-.07-.31-.09-.35-.28.04-.15.12,0,.23.05-.18-.17-.08-.38-.32-.66v.16s-.07-.14-.12-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.28,109.94l-.02.04c.05,0,.12.05.26.14,0-.11-.04-.18-.07-.24l-.16.08v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.13,110.08c-.1-.19-.08-.32-.26-.48-.08.08.04.19.04.3.11-.15.03.13.2.15,0,.05-.02.08-.04.1.04,0,.08.01.13.03h-.01s0,0,0,0h0s-.03-.03-.02-.02h0s-.03-.05-.04-.08c.07,0,.04.04.04.07l.02.03h0s.07-.2.07-.2c-.05,0-.08.03-.13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M521.79,109.72s.02.02.03.04c0-.03-.01-.05-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M521.92,109.79s.05.11,0,.11c-.07-.03-.06-.08-.1-.14.01.06.02.18.14.22v-.03c.09.02.32.18.33.21-.13-.15-.23-.25-.38-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.5,109.89l.06-.17-.17-.11.07.09c-.09.01,0,.11.04.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.54 109.97 523.66 110.16 523.54 109.85 523.54 109.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.68 109.84 523.79 110 523.76 109.87 523.68 109.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M531.23,101.78v-.07s0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M530.96,101.94l.05.09c-.02-.05-.03-.09-.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M527.49,107.16c.16.12.37.32.24.14l-.14-.17c-.01.06-.06.06-.11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.43,104.3l-.05-.04c.03.07.05.14.08.2,0-.05-.02-.1-.03-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M528.98,103.53l.15.07s-.09-.06-.15-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.56,100.67l-.07-.21c-.07.04.02.12.07.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M525.22,108.65c.09.04.15.04.19.03-.12-.06-.27-.19-.19-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.36,103.79s-.01-.09-.04-.13c0,.05,0,.09.04.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M525.53,108.59s-.03-.02-.05-.03c-.01.05-.03.1-.07.12.09.05.17.06.13-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.98,97.6s.01,0,.03.02c-.01-.03-.02-.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M540.63,98.59s-.03.04-.06.05c.02,0,.04,0,.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M524.35,109.47s0,.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.7,108.88s-.02-.05-.05-.1c.03.04.04.07.05.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M525.09,107.25h0s-.03-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M524.25,109.42s.05.02.08.02c-.02,0-.04-.02-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M524.31,109.5s-.03,0-.04,0c.02.03.03.05.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M524.39,109.43s-.04.02-.07.02c.01,0,.02.02.03.02,0,0,.02-.02.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.41,99.81s.01,0,.02.01c-.01-.1-.02-.08-.02-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "527.1 104.7 527.1 104.71 527.11 104.72 527.1 104.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M527.13,104.49c.1.26.05.25-.02.23l.39.49-.37-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M531.83,101.33l-.19-.11c-.07-.34.07-.29-.16-.47.35.58-.3.27.05.85l-.13-.08s0-.04.02-.04c-.29-.2.18.47-.01.48-.08-.01-.17-.07-.17-.16l-.02.21s-.09-.09-.06-.1l-.14.15v-.02c.02.11.06.28.07.35-.1-.05-.02-.07-.07-.14v.2c-.14-.12-.15-.32-.07-.34-.45-.52.01.19-.39-.02l.04-.13c-.26-.29-.26-.13-.49-.26.09.09.53.38.52.59-.06-.02-.11-.02-.09.13-.13-.2-.15-.12-.21-.06l-.17-.27c-.02.12.07.26.11.41-.1.03-.25-.17-.38-.33-.16.04.3.28.18.43-.17-.03-.18.12-.2.37-.14-.04-.09-.17-.17-.23l.07.26s-.06-.06-.08-.1c0,.12.17.27.13.4.17.31-.46-.31-.35.09-.08-.06-.09-.17-.17-.27,0,.32-.02.24.05.62l-.22-.11c.21.15.27.45.31.7.09.08.17.15.21.18l-.04.23s-.09-.13-.14-.26l.02.08c-.11-.07-.19-.24-.25-.41.05.04.1.09.16.13-.07-.18-.16-.38-.27-.54.01.04.01.07,0,.1-.02-.05-.04-.09-.06-.12-.02-.03,0,.04.02.13l-.23-.28.07.12-.3-.07c.07.38.25.9.13,1.15-.09-.25-.23-.36-.39-.62.24.24.08-.22.22-.23-.07,0-.14-.12-.16-.18l-.02.37c-.14-.21-.14-.13-.25-.19.31.39.05.37.05.55-.1-.14-.17-.29-.06-.32-.31-.25.19.58-.08.38.02-.02.05,0,0-.08.03.16-.16.15-.22,0l.02-.02c-.18.05-.46.3-.24.67-.03-.04-.27-.44-.3-.52l.53,1.37c-.18-.32-.76-.98-.75-1.23-.06-.02-.14-.04-.15.12.05.03.36.4.34.45-.32-.28-.18-.14-.49-.35.08.04.36.54.29.57-.04-.08-.32-.47-.33-.53l.17.56c-.02-.11-.26-.4-.38-.51.08.08-.13.08-.14.15l.13.07c-.21.04.28.76.11.85-.05-.11-.35-.62-.48-.63.12.26.61,1.26.6,1.54l-.12-.12v.23c-.18-.4-.5-1.29-.6-1.65-.13-.07-.13-.15-.21-.08-.12-.11-.08-.23-.06-.25l-.27.06c.2.27.03.39.2.61l.03-.44c.2.27.4.88.22.93-.11-.08-.31-.51-.38-.6.05.11-.02.28-.08.22l-.04-.19c-.15-.05.12.46-.16.26-.05,0-.35-.29-.24-.12.27.28.96,1.25,1.08,1.51-.03-.01-.39-.18-.53-.31-.23-.21-.32-.65-.52-.83.05.08.08.19.09.23-.08-.04-.15-.24-.2-.16.18.29-.18.09.13.26-.02.13-.12,0-.2.07.15.16.35.67.32.8-.04-.07-.13-.16-.16-.19-.17.08-.35.01-.49.11-.06-.06-.19-.09-.24-.23.01.06.06.17.02.21-.26-.18.07-.11-.2-.35.11.17.04.31.05.45.19.24.18-.06.17-.2.24.35.38.79.34,1.05-.06.17-.21-.19-.2-.12-.27.1.23.74-.13.62-.23-.17-.31-.44-.44-.58.04-.15.25.03.31-.02l-.16-.05c-.02-.09,0-.2.09-.16-.2-.15-.41.23-.71.17.02.1.02.21.11.28l.03-.07c.18.14.07.32.2.35.01.18.07.43-.1.4l-.2-.24c.05.07.17.1.15,0,.04.14-.4-.23-.21.14l.2.12c.02.18.11.51-.03.49.22.22,0-.04.27.2-.31-.32.24-.15-.11-.46.3.29.22.06.51.28-.06-.08-.14-.14-.04-.15-.01-.03-.03-.06-.03-.08h0s-.01,0-.01,0c0-.01,0-.02,0,0-.04-.02-.09-.06-.13-.1-.1-.22.03-.3,0-.42.07,0,.05.11.13.18l-.04-.19c.14.18.34.22.3.4l.1-.06c.13.06.24.05.23-.06.07,0-.03-.28.03-.11l.07-.22.03.05c.17-.08.1-.52.5-.31.02-.08.03-.18.15-.18l.13.15c.03-.1.31.02.22-.16.37.38.38-.12.55-.13l-.14-.21c.09-.04.12-.15.16-.31l-.13-.18c-.02-.21.31-.02.43-.13.04.08,0,.08-.06.06.45.31.13-.53.48-.33,0-.09.03-.09.09-.06,0,0,0,0,0,.02,0,0,.01,0,.02,0,.04.02.08.04.12.06-.05-.03-.09-.06-.11-.07.03-.02.05-.07.06-.15l.15.19s0,0,0-.01c.09.05-.03-.12-.15-.25,0-.05,0-.1-.03-.16.25.3.04-.18.31.13-.09-.19.12-.27-.09-.64.03.04.06.06.04.08.07,0,.15.02.12-.11l.19.24-.13-.41c.17.11.25.19.32.42-.05-.4.04-.19-.03-.58l.1.17s-.03-.3.08-.19c.31.25.53-.29.98-.17-.37-.45.26.14.03-.25.09.1.17.15.19.27.06-.2.32.05.2-.33.09.11.08.19.14.25,0-.03-.02-.13.04-.07.06.06.04.11.06.17.12-.11-.1-.47-.31-.81.17.11.19.07.1-.18.1.09.21.18.15.28.06-.02.39-.03.22-.3.06.06.08-.02.07-.06.12-.05.14-.04.23-.13l-.06-.02c-.17-.35.04-.13.1-.22l.02.03c.35.11.01-.17.38-.02l-.14-.19c-.26-.44.34.15.34-.09l-.11-.09c-.03-.19.55.48.65.49.04.03.02.07.02.11.32.15-.15-.28-.07-.42.11.13.21.38.3.36.11.09-.07-.61.22-.41-.09-.09-.19-.19-.19-.31.06-.09.5.27.35-.13.03.02.05.05.07.08,0-.13.12-.28.04-.5.5.66.19-.6.6.05l.18-.16.04.07c.16-.04.1-.22.05-.4.06.03.07.1.09.13.27.01.27-.03.23-.45l.15.2c-.03-.15.48.16.51-.2.01.02.03.07.04.11.05-.38.86.28.46-.54l.02-.27c-.21.05-.18-.35-.33-.43.04-.09.32.12.26.21l-.04-.03c.22.42.31,0,.47.28.34-.24.81-.22,1.15-.4l-.23-.29.13-.05c.07.05.19.22.1.26.15.15.05-.23,0-.3.24.03.16.4.21.38l.05-.06-.04-.03c-.02-.16-.1-.3,0-.34.1.02.15.17.18.17.01.02.03.03.04-.01l.16-.06-.21-.21c0-.16.14-.07-.09-.31.36.37.63-.17.78-.07-.02-.23.07-.28.2-.33-.06-.04-.24-.3-.13-.33.31.6.32.15.65.51-.23-.23.23-.23-.11-.56.11,0,.13.21.27.31.06-.34.5-.1.69-.31-.04-.08-.15-.17-.16-.31l.35.31c.02-.06-.21-.46.02-.25-.05-.06-.12-.14-.11-.19.67.1.76-.85,1.64-.42-.15-.11-.11-.15-.07-.18-.05-.02-.11-.19-.17-.29l.36.17c-.13-.31.2-.14.06-.43l-.03.09c-.1-.37-.53-.65-.75-1.08.12.42-.56-.4-.41.21-.08-.07-.05-.15-.12-.24.06.2.04.26-.09.23l-.02-.05c-.22.18-.42.07-.77.11l.14.19c-.07,0-.12-.05-.18-.09.11.35.17-.08.31.3-.32-.37-.42.24-.75-.21-.09.05.17.22.07.27l-.1-.11.07.18c-.07,0-.2-.13-.26-.24.02,0,.02-.05.03-.07-.17-.11-.19.18-.24.15l.13.03c-.18.26-.58.27-.66.67l.07.09c-.08.29-.21-.02-.36.18v-.03c.01.12-.01.2-.07.22-.02-.14-.22-.16-.23-.33-.08.31,0,.21.08.64l-.12-.14c.04.17.08.25,0,.35,0-.19-.21-.2-.23-.44-.42-.22-.1.54-.5.09.17.5.33.14.33.26.13.12.12.38.03.37-.07.03-.45-.49-.61-.39.02,0,0-.04.02-.05-.13-.07-.03.23-.22.09.12.29-.11.04.08.39l.1-.17c-.03.14.13.59-.13.48-.03-.08-.04-.19-.04-.26-.1-.07-.04.11-.15.04-.19-.35.14-.19.08-.5-.13-.12-.03.35-.2-.04.22.51-.2.04-.1.46l-.12-.21s.02.16-.01.18l-.1-.3c.05.28-.3-.09-.31.09.18-.12.19.22.36.32-.06.41-.45-.45-.65-.2.02-.05.2.04.21.17-.07-.01-.18-.05-.28-.14-.14.15.15.19.16.36-.21-.21-.02.15-.05.27l-.13-.21c-.27-.01.21.46-.06.41l-.1-.33-.04.13-.13-.25c0,.23-.05.21-.18.2.11.13.22.38.14.44-.13-.09-.09-.21-.19-.11-.05-.14-.12-.32.05-.17-.03-.07-.06-.14-.09-.21-.15-.1-.18.06-.22.09.02,0,.05,0,.08.02v.39c-.07-.06-.09-.14-.1-.21-.02.04.01.15-.03.2-.09-.17-.2-.34-.18-.47l-.05.29c-.06-.07-.21-.15-.23-.22-.15-.04-.02.46-.22.41.01.04.02.08,0,.11-.14.03-.37-.11-.36.2l-.26-.25c-.06.13.34.31.23.53-.06.17-.21-.22-.3-.28.03.19.12.56-.15.39,0-.08.06-.05.08-.1ZM530.62,102.28c0-.06-.04-.22.06-.11.12.25.03.15-.06.11ZM528.99,104.04c-.03-.08.02-.06.11,0-.01.03-.04.04-.11,0ZM524.6,109.06s0,0,0-.01c.11.04.07.02,0,.01ZM524.43,109.05s.03.06.05.09c-.03-.06,0-.08.03-.08-.04-.05-.08-.07-.09,0ZM536.62,100.97l-.06-.04c.02-.09.03-.03.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.03,103.62s.06.07.08.1c-.01-.04-.04-.08-.08-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "532.57 100.71 532.58 100.71 532.56 100.67 532.57 100.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M525,106.16s.08.04.12.07c-.03-.05-.07-.08-.12-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M524.08,109.8l.03-.1s-.07,0-.11-.02c.03.04.09.1.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.59,109.02s-.02.02-.01.05l.07.09s.02-.13-.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.55,109.19c-.12-.16-.13-.07-.16,0h0c.15.24.15.12.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.38,109.2s-.02.03-.04.04c.06.1.03,0,.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M524.37,109.26c-.05-.03.13.22.07.16.12.23-.02-.37-.07-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.12 108.68 523.28 108.87 523.2 108.68 523.12 108.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.62,108.55h-.12s.03.06.03.08c.05-.03.14-.03.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.53,108.63s-.05.04-.04.08c.01-.01.04-.04.04-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.19 108.54 523.24 108.56 523.31 108.54 523.19 108.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M524.51,107.98l.05-.12c-.04-.08-.09-.1-.11-.05.01.06,0,.11.06.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.85,107.6c.05.03.09.07.15.13l-.18-.26.03.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M524.07,107.37c-.04-.08-.01-.29-.11-.2.04.08,0,.2.11.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "525.62 106.77 525.6 106.79 525.89 107.2 525.62 106.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M526.11,104.96c-.17-.03.15.28-.03.22.04.12.15.05.18.15,0-.15.07-.11-.15-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M526.26,105.32s0,.05.01.09c0-.04,0-.06-.01-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "541.03 98.68 541.15 98.73 541.02 98.61 541.03 98.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M540.98,98.27l.18.27-.1-.28s-.03.06-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M530.08,101.86l.04.07c.06.06.08.06.12.05l-.15-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "531.15 101.46 531.13 101.47 531.32 101.69 531.15 101.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M531.74,100.64s-.04.09-.08.1c.04-.09.29.2.08-.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M538.16,109.56s-.04-.19-.05-.22c-.02.06.07.28.05.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "537.94 110.12 537.92 110.04 537.92 110.26 537.94 110.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.59,110.22c.14.33.11-.09.2.01l.03.07-.06-.28c-.06.07-.1.28-.18.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.19,109.54c.05.13,0,.13.05.03,0-.01-.01-.02-.02-.03,0,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.23,109.54s-.06-.1,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.08,109.66v-.13c-.02-.08-.07-.08-.07-.14-.03.08,0,.15.07.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.11,109.93v-.06s-.02-.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.14,109.75l-.02.12c.02.05.06.16.01-.05.03.1,0,0,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.19,109.79c.05.07.1.1.09.23.08-.07-.01-.31-.09-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.68,110.58l.07.09v-.12c0,.06-.1-.07-.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.74,109.58c.02.07.07.19.11.28v-.09s-.07-.08-.11-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.84,109.86v.14s.03-.06,0-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "537.22 110.31 537.23 110.02 537.21 110.32 537.22 110.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.53 109.63 536.51 109.45 536.54 109.72 536.53 109.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.41,109.7c-.02-.15-.1-.23-.1-.32-.03.04-.02.16-.02.28.01-.07.05-.06.12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.29,109.83s0-.1,0-.17c0,.04,0,.09,0,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.73,109.99s-.06-.16-.1-.2l.08.2s.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.71,110h0s-.04,0-.05,0c0,0,.02,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.73,109.99s0,0,0,0c0,.02.01.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.03,110.17c0,.12-.02.27.09.42-.02-.15-.09-.24-.09-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.84,110.24l.07.03c-.02-.05-.05-.13-.05-.19l-.02.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.83 110.31 536.84 110.24 536.81 110.23 536.83 110.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.44,109.99c0,.1-.02.11-.05.13.04.03.08.04.11.03-.02-.07-.04-.19-.07-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.58,110.01s0,0,0,.01c0,.02.01.02,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.11,110.21s.01.02.02.04c0-.01,0-.02,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.53,110.2s.03-.02.03-.09c-.01.03-.03.04-.05.05,0,.03.01.05.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.24,109.95s.05.07.08.1c-.03-.06-.09-.15-.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.55,109.97s0,0,0-.01c-.02-.04-.01-.02,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.55,109.97s0,.09,0,.13c0-.02.02-.05.02-.08,0-.01-.02-.03-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.42,111.55c-.05-.19-.04-.38.07-.2.01-.16-.21-.77-.37-1.1.02.08.05.16.03.29.05.1.2.21.2.39-.04.12-.08-.05-.15-.14.1.23.01.37.13.71l.03-.14c.02.05.02.15.05.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.23,110.24l.02-.03s-.08-.1-.16-.23c0,.1,0,.18.02.24h.12s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.35,110.18c.05.21.02.32.12.53.06-.03,0-.19,0-.29-.09.08,0-.12-.12-.22.01-.04.03-.06.04-.07-.03-.02-.05-.04-.08-.08,0,0,0,0,0,.01h0s0,0,0,0c.01.02.02.04,0,.03,0,0,0,0,0,0,0,.03.01.05.02.08-.04-.03-.02-.05-.02-.08,0-.01,0-.02,0-.03,0,0,0,0,0,0l-.07.15s.06,0,.1-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.2,111.05s-.01-.03-.02-.05c0,.03,0,.05.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.12,110.94s-.02-.12.01-.1c.04.06.03.1.05.17,0-.06,0-.16-.07-.25v.03c-.06-.06-.2-.3-.2-.33.07.18.12.31.2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.75,110.61l-.06.13.1.17-.03-.11c.06.03.01-.1,0-.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.07 110.11 536.01 109.89 536.05 110.22 536.07 110.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "535.96 110.18 535.9 109.98 535.91 110.11 535.96 110.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M530.15,114.51v.06s0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M530.34,114.46l-.02-.09c0,.05.01.09.02.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.13,111.06c-.09-.17-.22-.43-.15-.21l.07.2s.04-.03.07.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M531.56,112.89s.02.04.03.06c-.01-.07-.02-.14-.03-.21,0,.05,0,.1,0,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M531.79,113.76l-.09-.12s.06.08.09.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.18,115.04l.03.22s0-.12-.03-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.8,110.61c-.06-.07-.09-.1-.12-.1.08.11.16.28.12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.56,112.28s0,.09.02.13c0-.04,0-.08-.02-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.58,110.54s.02.03.03.04c.01-.04.03-.08.06-.07-.06-.08-.11-.12-.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M525.39,116.01s-.01-.01-.02-.02c0,.03.01.03.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.66,114.24s.02-.02.04-.03c-.01-.01-.03,0-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.47,110.23s0-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.83,111.01s0,.06.02.1c-.01-.05-.02-.08-.02-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.73,111.91s0,0,0,0c.02.04.02.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.53,110.31s-.03-.04-.05-.05c.01.01.03.03.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.5,110.21s.02.01.03.01c0-.04-.02-.06-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.43,110.25s.03,0,.05,0c0-.01-.01-.02-.02-.03,0,0-.02.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M527.22,114.84s0,0-.01-.02c0,.09,0,.08.01.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "533.14 113.41 533.14 113.4 533.14 113.39 533.14 113.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.1,113.59c-.04-.27-.01-.24.03-.2l-.21-.59.18.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.72,114.7l.12.17c.02.33-.07.24.07.48-.19-.65.22-.14.03-.79l.08.12s0,.04-.02.03c.17.29-.08-.49.05-.43.05.04.1.13.1.21l.03-.19s.06.12.03.11l.11-.09v.02c0-.11-.02-.28-.02-.35.06.08,0,.07.04.15l.02-.18c.08.16.07.34.02.33.26.63,0-.18.26.16l-.04.1c.15.36.16.21.3.42-.05-.11-.32-.54-.3-.72.04.04.07.06.07-.08.07.23.09.16.14.13l.09.31c.02-.1-.03-.26-.04-.41.07.01.15.25.23.44.11.02-.18-.36-.09-.45.11.09.13-.05.16-.26.09.09.05.19.09.27l-.03-.26s.03.08.04.12c.01-.11-.09-.31-.05-.41-.09-.34.28.45.24.05.05.08.05.19.09.31.03-.28.04-.21.02-.57l.14.18c-.12-.21-.14-.51-.14-.75-.05-.1-.1-.2-.12-.24l.05-.19s.05.15.07.29c0-.03,0-.05,0-.08.07.1.1.28.13.46-.03-.06-.06-.12-.09-.18.03.19.07.41.13.58,0-.04,0-.07,0-.09,0,.05.02.1.03.13.01.03,0-.04,0-.12l.13.33-.04-.14.19.17c-.01-.37-.09-.9.02-1.09.04.26.12.41.2.71-.14-.3-.07.17-.17.13.05.02.08.17.09.22l.05-.33c.07.24.08.17.15.26-.17-.47,0-.35.01-.51.05.16.09.33.01.31.18.34-.08-.59.09-.31-.02,0-.03-.01-.01.07,0-.15.12-.07.14.08h-.02c.13.03.33-.09.23-.5.02.05.13.5.15.58l-.22-1.43c.09.35.41,1.17.38,1.39.04.04.09.09.11-.05-.03-.04-.2-.49-.18-.53.18.37.11.19.29.5-.05-.07-.19-.62-.14-.62.02.08.17.54.17.6l-.06-.57c0,.1.13.46.2.6-.04-.1.09-.02.1-.08l-.08-.11c.14.05-.11-.79.01-.8.02.12.17.69.25.74-.06-.28-.28-1.36-.24-1.61l.07.15.02-.2c.08.43.2,1.34.23,1.71.08.11.07.18.13.15.07.14.03.23.02.25l.18.05c-.1-.32.02-.36-.07-.62l-.07.38c-.1-.32-.18-.94-.05-.92.07.12.15.58.19.69-.02-.12.04-.24.07-.17v.19c.1.1-.02-.46.14-.17.03.01.2.39.15.2-.15-.35-.51-1.49-.56-1.77.02.02.24.31.32.48.13.28.15.7.26.94-.03-.09-.04-.2-.04-.24.05.07.07.28.12.22-.09-.33.12,0-.06-.28.03-.11.08.05.14.01-.08-.2-.16-.74-.13-.85.02.08.07.19.09.24.12,0,.23.12.34.09.03.08.11.16.14.3,0-.06-.02-.18,0-.19.15.26-.06.07.09.39-.05-.19,0-.29.02-.42-.1-.29-.13-.02-.14.11-.12-.4-.17-.85-.11-1.07.06-.13.12.25.12.19.19.02-.07-.75.16-.5.13.24.16.51.23.69-.04.12-.16-.13-.21-.1l.1.1c0,.09-.03.17-.07.11.12.22.3-.04.49.13,0-.09,0-.19-.04-.29l-.03.05c-.1-.2-.01-.31-.09-.39.01-.16,0-.41.11-.32l.1.29c-.03-.09-.1-.16-.1-.06,0-.14.24.36.16-.03l-.12-.19c.01-.16-.02-.5.08-.42-.12-.28,0,.04-.16-.29.17.41-.18.04.02.46-.17-.38-.14-.14-.3-.46.03.1.08.18,0,.15,0,.03.01.07.01.09,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.02,0,0,.03.04.05.09.07.14.04.23-.05.25-.05.38-.05-.04-.02-.12-.07-.21v.19c-.06-.21-.19-.33-.15-.48h-.07c-.08-.1-.15-.13-.16-.02-.05-.04-.01.26-.04.09l-.07.17-.02-.05c-.12,0-.12.43-.37.08-.02.07-.04.14-.12.1l-.07-.18c-.03.08-.2-.14-.16.06-.2-.48-.27-.04-.38-.1l.07.24c-.06,0-.1.09-.14.21l.07.21c0,.2-.21-.1-.3-.05-.02-.08.01-.07.05-.03-.27-.45-.14.43-.36.11,0,.09-.03.07-.07.02,0,0,0,0,0-.01,0,0,0,0-.01,0-.02-.03-.05-.07-.07-.1.03.05.05.09.07.11-.02.01-.04.05-.06.11l-.08-.23s0,0,0,0c-.06-.08,0,.12.08.29,0,.04,0,.09,0,.15-.14-.36-.04.15-.2-.24.04.2-.11.19,0,.6-.02-.05-.03-.08-.02-.08-.05-.04-.1-.07-.09.05l-.1-.29.05.42c-.1-.16-.15-.26-.17-.5,0,.38-.05.16-.04.53l-.05-.19s0,.29-.07.14c-.18-.34-.38.06-.67-.22.21.55-.16-.22-.04.21-.05-.13-.1-.19-.1-.32-.06.16-.21-.17-.16.22-.05-.13-.04-.2-.07-.27,0,.03,0,.12-.03.05-.03-.08-.02-.12-.02-.18-.09.05.02.46.13.85-.1-.17-.12-.13-.08.13-.06-.12-.12-.24-.08-.3-.04,0-.27-.12-.18.19-.03-.07-.06,0-.05.03-.08,0-.1-.02-.17.03l.04.04c.08.38-.04.1-.09.16v-.04c-.23-.22-.03.15-.26-.12l.08.23c.14.5-.21-.25-.23-.04l.07.12c0,.18-.33-.63-.39-.68-.02-.04,0-.07,0-.11-.2-.26.08.31.01.4-.07-.16-.1-.42-.17-.43-.07-.12,0,.58-.18.29.06.12.11.24.1.35-.05.06-.31-.42-.25-.01-.02-.03-.03-.06-.04-.09-.02.12-.1.21-.06.44-.28-.78-.17.47-.4-.26l-.13.08-.02-.08c-.11-.02-.09.17-.07.35-.04-.04-.04-.12-.05-.15-.18-.11-.18-.07-.19.33l-.08-.23c.01.15-.31-.31-.36,0,0-.03-.02-.07-.02-.11-.06.32-.56-.55-.35.33l-.03.24c.15.03.09.38.19.51-.03.07-.21-.22-.16-.28l.02.04c-.11-.46-.21-.11-.3-.42-.24.1-.56-.08-.8-.03l.13.34h-.09c-.05-.07-.11-.26-.05-.26-.09-.19-.05.2-.03.27-.16-.11-.08-.42-.12-.42l-.04.04.02.04c0,.15.05.31-.03.31-.07-.06-.09-.21-.11-.22,0-.02-.02-.03-.03,0h-.11s.12.27.12.27c0,.15-.1.02.04.31-.22-.46-.44-.06-.52-.19,0,.22-.07.24-.15.24.04.05.14.36.06.34-.17-.65-.21-.24-.4-.69.14.29-.17.13.04.54-.07-.03-.08-.24-.16-.38-.06.29-.34-.07-.48.06.02.08.09.21.09.34l-.22-.39c-.02.05.12.49-.03.22.03.07.07.17.06.21-.45-.31-.56.54-1.12-.13.09.15.07.17.04.19.03.03.06.21.1.32l-.23-.27c.07.32-.14.07-.06.37l.03-.07c.05.37.32.77.45,1.23-.06-.43.35.55.28-.06.05.09.02.15.07.26-.03-.2-.01-.26.07-.19v.05c.16-.1.29.07.52.14l-.08-.22c.05.02.08.09.12.14-.06-.36-.12.02-.19-.38.19.44.29-.08.49.43.06-.02-.1-.26-.03-.27l.06.14-.04-.19c.05.02.13.19.16.31-.01-.01-.02.04-.03.06.1.15.13-.1.17-.05l-.09-.07c.13-.19.4-.06.48-.4l-.05-.1c.07-.24.14.09.25-.05v.03c0-.11.02-.18.06-.18,0,.14.14.22.14.38.07-.25.02-.19-.01-.61l.07.17c-.02-.17-.04-.26.01-.32-.01.17.13.26.12.48.26.34.1-.46.34.09-.08-.51-.21-.23-.2-.35-.08-.15-.06-.38,0-.35.05,0,.27.6.38.56-.01,0,0,.04-.01.04.08.11.03-.2.15,0-.06-.31.08,0-.03-.39l-.08.12c.03-.12-.05-.58.12-.39.02.08.02.19.01.25.06.1.03-.09.1.01.11.38-.11.12-.08.43.08.15.04-.31.13.11-.11-.54.14.03.09-.39l.06.23s0-.15.02-.16l.05.31c-.01-.27.19.18.21.03-.13.05-.11-.27-.22-.41.07-.35.27.57.42.4-.01.04-.13-.11-.13-.23.05.04.12.11.18.22.1-.08-.09-.23-.08-.38.12.26.02-.13.05-.23l.07.23c.18.11-.11-.49.07-.35l.05.34.04-.1.07.27c0-.22.05-.17.14-.12-.06-.16-.12-.42-.06-.45.08.12.04.23.12.17.02.15.06.34-.04.14.02.08.03.15.04.23.09.14.12,0,.15,0-.01,0-.03-.01-.05-.04l.03-.36c.05.08.05.16.06.23.02-.03,0-.14.03-.17.05.19.11.38.08.49l.05-.24c.03.08.13.21.13.28.1.09.05-.41.18-.29,0-.04,0-.08,0-.11.09.02.24.23.25-.06l.16.32c.05-.1-.2-.4-.12-.57.06-.13.12.28.18.36,0-.18-.04-.55.13-.3,0,.07-.04.03-.06.06ZM530.59,114.27c0,.05,0,.21-.05.08-.06-.27,0-.15.05-.08ZM531.83,113.29c.01.08-.02.05-.07-.03.01-.02.03-.02.07.03ZM535.25,110.5s0,0,0,.01c-.07-.08-.04-.05,0-.01ZM535.37,110.57s-.01-.07-.02-.1c.01.06,0,.07-.03.06.02.06.05.1.06.04ZM526.49,113.37l.03.06c-.02.08-.02.01-.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M531.77,113.66s-.03-.08-.05-.12c0,.04.02.09.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.18,115s0,0,0,0c0,.01,0,.03,0,.04v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.68,112.92s-.05-.07-.07-.11c.02.06.04.1.07.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.69,110.05l-.03.08s.05.03.07.06c-.02-.05-.05-.13-.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.58,111.33s.02,0,.01-.04l-.03-.11s-.03.11.02.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.97,110.8c.06.19.08.12.1.07,0,0,0,0,0,0-.07-.27-.08-.17-.1-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.08,110.86s.02-.02.03-.02c-.03-.11-.02-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.43,110.41s-.06-.25-.03-.18c-.06-.25-.03.33.03.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.19 111.43 536.11 111.19 536.15 111.39 536.19 111.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.85,111.34l.08.05s-.01-.07,0-.09c-.04,0-.09-.03-.07.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.92,111.3s.04-.01.04-.05c0,0-.03.02-.04.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.13 111.52 536.1 111.48 536.05 111.47 536.13 111.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.19,111.49l-.04.09c.02.08.05.13.07.09,0-.06.01-.1-.02-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.59,112.09s-.05-.1-.08-.17l.09.3v-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.42,112.21c.02.08-.02.27.05.22-.02-.08.03-.17-.05-.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "534.33 112.13 534.34 112.13 534.19 111.64 534.33 112.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.82,113.56c.11.09-.07-.31.04-.18-.02-.12-.09-.1-.1-.21,0,.14-.05.07.06.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.76,113.17s0-.05,0-.08c0,.03,0,.06,0,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.4 114.04 523.32 113.95 523.4 114.1 523.4 114.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.41,114.43l-.11-.31.06.29s.02-.05.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M530.92,114.86l-.02-.08c-.03-.08-.05-.08-.07-.09l.09.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "530.18 114.83 530.19 114.83 530.09 114.56 530.18 114.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.73,115.36s.03-.07.06-.06c-.03.07-.17-.29-.06.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.18,101.97s.16.11.19.13c-.02-.07-.24-.16-.19-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "510.01 101.29 510.08 101.34 509.94 101.17 510.01 101.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.25,100.87c-.33-.13-.03.18-.19.19l-.08-.03.23.17c.01-.11-.09-.32.03-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.05,101.03c-.13-.05-.08-.11-.07.03.02,0,.02,0,.04,0,0-.01.01-.02.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.02,101.06s.12.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.06,100.82l.08.12c.08.03.12-.02.16.03-.03-.09-.1-.12-.24-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.86,100.64l.03.06s.05,0-.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.95,100.81l-.06-.12c-.06-.02-.16-.07.02.05-.09-.06,0,0,.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.89,100.82c-.09,0-.15.01-.23-.1-.02.13.21.24.23.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M509.94,100.67h-.12s.08.09.08.09c-.04-.05.13-.04.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.42,100.55c-.06-.04-.19-.08-.28-.12l.05.08c.06,0,.12-.02.22.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.14,100.43l-.08-.13c-.04.05,0,.09.08.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "510.52 100.44 510.7 100.68 510.53 100.42 510.52 100.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "511.56 100.3 511.7 100.42 511.5 100.23 511.56 100.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.63,100.13c.11.1.24.08.3.15,0-.06-.09-.15-.17-.24.04.07,0,.1-.13.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.65,99.9s.07.08.11.14c-.02-.04-.05-.08-.11-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.16,100.21s.15.07.22.05l-.2-.08-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.17,100.18h0s.03-.04.04-.05c0,0-.02.02-.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.15,100.21h0s-.03-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.78,100.36c-.08-.1-.15-.24-.35-.25.11.1.23.1.35.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.9,100.12l-.08.04c.05.03.13.05.17.1l-.09-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "510.86 100.05 510.9 100.12 510.93 100.1 510.86 100.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.41,99.92c-.07-.07-.05-.11-.05-.15-.06.02-.1.05-.12.09.06.04.15.11.17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.27,100.04h0s-.02-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "511.55 99.41 511.52 99.39 511.55 99.41 511.55 99.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.2,99.84c-.05,0-.02.05.03.1,0-.03,0-.06,0-.09-.03-.02-.04-.03-.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.61,99.75s-.09,0-.13,0c.07.02.18.04.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.32,100.04h0s.03.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.32,100.04s-.06-.07-.09-.1c0,.03.02.05.04.08.01,0,.04.01.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.41,98.65c.17.1.29.26.07.23.1.14.69.4,1.04.52-.07-.04-.15-.08-.21-.2-.11-.03-.3.03-.43-.11-.04-.14.1-.04.22-.03-.24-.08-.26-.28-.59-.44l.07.14c-.05-.03-.11-.1-.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.43,99.51v.04c.05-.02.14,0,.29.03-.06-.09-.12-.14-.18-.17l-.1.12-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.37,99.68c-.18-.12-.22-.24-.45-.31-.03.09.13.14.18.24.03-.16.08.09.24.06.02.04.02.07.01.1.04-.01.08-.02.12-.02h-.01s0,0,0,0h0s-.04-.02-.02-.01h0s-.05-.04-.07-.05c.06-.02.05.02.07.04l.03.02h0s-.03-.19-.03-.19c-.04.01-.05.05-.07.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.06,99.82s.03.01.05.02c-.02-.02-.03-.03-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.2,99.83s.09.07.06.09c-.07,0-.09-.05-.15-.08.04.05.1.14.22.13l-.02-.02c.09-.02.37.04.39.07-.18-.08-.31-.13-.49-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.74,99.73l-.03-.16-.19-.03.1.05c-.07.04.06.09.13.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "511.66 99.45 511.85 99.57 511.6 99.35 511.66 99.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "511.71 99.29 511.88 99.39 511.8 99.29 511.71 99.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M513.59,90.03l-.04-.06s.02.04.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M513.47,90.26l.09.05s-.08-.05-.09-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M513.54,95.73c.19.04.47.11.27.02l-.2-.08c.02.05-.02.07-.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M513.58,92.71h-.07c.06.03.12.07.17.11-.03-.03-.07-.07-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M512.79,92.28h.16c-.05,0-.1,0-.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M513.97,88.63l-.18-.13c-.03.06.09.08.18.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M512.42,97.78c.1,0,.15-.02.17-.04-.14,0-.32-.06-.17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M515.64,91.09s-.06-.06-.11-.08c.02.04.06.07.11.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M512.65,97.62s-.04,0-.06,0c.02.05.03.09,0,.12.1,0,.17,0,.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M516.19,83.93s.02,0,.03,0c-.03-.01-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M518.79,83.34s0,.04,0,.06c.02,0,.02-.02,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M512.1,98.76s.02.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.27,98.5s-.04-.04-.09-.06c.04.03.07.05.09.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.61,96.69h0s-.03-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.99,98.75s.06,0,.08,0c-.02,0-.04,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M512.08,98.8s-.02.01-.03.02c.03.02.05.03.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M512.11,98.71s-.02.03-.05.04c.02,0,.03,0,.03,0,0-.01,0-.03.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M515.65,86.73s.01,0,.02,0c-.07-.07-.06-.05-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "511.92 93.92 511.93 93.93 511.94 93.93 511.92 93.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.83,93.74c.22.17.18.18.11.19l.58.24-.69-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M513.8,89.44h-.21c-.25-.23-.12-.25-.4-.29.61.29-.08.33.54.62h-.15s-.02-.04,0-.05c-.34-.04.41.28.26.37-.07.02-.17.01-.23-.05l.11.17s-.13-.03-.1-.06l-.02.18h-.02c.09.06.21.18.27.23-.11,0-.06-.05-.14-.08l.11.15c-.18-.04-.3-.18-.25-.23-.65-.21.12.14-.32.14l-.04-.12c-.37-.11-.28,0-.54,0,.12.03.63.08.74.24-.06,0-.1.03,0,.13-.22-.1-.19-.03-.2.04l-.29-.14c.05.1.2.17.32.27-.06.06-.29-.03-.49-.1-.1.09.4.09.39.25-.16.04-.07.17.05.37-.13.02-.17-.1-.27-.11l.2.17s-.08-.03-.12-.05c.07.09.29.14.33.26.31.17-.54-.06-.23.21-.09-.01-.17-.1-.29-.14.17.25.12.2.38.46h-.23c.25.04.46.25.64.43.12.02.22.04.27.06l.09.2c-.05,0-.15-.07-.26-.15l.06.06c-.13,0-.28-.11-.43-.22.06.01.13.03.2.04-.16-.12-.34-.24-.51-.31.03.02.05.05.06.08-.04-.03-.08-.06-.11-.07-.03-.01.03.03.09.09l-.33-.13.12.07-.28.06c.27.27.69.6.74.85-.21-.16-.38-.2-.66-.34.32.09-.06-.2.05-.27-.05.03-.18-.04-.22-.08l.19.3c-.23-.11-.19-.05-.3-.05.47.19.24.27.34.41-.15-.07-.3-.16-.22-.23-.38-.07.47.38.14.33,0-.02.03-.02-.04-.07.11.11-.05.18-.17.09v-.02c-.11.11-.2.41.17.62-.05-.03-.45-.25-.52-.29l1.16.88c-.32-.18-1.14-.49-1.26-.69-.06,0-.14.02-.05.15.06,0,.5.18.51.23-.41-.1-.22-.04-.58-.09.09,0,.58.29.54.34-.07-.05-.51-.25-.55-.29l.44.38c-.07-.08-.42-.22-.58-.26.11.04-.07.11-.03.17h.14c-.15.11.63.5.53.64-.09-.07-.62-.37-.72-.32.24.16,1.16.77,1.29,1.01l-.16-.05.12.18c-.35-.26-1.08-.84-1.35-1.1-.14,0-.18-.07-.21.02-.15-.04-.19-.15-.18-.18l-.18.15c.3.14.23.3.48.42l-.21-.36c.3.14.79.55.67.66-.14-.03-.52-.3-.62-.35.09.07.13.23.05.2l-.13-.14c-.15.02.33.33,0,.27-.04.02-.43-.1-.26,0,.37.12,1.43.66,1.67.82-.03,0-.41,0-.6-.05-.29-.09-.6-.41-.85-.48.08.04.17.12.19.15-.09,0-.25-.14-.25-.05.3.17-.1.13.24.17.05.11-.1.04-.13.13.21.08.63.42.68.53-.07-.04-.18-.08-.23-.1-.1.13-.28.13-.35.26-.08-.03-.2,0-.32-.1.04.05.14.12.12.16-.3-.06,0-.11-.34-.22.17.1.19.23.27.35.28.12.12-.11.04-.22.37.19.71.5.81.73.03.16-.27-.08-.22-.03-.17.17.56.52.2.55-.27-.06-.47-.25-.65-.32-.04-.14.22-.06.25-.12l-.15.02c-.06-.07-.09-.16,0-.16-.24-.06-.22.33-.51.38.06.07.12.16.23.19v-.07c.21.06.21.24.33.22.1.14.27.33.11.37l-.28-.13c.08.04.19.02.13-.05.1.1-.44-.05-.11.18l.22.03c.1.14.34.38.21.42.29.1-.02-.04.32.07-.42-.16.13-.21-.32-.34.4.13.21-.02.56.06-.09-.04-.19-.06-.1-.11-.02-.02-.05-.04-.07-.06h0s-.01,0-.01,0c-.01-.01-.01-.01,0,0-.05,0-.1-.02-.16-.04-.19-.14-.12-.25-.2-.35.07-.02.09.07.2.1l-.13-.14c.2.1.39.06.45.22l.06-.09c.14,0,.22-.04.16-.13.07-.02-.16-.22-.03-.1l-.05-.21.05.02c.1-.13-.18-.46.26-.43-.03-.07-.06-.15.04-.2l.18.07c-.03-.09.27-.09.1-.21.5.17.25-.24.39-.31l-.22-.12c.05-.07.02-.17-.02-.31l-.2-.1c-.12-.16.25-.13.29-.26.07.05.04.07-.02.07.53.08-.17-.48.23-.45-.06-.07-.02-.08.04-.08,0,0,0,0,0,.01,0,0,0,0,0-.01.04,0,.09,0,.13,0-.06-.01-.1-.02-.13-.02,0-.03,0-.08-.03-.14l.22.09s0,0,0-.01c.1,0-.09-.08-.26-.14-.03-.04-.06-.08-.1-.12.36.14-.07-.16.33-.02-.17-.12-.04-.26-.41-.47.05.02.08.02.07.05.07-.02.13-.04.04-.13l.28.12-.32-.28c.2.03.3.05.49.21-.26-.3-.07-.17-.33-.45l.17.09s-.19-.23-.03-.18c.38.07.27-.44.71-.52-.55-.21.29,0-.11-.2.13.05.22.05.31.14-.06-.18.29-.09-.02-.34.13.05.17.11.25.14-.02-.02-.09-.09,0-.07.08.02.1.07.14.11.04-.14-.34-.33-.69-.52.2.02.19-.02-.02-.18.13.03.27.06.27.16.04-.04.3-.18.02-.33.08.02.05-.05.02-.08.06-.09.09-.09.11-.2h-.06c-.33-.2-.04-.11-.04-.21l.03.02c.34-.06-.08-.13.29-.17l-.22-.09c-.46-.24.35-.03.22-.21l-.14-.02c-.13-.13.71.14.79.11.05,0,.06.05.08.08.34-.02-.28-.15-.29-.29.16.05.38.21.44.15.14.02-.4-.45-.06-.41-.13-.03-.26-.07-.32-.16,0-.1.55,0,.2-.25.04,0,.07.02.1.03-.07-.1-.07-.27-.26-.4.78.29-.19-.54.5-.22l.05-.2.07.04c.1-.1-.05-.22-.2-.33.06,0,.12.04.15.06.22-.11.2-.14-.09-.44l.23.09c-.11-.1.47-.09.28-.38.02.01.07.04.09.06-.18-.31.83-.18.04-.62l-.15-.22c-.14.13-.35-.18-.51-.18-.02-.08.32-.06.33.04h-.05c.42.21.24-.14.53,0,.12-.33.5-.54.65-.84l-.35-.11.06-.1c.09,0,.28.08.23.15.21.04-.1-.19-.18-.23.2-.09.37.23.39.18v-.07s-.04,0-.04,0c-.12-.11-.26-.18-.2-.26.09-.03.22.06.24.04.02.01.04,0,.02-.03l.09-.12-.29-.06c-.11-.11.07-.12-.26-.19.5.11.38-.42.54-.42-.16-.16-.12-.24-.06-.34-.07,0-.37-.11-.3-.18.6.29.33-.05.81.07-.32-.06.03-.28-.43-.35.08-.05.23.09.4.1-.17-.27.31-.32.32-.57-.08-.04-.22-.05-.32-.15l.45.05c-.02-.06-.45-.23-.14-.19-.07-.02-.18-.04-.2-.08.57-.26.02-.99.94-1.12-.18,0-.18-.05-.17-.1-.05.01-.2-.08-.31-.12l.38-.06c-.29-.15.06-.2-.23-.34l.03.08c-.32-.21-.81-.2-1.25-.39.36.24-.67-.01-.16.35-.1,0-.13-.08-.24-.11.18.11.2.17.08.21l-.04-.03c-.04.24-.27.26-.49.45l.23.07c-.05.04-.12.02-.19.03.31.2.08-.14.42.06-.48-.11-.16.37-.69.21-.04.08.26.08.23.16l-.15-.03.17.09c-.05.04-.23,0-.35-.05.02,0-.02-.05-.02-.07-.19,0-.02.22-.09.22l.12-.04c.04.27-.25.47-.06.8l.11.03c.12.24-.17.08-.15.3l-.02-.02c.09.08.12.15.09.19-.1-.1-.27-.01-.38-.13.13.26.12.15.46.43l-.18-.04c.14.1.22.14.22.25-.12-.14-.28-.05-.44-.22-.45.03.26.44-.32.29.44.29.33-.05.41.04.17.02.32.22.25.26-.04.06-.65-.16-.7,0,0-.01-.03-.03-.02-.04-.14,0,.12.18-.11.16.27.16-.05.08.3.25l-.02-.17c.06.12.46.38.19.42-.07-.04-.15-.12-.19-.17-.12,0,.04.1-.09.09-.36-.17,0-.2-.25-.4-.17-.03.2.27-.18.06.47.28-.13.12.21.39l-.21-.1s.12.11.1.14l-.26-.18c.21.19-.28.07-.18.2.07-.17.28.08.47.08.2.33-.62-.13-.62.14-.02-.04.18-.06.26.03-.06.02-.17.04-.3.02-.02.17.23.08.34.2-.29-.07.08.12.13.22l-.22-.1c-.22.11.44.25.2.33l-.28-.2.04.12-.24-.13c.15.17.09.18-.02.23.16.05.4.19.37.27-.15,0-.2-.12-.21,0-.13-.09-.29-.19-.06-.15-.07-.04-.13-.08-.2-.12-.18-.01-.1.12-.11.16.01-.01.03-.02.07-.02l.24.29c-.09-.01-.15-.06-.21-.11,0,.04.1.11.1.16-.17-.09-.36-.17-.41-.27l.13.24c-.08-.02-.25-.02-.31-.07-.14.03.26.36.07.4.03.02.06.05.08.08-.09.08-.35.07-.16.31l-.35-.08c.03.13.45.09.49.3.05.16-.29-.08-.4-.08.14.13.42.38.11.36-.04-.06.01-.07,0-.11ZM513.4,90.66s-.16-.15-.02-.11c.24.14.11.11.02.11ZM513.08,92.68c-.06-.05-.02-.06.08-.05,0,.03-.01.05-.08.05ZM512.11,98.33s0,0,0,0c.11,0,.07,0,0,0ZM511.96,98.38s.05.04.09.05c-.05-.04-.04-.06-.01-.08-.06-.02-.11-.03-.07.03ZM517.28,87.03h-.07c-.04-.08,0-.04.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M512.88,92.33s.08.03.12.05c-.03-.03-.07-.05-.12-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "514.01 88.66 514.01 88.65 513.97 88.63 514.01 88.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.98,95.84s.09,0,.13.02c-.05-.03-.1-.04-.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M512.03,99.12l-.02-.1s-.06.02-.1.02c.05.02.13.05.12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.41,98.99s0,.02.01.05l.1.05s-.05-.12-.11-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.29,98.8c-.18-.09-.14-.02-.13.05h0c.24.14.19.05.13-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.16,98.87s0,.04-.02.04c.1.06.03,0,.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M512.01,98.58c-.06,0,.22.14.14.11.22.15-.2-.29-.14-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "510.68 98.53 510.91 98.63 510.75 98.51 510.68 98.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.04,98.25l-.1.04s.05.04.06.06c.03-.04.1-.07.04-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511,98.35s-.02.05,0,.08c0-.01.01-.05,0-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "510.67 98.39 510.73 98.39 510.77 98.35 510.67 98.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.5,97.48l-.02-.11c-.07-.05-.13-.05-.12,0,.04.05.06.09.14.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.76,97.4c.06,0,.11.03.19.05l-.27-.15.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M510.82,97.14c-.07-.05-.16-.23-.19-.12.07.05.09.16.19.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "511.8 96.11 511.79 96.13 512.25 96.36 511.8 96.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.26,94.49c-.16.04.27.16.09.18.1.08.15-.01.23.06-.08-.11,0-.11-.32-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M511.57,94.72s.03.04.05.06c-.02-.03-.04-.05-.05-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "519.14 83.2 519.27 83.18 519.09 83.15 519.14 83.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M518.84,82.94l.31.1-.26-.15s.02.06-.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M512.73,90.56l.07.04c.08.03.09.01.12,0l-.19-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "513.34 89.82 513.32 89.83 513.6 89.93 513.34 89.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M513.32,88.96s.02.08,0,.11c-.02-.08.34.04,0-.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.21,95.24s.18.06.22.07c-.04-.06-.27-.08-.22-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "502.84 94.66 502.92 94.68 502.73 94.57 502.84 94.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.94,94.2c-.36-.03.02.18-.12.23h-.08s.27.09.27.09c-.02-.11-.18-.28-.07-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.75,94.11c-.14-.01-.11-.08-.05.05.02,0,.02,0,.04,0,0-.01,0-.02.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.73,94.15c0,.05.12,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.7,93.91l.11.09c.08,0,.11-.05.17-.02-.05-.08-.14-.08-.28-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.45,93.8l.04.04s.05,0-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.59,93.94l-.09-.09c-.06,0-.17-.02.03.04-.1-.03,0,0,.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.53,93.97c-.08.02-.14.06-.25-.03.02.13.27.16.25.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.58,94.1l-.11.03.11.07c-.05-.03.11-.07,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.96,93.55c-.07-.02-.2-.02-.3-.03l.08.06c.06-.01.11-.05.22-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.66,93.52l-.11-.1c-.03.06.03.08.11.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "503.07 93.71 503.31 93.88 503.07 93.69 503.07 93.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "504.02 93.29 504.19 93.36 503.94 93.24 504.02 93.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M504.03,93.1c.14.06.25,0,.33.06-.02-.05-.13-.12-.23-.18.05.05.03.09-.1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.98,92.89s.09.06.15.1c-.03-.03-.07-.06-.15-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.61,93.31s.17.02.22-.01l-.21-.02s0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.61,93.28h0s.02-.05.02-.06c0,0-.01.02-.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.61,93.32s0,0,0,0c-.02,0-.03,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.3,93.56c-.11-.07-.22-.18-.41-.13.14.06.25.03.41.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.34,93.3l-.06.06c.06,0,.14.01.19.05l-.13-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "503.28 93.25 503.34 93.3 503.36 93.28 503.28 93.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.76,92.97c-.08-.05-.08-.09-.09-.13-.05.03-.08.07-.09.12.06.02.18.06.18.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.67,93.12s0,0-.01,0c-.02,0-.02,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.75,92.45s-.03,0-.04,0c.01,0,.02,0,.04,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.54,92.96s0,.05.06.09c-.02-.03-.02-.06-.02-.08-.03,0-.05-.01-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.91,92.76s-.09.02-.13.03c.07,0,.18-.01.13-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.72,93.11s0,0,0,0c.05,0,.02,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.72,93.11s-.08-.05-.12-.07c.01.02.03.05.06.07.02,0,.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.43,92.06c.19.05.35.17.13.2.13.1.78.19,1.15.2-.08-.02-.16-.04-.26-.13-.11,0-.28.11-.44.01-.08-.12.09-.07.2-.09-.25,0-.33-.2-.69-.25l.11.11c-.06,0-.14-.06-.19-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.66,92.59l.02.04s.12-.04.28-.05c-.08-.07-.15-.1-.22-.11l-.06.14-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.65,92.76c-.21-.07-.28-.16-.52-.16,0,.09.16.1.24.17-.02-.15.11.07.25-.01.03.04.04.06.04.09.03-.02.07-.04.11-.05,0,0,0,0-.01,0h0s0,0,0,0c-.03,0-.04,0-.03,0,0,0,0,0,0,0-.03,0-.05-.02-.08-.02.05-.03.06,0,.08.02.01,0,.02,0,.03,0h0l-.09-.17s-.04.06-.03.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.45,93.26s.03,0,.05,0c-.02-.01-.04-.02-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.59,93.23s.11.04.08.07c-.07.02-.1-.02-.17-.03.05.03.14.1.25.06l-.03-.02c.08-.04.36-.06.39-.05-.19-.02-.33-.04-.53-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.07,92.98l-.08-.14-.2.02.11.02c-.06.06.08.07.16.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "503.86 92.46 504.08 92.52 503.78 92.39 503.86 92.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "503.86 92.3 504.06 92.34 503.95 92.28 503.86 92.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.27,82.99l-.05-.05s.03.03.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.21,83.25l.09.03c-.05-.02-.09-.04-.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M504.63,88.46c.19-.01.48-.01.26-.05l-.22-.03s0,.07-.05.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.9,85.57s-.04,0-.07,0c.07.03.14.05.2.08-.04-.02-.08-.05-.13-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.03,85.36l.15-.04c-.05,0-.1.02-.15.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.33,81.55l-.21-.09c-.01.06.1.06.21.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M504.11,90.68c.09-.03.13-.06.15-.08-.13.03-.32.03-.15.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M505.51,83.56s-.08-.05-.12-.06c.03.03.07.05.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M504.29,90.47s-.04,0-.05.01c.03.04.05.08.03.12.1-.02.16-.05.03-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M504.55,76.53s.02,0,.03,0c-.03,0-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M507,75.49s0,.04,0,.06c.02,0,.02-.03,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M504.09,91.69s.02.01,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.21,91.68s-.05-.02-.1-.03c.05.01.08.02.1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.04,89.87s0,0,0,0c-.04,0-.04,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.98,91.72s.05-.02.07-.03c-.02,0-.04.01-.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M504.08,91.73s-.02.02-.03.02c.03.01.06.01.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M504.08,91.64s-.01.04-.03.05c.02,0,.03,0,.04,0,0-.01,0-.02,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M504.56,79.36s.01,0,.02,0c-.08-.05-.07-.03-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "502.6 87.14 502.61 87.15 502.62 87.15 502.6 87.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.47,86.99c.25.11.22.13.15.15l.62.09-.77-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.34,82.37l-.21.04c-.29-.17-.17-.22-.45-.19.66.15,0,.34.66.49l-.15.03s-.03-.02-.02-.04c-.34.04.46.18.34.3-.06.04-.16.05-.24,0l.14.14s-.13,0-.11-.03l.02.17h-.02c.1.04.25.13.31.17-.1.02-.07-.04-.15-.04l.14.12c-.18,0-.33-.11-.29-.17-.68-.05.15.11-.27.21l-.07-.1c-.39-.02-.27.07-.52.12.13,0,.63-.07.78.06-.06.02-.09.05.04.13-.24-.05-.19.02-.19.08l-.31-.07c.08.09.24.12.37.19-.05.07-.29.04-.5.01-.08.11.41,0,.44.15-.14.08-.03.18.13.34-.12.05-.19-.05-.28-.04l.24.12s-.08,0-.12-.02c.09.07.31.07.38.17.34.09-.54.07-.17.26-.09,0-.19-.05-.31-.07.23.2.16.16.48.35l-.23.06c.25-.03.51.13.72.26.12,0,.22,0,.27-.01l.14.17c-.05,0-.16-.03-.29-.08.02.01.05.03.07.04-.13.02-.3-.04-.47-.11.06,0,.13,0,.2,0-.18-.07-.39-.15-.57-.18.03.02.06.04.08.06-.05-.02-.09-.03-.13-.04-.03,0,.03.03.11.06l-.36-.04.14.04-.25.13c.33.2.82.41.92.64-.25-.1-.42-.1-.72-.16.33.01-.1-.18-.02-.27-.04.05-.19,0-.23-.02l.25.24c-.25-.06-.19,0-.31.03.5.06.3.2.43.31-.17-.03-.33-.08-.27-.16-.39.02.55.25.22.28,0-.02.03-.03-.05-.06.14.08,0,.18-.14.12v-.02c-.09.14-.09.45.32.55-.05,0-.5-.12-.58-.15l1.35.55c-.35-.1-1.22-.18-1.4-.35-.06.02-.13.06-.02.16.06-.01.53.05.56.09-.42,0-.23.02-.59.06.08-.02.64.14.61.19-.08-.03-.55-.11-.61-.14l.52.25c-.09-.06-.47-.1-.63-.1.11,0-.04.12.01.17l.14-.03c-.12.14.74.32.68.47-.11-.04-.69-.19-.78-.13.27.09,1.32.44,1.51.63h-.17s.16.14.16.14c-.41-.15-1.27-.52-1.59-.7-.14.03-.19-.02-.2.07-.16,0-.22-.1-.22-.12l-.14.19c.33.06.3.23.57.27l-.29-.3c.33.06.91.32.82.46-.14.01-.58-.15-.69-.17.11.04.19.18.1.18l-.16-.1c-.14.06.41.22.07.26-.03.03-.44.01-.25.06.39.02,1.55.25,1.83.35-.03,0-.4.1-.59.1-.31,0-.68-.23-.95-.23.09.02.19.07.23.09-.08.02-.28-.07-.25.01.33.08-.06.15.27.09.08.1-.09.07-.09.16.22.02.72.23.8.33-.08-.02-.2-.03-.25-.03-.06.15-.23.2-.26.35-.08,0-.2.05-.33-.01.05.03.16.08.16.12-.31.03-.02-.11-.38-.11.19.05.24.17.35.26.3.04.09-.14-.02-.22.41.08.82.28.98.48.08.14-.28,0-.22.03-.12.21.68.34.35.47-.28.02-.52-.1-.72-.13-.08-.12.2-.12.2-.18l-.14.06c-.08-.05-.13-.13-.05-.15-.25.01-.12.37-.38.5.08.05.16.12.27.12l-.03-.06c.22,0,.27.16.39.11.13.1.35.24.21.32l-.3-.04c.09.02.19-.03.11-.08.12.07-.44.08-.06.2l.22-.03c.14.11.44.26.32.34.31.02-.03-.03.33-.02-.44-.03.07-.23-.41-.23.42.02.19-.08.56-.1-.1-.02-.2,0-.13-.08-.03,0-.06-.03-.08-.04,0,0,0,0,0,0,0,0,0,0-.01,0-.01,0-.02,0,0,0-.05,0-.1.01-.16,0-.22-.08-.19-.21-.3-.27.06-.04.11.04.22.04l-.16-.1c.22.04.39-.05.5.09l.03-.1c.14-.03.2-.1.12-.17.06-.04-.22-.17-.06-.09l-.1-.18h.06c.06-.14-.3-.38.13-.47-.04-.06-.1-.13-.02-.2l.19.02c-.05-.08.23-.16.04-.23.53.03.18-.29.29-.39l-.25-.06c.03-.08-.02-.17-.1-.29l-.22-.04c-.16-.12.2-.19.21-.32.08.03.05.06,0,.07.53-.06-.29-.41.1-.48-.07-.05-.04-.07.02-.09,0,0,0,0,0,.01,0,0,0,0,0-.01.04,0,.09-.02.13-.03-.06,0-.1,0-.13.02,0-.03-.02-.08-.06-.13l.24.03s0,0,0-.01c.1-.02-.1-.06-.29-.07-.03-.03-.08-.06-.13-.08.39.05-.11-.13.31-.1-.19-.07-.11-.24-.52-.35.05,0,.08,0,.08.03.06-.04.11-.07,0-.14l.3.04-.38-.18c.2-.02.31-.03.53.08-.32-.22-.11-.15-.44-.34l.19.05s-.24-.17-.08-.17c.39-.02.15-.48.55-.67-.58-.07.28-.07-.16-.17.14.01.22,0,.33.06-.11-.16.25-.15-.1-.32.14.01.19.07.28.07-.03-.02-.11-.07-.03-.06.08,0,.11.04.16.08,0-.14-.41-.24-.8-.33.2-.03.18-.07-.07-.17.13,0,.27,0,.3.08.03-.04.25-.25-.07-.32.08,0,.04-.06,0-.08.04-.1.07-.1.06-.21l-.06.02c-.37-.12-.07-.1-.09-.2h.04c.31-.12-.11-.1.24-.22l-.24-.04c-.5-.12.33-.1.16-.25h-.14c-.16-.08.72-.01.8-.06.05,0,.07.04.1.06.33-.09-.3-.08-.35-.21.17.01.42.11.46.04.14-.01-.49-.34-.15-.38-.13,0-.27,0-.35-.08-.03-.09.53-.12.14-.28.04,0,.07,0,.1,0-.09-.08-.13-.24-.34-.32.82.11-.31-.48.43-.32v-.2l.08.02c.08-.11-.1-.2-.27-.28.06-.02.12.02.16.03.19-.15.16-.18-.18-.4l.25.03c-.13-.07.43-.18.19-.42.03,0,.07.02.1.04-.24-.26.77-.34-.1-.6l-.19-.18c-.1.16-.38-.1-.54-.06-.04-.08.3-.12.33-.03h-.05c.45.13.21-.18.52-.11.05-.34.37-.62.45-.93l-.37-.04.04-.11c.09-.01.29.02.26.09.21,0-.14-.17-.22-.19.18-.12.41.15.42.1v-.07s-.06,0-.06,0c-.14-.08-.29-.12-.25-.21.08-.05.23.01.25,0,.03,0,.04,0,.02-.03l.06-.13h-.29c-.13-.09.04-.13-.29-.13.51,0,.28-.48.45-.51-.19-.13-.17-.21-.12-.31-.06.01-.39-.04-.33-.12.65.17.32-.11.81-.08-.33,0-.02-.27-.49-.26.07-.06.25.05.41.02-.22-.23.25-.36.21-.6-.09-.02-.22-.01-.34-.08l.45-.03c-.03-.05-.49-.14-.17-.16-.07,0-.19,0-.21-.04.51-.35-.16-.96.72-1.25-.18.03-.19-.02-.18-.06-.05.02-.21-.04-.33-.06l.36-.12c-.32-.1.02-.2-.29-.29l.04.07c-.35-.15-.84-.06-1.3-.17.4.17-.66.1-.1.37-.1.01-.15-.06-.26-.06.19.08.23.13.12.19l-.05-.02c0,.24-.22.3-.4.53l.24.03s-.12.05-.18.06c.34.14.05-.15.43-.01-.49-.02-.09.39-.63.33-.02.08.27.03.25.11h-.15s.18.05.18.05c-.04.05-.23.04-.35.02.02-.01-.03-.05-.03-.06-.19.04.02.22-.04.23l.11-.06c.09.26-.16.5.09.79h.11c.17.22-.15.12-.09.33h-.02c.1.05.15.11.12.16-.12-.07-.27.04-.4-.05.18.23.15.13.53.33h-.19c.16.07.24.09.27.19-.14-.11-.29,0-.48-.13-.44.12.34.38-.26.35.48.19.31-.11.41-.04.17,0,.36.15.3.2-.02.06-.67-.02-.69.14,0-.02-.03-.02-.03-.04-.14.03.15.15-.07.18.3.1-.04.09.35.18l-.06-.16c.08.1.52.27.27.36-.08-.03-.17-.09-.22-.13-.12.02.06.09-.07.11-.39-.09-.05-.19-.33-.34-.17,0,.25.23-.16.09.52.17-.1.14.29.33l-.23-.06s.14.08.12.11l-.29-.12c.24.14-.26.12-.14.23.03-.18.29.02.47-.02.27.28-.63,0-.57.26-.03-.04.17-.09.26-.02-.06.04-.16.08-.29.08.02.17.24.02.37.12-.29,0,.1.1.18.19l-.24-.05c-.19.15.48.15.27.28l-.31-.14.07.1-.27-.07c.18.13.12.15.03.23.17.01.43.1.42.18-.15.03-.22-.08-.21.04-.14-.06-.32-.12-.09-.13-.08-.02-.14-.06-.22-.08-.17.03-.07.14-.07.18.01-.01.03-.03.06-.03l.29.23c-.09,0-.16-.03-.23-.06.02.04.12.08.13.14-.19-.05-.39-.09-.46-.18l.18.2c-.09,0-.25.03-.31,0-.13.06.33.29.16.38.04.01.07.03.09.06-.07.1-.32.15-.08.33h-.36c.06.12.45,0,.55.19.09.14-.3-.02-.41,0,.16.1.49.27.19.32-.06-.05,0-.07-.02-.11ZM503.23,83.65s-.19-.11-.04-.1c.27.08.13.08.04.1ZM503.41,85.66c-.07-.03-.03-.05.07-.07.01.03,0,.05-.07.07ZM503.97,91.29s0,0-.01,0c.1-.03.06-.02.01,0ZM503.84,91.38s.06.02.1.03c-.06-.02-.06-.05-.03-.07-.06,0-.11,0-.06.04ZM506.22,79.33h-.07c-.06-.05,0-.03.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.13,85.38s.09,0,.13.02c-.04-.02-.08-.03-.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.37,81.57s0,0,0,0c-.01,0-.03,0-.04-.01l.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.2,89.23s.08-.02.13-.02c-.06-.01-.11-.01-.13.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M504.12,92.05l-.05-.08s-.05.04-.09.05c.06,0,.14.01.14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.53,92.37s0,.02.03.04l.11.02s-.08-.1-.14-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.32,91.96c-.2-.04-.14.02-.12.08,0,0,0,0,0,0,.28.07.19,0,.11-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.21,92.05s0,.03,0,.05c.11.03.03-.01,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.95,91.55c-.06.01.25.07.17.06.25.08-.27-.22-.17-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "502.66 91.86 502.91 91.9 502.72 91.83 502.66 91.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.92,91.5l-.08.07s.06.02.08.04c.02-.05.08-.09,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.92,91.61s0,.05.03.07c0-.01,0-.05-.03-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "502.61 91.74 502.67 91.73 502.7 91.67 502.61 91.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M503.15,90.65l-.05-.1c-.08-.03-.14-.01-.11.03.05.03.08.07.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.42,90.78c.06-.01.11,0,.19,0l-.3-.06.11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.4,90.51c-.08-.03-.22-.18-.22-.06.08.03.13.13.22.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "503.06 89.27 503.06 89.29 503.56 89.39 503.06 89.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.1,87.86c-.14.08.3.09.13.15.11.05.14-.05.23,0-.11-.09-.03-.11-.37-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.47,88s.04.03.07.05c-.03-.02-.05-.04-.07-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "507.32 75.3 507.43 75.26 507.26 75.27 507.32 75.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M506.97,75.1l.32.05-.28-.1s.03.05-.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.55,83.7l.08.02c.08,0,.09,0,.11-.04l-.19.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "502.98 82.85 502.97 82.86 503.26 82.89 502.98 82.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M502.77,82.01s.04.08.02.11c-.04-.08.34-.04-.02-.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.57,119.47s0-.19,0-.23c-.02.05,0,.28,0,.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "537.38 119.95 537.38 119.86 537.36 120.07 537.38 119.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.19,119.95c.03.36.07-.06.1.07v.08s.02-.29.02-.29c-.04.05-.09.24-.12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.08,119.18c0,.14-.02.12.02.04,0-.02,0-.02,0-.04,0,0,0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.1,119.19s-.02-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.01,119.27l.02-.12c0-.08-.03-.1-.02-.16-.03.07-.02.15,0,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.99,119.53v-.05s0-.05,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.03,119.37l-.03.11c0,.06,0,.17.01-.04,0,.11,0,0,.01-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.04,119.42c.02.08.04.13.01.25.05-.05.04-.3-.01-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M537.19,120.32l.02.1v-.12c0,.06-.03-.1-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.84,119.09c0,.08.01.2.02.3l.02-.09c-.01-.05-.03-.1-.03-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.86,119.39l-.03.13s.03-.05.03-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.99 119.93 537.03 119.65 536.98 119.93 536.99 119.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.73 119.08 536.74 118.9 536.72 119.17 536.73 119.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.66,119.11c0-.15-.02-.25-.01-.34-.02.03-.03.15-.05.26.01-.06.03-.05.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.58,119.21s.01-.1.02-.16c0,.03-.02.08-.02.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.78,119.48s-.01-.17-.03-.22l.02.21s0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.77,119.49h0s-.02-.02-.02-.02c0,0,.01,0,.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.78,119.48s0,0,0,0c0,.02,0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.91,119.73c-.01.12-.05.25,0,.43,0-.15-.01-.25,0-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.8,119.75l.03.05c0-.06,0-.14,0-.2l-.03.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.79 119.82 536.8 119.75 536.79 119.73 536.79 119.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.63,119.41c-.01.09-.03.1-.04.12.02.04.04.06.05.06,0-.07,0-.19-.01-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.7,119.46s0,0,0,.01c0,.02,0,.02,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.43,119.52s0,.03,0,.04c0-.01,0-.02,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.65,119.63s.02-.01.03-.08c0,.02-.02.04-.03.04,0,.03,0,.05,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.53,119.31s.02.08.03.12c0-.07-.02-.17-.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.69,119.42s0,0,0,0c0-.05,0-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.69,119.42s-.01.08-.01.13c0-.02.01-.04.02-.07,0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.41,120.9c0-.2.03-.38.06-.17.03-.15,0-.8-.04-1.16,0,.09,0,.17-.02.28.01.11.07.25.05.43-.04.1-.03-.07-.06-.17.02.25-.04.36-.03.72l.03-.13c0,.06,0,.15,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.49,119.58v-.02s-.02-.11-.04-.27c-.02.1-.02.17-.02.24l.06.03v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.56,119.56c0,.22-.03.31,0,.54.04-.02.02-.18.04-.27-.06.05.01-.12-.03-.24.01-.04.02-.05.03-.06-.01-.03-.02-.06-.03-.1,0,0,0,0,0,.01h0s0,.05,0,.03c0,0,0,0,0,0,0,.03,0,.06,0,.08-.02-.04,0-.06,0-.08,0-.01,0-.02,0-.03,0,0,0,0,0,0l-.06.12s.03.02.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.88,120.63s0-.03,0-.05c0,.03,0,.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.86,120.5s0-.12.02-.09c.01.06,0,.1,0,.17,0-.06.03-.16,0-.26v.03c-.03-.07-.07-.34-.06-.37.01.19.02.33.04.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.71,120.08l-.05.11.03.19v-.11s.02-.09.02-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.42 119.42 536.42 119.19 536.4 119.51 536.42 119.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.36 119.45 536.36 119.25 536.34 119.37 536.36 119.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.81,121.99v.06s0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.91,122v-.1c0,.05,0,.09,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.79,119.51c-.03-.18-.06-.47-.05-.25v.22s.04-.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.74,120.83s0,.04,0,.07c0-.07,0-.14,0-.21,0,.04-.01.09-.02.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.75,121.72l-.03-.14s.02.1.03.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.24,122.23v.22s0-.11,0-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.71,119.54c-.02-.08-.04-.12-.05-.13.02.12.05.31.05.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.79,119.68s-.01.08,0,.13c0-.04.01-.08,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.61,119.41s0,.03.01.05c.01-.04.03-.07.04-.05-.02-.09-.04-.15-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M530.16,122.1s0-.01,0-.03c0,.03,0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.5,119.92s.02-.01.02-.02c0-.01-.01-.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.1,119.36s0-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.19,120.21s0,.06,0,.11c0-.05,0-.09,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.5,120.77s0,0,0,0c0,.04,0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.12,119.46s-.01-.05-.02-.06c0,.02,0,.04.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.12,119.35s0,.01.01.02c0-.04,0-.06-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.08,119.37s.02,0,.02.02c0-.01,0-.03,0-.03,0,0,0,0-.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M531.26,121.49s0-.01,0-.02c-.01.09,0,.08,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "534.49 121.77 534.49 121.76 534.49 121.75 534.49 121.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.44,121.93c.01-.27.03-.24.04-.18l-.03-.62v.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.56,122.05l.04.19c-.03.32-.07.21-.03.48-.01-.68.13-.07.12-.75l.03.14s0,.03-.01.03c.05.32.02-.49.08-.4.02.05.04.15.03.23l.04-.17s.01.13,0,.12l.07-.06v.02c0-.11.02-.27.03-.34.02.1,0,.07,0,.16l.03-.17c.02.18,0,.35-.03.32.05.68.03-.17.11.22l-.03.09c.03.38.06.24.1.48-.01-.13-.09-.6-.06-.77.01.05.03.08.05-.06,0,.24.03.18.05.17v.32c.03-.09.03-.26.04-.4.03.03.05.28.06.49.05.05-.04-.4.01-.46.05.12.07-.01.12-.2.03.11,0,.2.01.29l.02-.26s0,.08,0,.12c.02-.1,0-.32.03-.41,0-.35.08.51.12.11.01.09,0,.2,0,.32.05-.26.05-.19.09-.55l.05.21c-.04-.24,0-.52.02-.76-.01-.12-.03-.22-.03-.27l.05-.17c0,.05,0,.16,0,.3,0-.03,0-.05,0-.08.02.12.02.3,0,.48,0-.06-.02-.13-.02-.2,0,.19-.02.41,0,.6,0-.04,0-.07.02-.09,0,.05,0,.1,0,.13,0,.03,0-.04.01-.12l.02.36v-.14s.08.22.08.22c.04-.36.07-.89.15-1.04-.01.26,0,.43.01.74-.03-.33-.06.14-.1.08.02.03.02.18.02.23l.07-.3c0,.25.02.19.04.29-.03-.5.05-.33.07-.49,0,.17,0,.34-.04.3.05.38.04-.59.09-.27,0,0-.01-.02-.02.06.02-.15.07-.03.06.11h0c.06.06.18,0,.18-.42,0,.06,0,.51,0,.6l.07-1.43c0,.37.06,1.23.01,1.44.02.05.03.11.06-.02-.01-.05-.04-.53-.02-.56.05.41.03.22.08.56-.02-.08-.01-.65.01-.63,0,.09.02.56,0,.62l.04-.56c-.01.1,0,.48.03.63,0-.11.05,0,.06-.05l-.03-.13c.07.08.05-.79.11-.76,0,.12,0,.72.03.79,0-.29.03-1.39.09-1.61v.16s.05-.19.05-.19c-.02.43-.07,1.35-.11,1.7.03.13.01.19.05.18.02.15-.01.23-.02.24l.09.1c-.01-.34.06-.34.05-.62l-.08.35c-.01-.33.03-.96.09-.9.02.13,0,.6,0,.71,0-.12.05-.22.06-.14l-.02.18c.04.13.04-.45.09-.13.01.02.05.43.05.23-.03-.38-.06-1.57-.06-1.86,0,.03.08.36.1.55.03.3-.02.72,0,.98,0-.09,0-.21.01-.24.02.08,0,.28.03.24,0-.34.07.03,0-.29.03-.1.03.07.07.05-.02-.22.02-.75.04-.85,0,.09,0,.2.01.25.06.03.1.18.16.18,0,.08.04.18.03.33,0-.06.01-.18.03-.19.04.29-.04.05,0,.4,0-.2.04-.27.06-.4-.02-.31-.06-.06-.08.07-.01-.42.02-.86.08-1.06.05-.11.03.27.03.21.09.07.06-.74.15-.44.04.27.01.53.03.73-.04.1-.07-.17-.09-.16l.04.13c-.01.09-.04.16-.05.08.03.24.16.04.23.26.01-.09.03-.18.02-.29l-.02.04c-.03-.22.04-.3,0-.4.03-.15.05-.39.1-.27l.02.31c0-.09-.03-.18-.04-.09.01-.14.08.41.09.01l-.03-.21c.03-.15.06-.48.1-.39-.02-.3,0,.04-.04-.32.03.44-.1-.02-.05.45-.04-.41-.05-.17-.1-.52,0,.1.02.19-.02.14,0,.03,0,.07,0,.09,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.02,0,0,0,.04.02.1.02.15-.01.23-.06.23-.08.35-.02-.05,0-.12,0-.22l-.02.18c0-.22-.06-.37-.02-.5h-.04c-.03-.13-.06-.18-.08-.09-.02-.05-.04.25-.03.07l-.06.14v-.06c-.06-.03-.12.38-.2-.03-.02.06-.04.13-.08.06v-.19c-.04.07-.1-.19-.1.01-.04-.52-.13-.11-.18-.2v.25s-.06.06-.1.16v.22c-.02.19-.08-.16-.14-.13,0-.09.02-.06.03-.01-.08-.5-.13.37-.2,0-.01.08-.02.05-.04,0,0,0,0,0,0-.01,0,0,0,0,0,0,0-.04-.02-.08-.02-.12,0,.05.01.1.02.12-.01,0-.03.03-.04.09v-.24s-.02,0-.02,0c-.02-.09-.01.11,0,.29,0,.04-.01.09-.02.15-.02-.39-.04.13-.07-.28,0,.2-.08.15-.08.58,0-.06,0-.08,0-.08-.02-.05-.04-.1-.05.02l-.02-.31-.03.41c-.03-.19-.04-.29-.02-.53-.05.36-.05.14-.09.5v-.2s-.04.27-.06.11c-.05-.38-.2-.05-.32-.39.03.58-.05-.26-.05.19,0-.14-.03-.21-.01-.33-.05.14-.09-.22-.11.17,0-.14,0-.2,0-.28,0,.03-.01.12-.02.04,0-.08,0-.12.01-.18-.05.02-.05.45-.04.85-.03-.19-.05-.16-.06.1-.01-.13-.03-.27,0-.31-.02-.02-.12-.19-.12.13,0-.08-.03-.02-.03.01-.04-.02-.05-.05-.09-.02v.05c0,.39-.02.09-.05.13v-.04c-.08-.28-.03.13-.11-.18v.24c.01.52-.07-.3-.11-.1l.02.14c-.02.18-.08-.7-.11-.76,0-.04,0-.07.01-.11-.07-.3,0,.31-.05.39-.01-.17,0-.43-.03-.46-.02-.14-.08.55-.13.23.01.13.03.26,0,.36-.03.05-.1-.49-.12-.08,0-.04,0-.07,0-.1-.02.11-.08.18-.09.4-.04-.83-.15.41-.17-.36l-.08.04v-.08c-.05-.05-.07.13-.08.32-.01-.05,0-.12,0-.16-.08-.15-.08-.12-.14.26v-.25c-.03.14-.13-.39-.2-.1,0-.03,0-.08,0-.11-.08.29-.21-.68-.22.22l-.05.22c.07.07,0,.39.03.54-.03.05-.08-.27-.04-.32v.04c0-.47-.08-.16-.09-.48-.14.03-.28-.23-.41-.25l.02.37-.05-.02c-.01-.08-.02-.29,0-.27-.02-.21-.05.17-.05.25-.07-.15.01-.43,0-.44l-.03.03v.04c-.01.15,0,.31-.05.29-.03-.07-.02-.23-.03-.24,0-.03,0-.04-.01,0l-.06-.03.03.29c-.02.14-.05-.01-.02.31-.05-.5-.22-.18-.24-.33-.03.21-.07.21-.11.18.01.06.03.38-.01.35,0-.67-.08-.29-.12-.77.03.32-.1.08-.05.53-.03-.05,0-.25-.04-.41-.07.26-.17-.16-.26-.07,0,.09.02.22,0,.35l-.06-.44s0,.51-.04.2c0,.07.02.19,0,.21-.19-.42-.36.36-.56-.44.03.17.01.19,0,.19.01.04,0,.22.01.34l-.08-.33c0,.33-.08.02-.08.34l.02-.06c-.02.37.06.83.07,1.31.03-.43.11.63.15.02.02.1,0,.15,0,.27.01-.21.03-.25.06-.16v.05c.09-.05.14.15.24.28v-.24s.02.11.03.16c.02-.36-.06-.02-.05-.42.04.48.16,0,.19.55.03,0-.02-.27.02-.27v.15s.02-.19.02-.19c.02.03.04.22.04.34,0-.01-.01.04-.02.05.03.17.08-.06.09,0l-.04-.09c.09-.14.21.05.3-.25v-.11c.06-.21.05.12.12.02v.03c.01-.11.03-.17.05-.16-.02.13.04.25.02.4.07-.22.03-.18.07-.59l.02.19c.01-.17.01-.26.05-.31-.03.16.03.28,0,.49.09.4.11-.41.16.18.03-.51-.08-.28-.06-.39-.02-.17.02-.38.05-.33.03.01.06.66.12.64,0,0,0,.04-.01.03.03.13.04-.18.08.03,0-.31.04.02.03-.38l-.06.09c.03-.1.05-.57.11-.34,0,.08-.02.19-.03.24.02.12.03-.08.05.04,0,.4-.07.09-.1.39.02.17.06-.29.05.14.01-.55.07.07.1-.35v.24s.02-.15.03-.14l-.02.31c.03-.26.07.23.1.08-.07,0-.02-.29-.06-.46.08-.32.07.62.16.5-.01.03-.05-.14-.04-.25.02.05.05.14.06.26.06-.05-.02-.24,0-.39.03.29.03-.12.06-.21v.24c.08.15.01-.5.09-.32l-.02.34.03-.09v.27c.03-.2.05-.15.08-.08-.01-.17,0-.44.03-.45.03.14,0,.23.04.19,0,.15-.01.34-.04.12,0,.08,0,.15,0,.23.03.16.06.04.08.03,0,0-.01-.02-.02-.06l.06-.34c.01.09,0,.16,0,.23.01-.03.02-.14.04-.16,0,.2,0,.4-.02.49l.06-.22c0,.08.04.23.03.31.04.11.08-.38.13-.23,0-.04,0-.07.02-.1.05.04.09.28.14.01l.04.35c.04-.08-.05-.44.01-.58.05-.11.03.3.04.4.02-.18.05-.54.11-.25-.01.07-.03.01-.04.04ZM533.06,121.89c0,.05-.02.21-.04.07,0-.28.02-.14.04-.07ZM533.83,121.29c0,.08-.02.04-.03-.05,0-.02.02-.01.03.05ZM535.96,119.56s0,0,0,.01c-.02-.09-.02-.06,0-.01ZM536,119.66s0-.07,0-.1c0,.06-.01.07-.02.05,0,.06.01.11.02.05ZM531.08,119.87v.06c0,.07,0,0,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.75,121.62s0-.09,0-.13c0,.04,0,.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.24,122.19s0,0,0,0c0,.01,0,.03,0,.04v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.34,121.72s-.02-.08-.02-.12c0,.06,0,.11.02.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.24,119.25l-.03.06s.02.04.03.08c0-.06,0-.14,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.53,120.73s0,0,.01-.03v-.11s-.03.1-.01.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.28,120.05c0,.2.02.13.04.1,0,0,0,0,0,0,0-.28-.02-.19-.04-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.33,120.13s.01-.02.02,0c0-.11,0-.02-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.06,119.53c.01.05,0-.26,0-.18,0-.26-.06.31,0,.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.32 120.71 536.3 120.46 536.3 120.67 536.32 120.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.15,120.53l.03.07s0-.07,0-.09c-.02,0-.04-.06-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M536.19,120.52s.02,0,.03-.04c0,0-.02.01-.03.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "536.27 120.79 536.26 120.74 536.24 120.72 536.27 120.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.79,120.49l-.03.07c0,.09,0,.14.02.1,0-.06.02-.09.01-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.92,121.18c-.01-.05-.01-.11-.02-.19v.31s.02-.12.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M535.82,121.25c0,.09-.05.25,0,.23,0-.09.04-.16,0-.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "535.27 120.87 535.27 120.87 535.26 120.36 535.27 120.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.82,122.1c.05.12,0-.31.04-.16,0-.12-.03-.12-.03-.23-.02.13-.04.06-.02.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M534.84,121.71s0-.04.01-.08c0,.03,0,.06-.01.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "529.4 119.65 529.37 119.55 529.39 119.72 529.4 119.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M529.35,120.03v-.32s-.02.29-.02.29c0-.01.02-.04.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M533.16,122.54v-.08c0-.08-.01-.09-.03-.1l.03.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "532.78 122.3 532.79 122.31 532.77 122.02 532.78 122.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M532.48,122.69s.03-.05.04-.04c-.03.05-.05-.32-.04.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.27,88.96s.18-.07.21-.09c-.05,0-.26.11-.21.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "496.76 88.98 496.84 88.94 496.63 89 496.76 88.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.68,88.8c-.32.16.08.04-.02.12l-.07.04.27-.1c-.06-.02-.25.01-.18-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.35,88.4c-.12.06-.12.03-.03.04.01,0,.02-.01.03-.02,0,0,0,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.35,88.42s.1-.06,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.24,88.37l.12-.03c.07-.04.08-.07.14-.08-.07,0-.15.04-.26.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.99,88.45h.05s.04-.03-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.16,88.42l-.11.02c-.05.03-.16.07.04,0-.1.04,0,0,.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.11,88.46c-.07.04-.1.08-.23.11.06.03.29-.08.23-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.34,88.94l-.09.06.12-.03c-.06.02.07-.07-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.35,88.15c-.07.03-.18.09-.27.13l.09-.02s.08-.07.18-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.07,88.28l-.13.03s.05,0,.13-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "496.63 88.61 496.9 88.54 496.62 88.6 496.63 88.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "497.31 88.05 497.48 87.99 497.22 88.07 497.31 88.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.26,87.99c.14-.05.22-.11.31-.13-.03,0-.15.03-.26.06.06,0,.06.01-.04.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.14,87.95s.1-.02.16-.04c-.03,0-.08.02-.16.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.96,88.24s.15-.07.19-.11l-.19.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.95,88.23h0s0-.03,0-.03c0,0,0,.01,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.96,88.25h0s-.02,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.77,88.46c-.12.03-.25.05-.4.15.14-.05.23-.11.4-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.72,88.36l-.03.05c.05-.02.12-.06.18-.08l-.15.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "496.65 88.38 496.72 88.36 496.73 88.35 496.65 88.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.98,88.08c-.09.02-.1.01-.12,0-.03.03-.05.06-.04.07.06-.02.18-.06.16-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.95,88.16s0,0-.01,0c-.02,0-.02.01.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "496.79 87.94 496.76 87.95 496.79 87.94 496.79 87.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.78,88.18s.02.01.08,0c-.02,0-.04,0-.05-.01-.03.01-.05.02-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M497.03,87.95s-.07.05-.1.07c.06-.03.15-.09.1-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.99,88.14h0s.02-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.99,88.14s-.08.02-.13.04c.02,0,.04,0,.07,0,.01,0,.03-.02.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M495.51,88.42c.18-.07.37-.11.18,0,.15-.03.74-.3,1.07-.46-.08.03-.15.06-.27.08-.1.05-.21.16-.38.21-.11,0,.05-.06.14-.12-.22.11-.35.09-.68.24l.13-.02c-.05.02-.14.04-.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.76,88.01h.03s.1-.06.23-.14c-.1.02-.17.04-.23.07v.07s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.81,88.07c-.2.07-.3.08-.51.19.03.03.18-.05.27-.06-.07-.03.12-.03.21-.12.04,0,.05,0,.06,0,.02-.02.05-.04.08-.07h-.01s0,0,0,0h0s-.04.02-.03.01h0s-.05.02-.08.03c.03-.03.05-.02.08-.03h.03s0-.01,0-.01h-.13s-.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M495.93,88.77s.03-.01.05-.02c-.03,0-.04.01-.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.04,88.69s.11-.04.09-.02c-.05.04-.09.04-.16.07.06-.01.15-.03.24-.1h-.03c.06-.04.29-.18.32-.19-.17.09-.3.15-.47.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.37,88.4h-.12s-.16.09-.16.09l.1-.05s.1-.02.18-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "496.89 87.89 497.1 87.81 496.79 87.91 496.89 87.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "496.84 87.84 497.02 87.77 496.91 87.8 496.84 87.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M493.3,85.14h-.06s.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M493.32,85.25l.09-.02c-.05,0-.09.02-.09.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.26,86.4c.17-.08.43-.2.22-.12l-.2.08s.02.02-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M494.68,85.78l-.06.03c.07-.02.14-.03.2-.05-.04,0-.09.02-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M493.82,86.04l.12-.07s-.09.04-.12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M492.92,84.61l-.22.04s.11-.01.22-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.52,87.27c.07-.05.1-.07.11-.09-.11.06-.28.15-.11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M495.53,84.55s-.08.01-.13.02c.04,0,.08,0,.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.61,87.13s-.03.02-.04.03c.04,0,.07,0,.06.02.08-.05.13-.09-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M492.59,82.4s.01,0,.02,0c-.03,0-.03,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M494.63,81.39s.02.01.02.02c.01,0,.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.83,87.57s.02,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.06,87.95s-.05.02-.1.03c.05-.02.08-.03.1-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M495.3,87.49h0s-.03.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.75,87.63s.04-.03.05-.04c-.01,0-.03.02-.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.84,87.59s-.01.01-.02.02c.03-.01.05-.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.81,87.56s0,.02-.01.03c.01,0,.02-.01.03-.02,0,0-.01,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M493.41,83.44s.01,0,.02,0c-.09,0-.08,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "494.01 86.8 494.02 86.8 494.03 86.8 494.01 86.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M493.84,86.8c.26-.07.23-.04.19,0l.59-.22-.77.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M493.17,84.9l-.18.09c-.32.04-.22-.02-.48.09.66-.18.11.12.76-.06l-.13.06s-.03,0-.03,0c-.3.13.48-.1.41-.02-.04.03-.14.08-.22.08h.17s-.12.04-.11.03l.07.05h-.02c.11-.01.27-.04.34-.05-.09.04-.07.01-.15.04h.17c-.16.06-.34.07-.32.04-.64.22.17-.02-.18.17h-.09c-.36.12-.22.11-.44.22.12-.05.56-.25.73-.26-.05.03-.06.05.07.03-.23.07-.17.07-.15.1l-.31.09c.1,0,.25-.05.4-.07-.02.04-.26.12-.45.19-.03.07.37-.15.45-.11-.1.08.03.07.23.07-.1.06-.19.05-.27.09l.25-.05s-.08.03-.12.04c.1,0,.31-.09.4-.08.34-.09-.47.23-.07.15-.08.04-.19.05-.31.09.27-.02.2,0,.55-.06l-.19.1c.22-.1.5-.15.74-.19.11-.05.2-.09.25-.11h.18s-.15.05-.28.08h.08c-.11.04-.29.09-.46.13.06-.03.12-.05.18-.08-.19.05-.4.1-.58.16.04,0,.07-.01.09,0-.05.01-.1.03-.13.04-.03.01.04,0,.12-.02l-.34.12.14-.04-.19.14c.36-.06.87-.18,1.04-.14-.26.06-.41.13-.7.22.3-.12-.15-.02-.1-.08-.03.03-.17.07-.22.08l.31-.02c-.24.08-.18.08-.27.13.47-.17.34-.05.49-.07-.16.05-.32.1-.3.05-.34.16.58-.13.29,0,0,0,.02-.02-.07,0,.15-.03.05.06-.09.1h0c-.04.07.06.18.46.05-.05.02-.49.16-.57.18l1.39-.36c-.35.11-1.16.43-1.37.45-.04.03-.1.07.04.06.05-.03.49-.2.53-.19-.37.17-.2.1-.51.26.07-.04.62-.21.61-.18-.08.02-.53.19-.59.2l.55-.13c-.1.02-.45.16-.6.22.1-.04,0,.05.07.05l.11-.07c-.06.09.77-.2.76-.13-.11.03-.68.22-.73.28.28-.08,1.33-.4,1.55-.42l-.15.07.19-.02c-.42.12-1.3.36-1.65.44-.11.07-.18.07-.15.1-.14.07-.23.06-.24.05l-.06.12c.31-.12.34-.05.6-.15l-.36.03c.31-.12.92-.27.88-.19-.12.06-.57.19-.67.23.11-.03.23-.02.15.01l-.18.04c-.11.08.44-.1.15.05-.02.02-.39.19-.2.13.35-.16,1.46-.57,1.74-.66-.02.01-.32.2-.49.28-.27.13-.68.22-.92.33.09-.03.2-.06.23-.07-.07.04-.27.09-.22.11.32-.11,0,.07.28-.09.1,0-.05.06-.03.09.2-.09.71-.23.81-.24-.08.03-.18.08-.23.1,0,.07-.14.16-.12.22-.07.03-.16.1-.3.14.06-.01.17-.05.19-.03-.26.14-.06-.02-.38.13.19-.07.27-.05.4-.07.28-.12.03-.08-.09-.06.39-.15.82-.27,1.03-.28.12,0-.25.12-.19.11-.03.12.71-.2.46-.01-.24.13-.5.2-.67.28-.11,0,.14-.12.12-.14l-.11.08c-.09.02-.16.02-.09-.02-.21.11.01.17-.16.32.09-.02.18-.04.28-.09h-.04c.19-.11.29-.08.38-.14.15-.03.39-.09.29,0l-.28.12c.08-.03.16-.09.07-.07.13-.04-.36.22.02.08l.19-.11c.15-.03.47-.12.39-.05.27-.13-.04,0,.28-.15-.4.19-.02-.1-.43.11.37-.18.14-.11.45-.27-.09.04-.17.08-.14.04-.03,0-.06.02-.09.03h0s-.01,0-.01,0c-.01,0-.02,0,0,0-.04.02-.08.05-.14.07-.22.07-.23.02-.35.05.04-.04.11-.04.21-.09l-.18.04c.21-.09.33-.19.47-.19v-.04c.1-.07.14-.12.04-.1.04-.04-.25.05-.08,0h-.15s.05-.03.05-.03c0-.07-.39.02-.04-.19-.06,0-.13,0-.09-.05l.18-.08c-.07,0,.15-.14-.04-.08.48-.21.06-.16.13-.24l-.24.09s-.08-.04-.19-.04l-.21.08c-.19.03.12-.14.08-.18.08-.03.07,0,.02.02.45-.23-.39,0-.07-.19-.08.01-.06,0,0-.03,0,0,0,0,.01,0h0s.07-.05.11-.07c-.05.03-.09.05-.11.06,0,0-.04-.02-.1-.01l.22-.09h0c.08-.05-.11.02-.28.09-.04,0-.09.01-.14.03.36-.14-.14,0,.25-.15-.19.06-.17-.03-.58.1.05-.02.08-.03.08-.02.04-.03.08-.07-.04-.04l.29-.11-.4.1c.17-.08.27-.13.5-.18-.36.06-.14,0-.5.07l.19-.06s-.27.04-.12-.02c.34-.16-.02-.21.28-.42-.55.2.23-.13-.2,0,.13-.05.2-.09.32-.11-.15,0,.18-.14-.19-.06.13-.05.2-.05.27-.08-.03,0-.12.02-.04,0,.08-.03.11-.03.17-.04-.04-.04-.44.08-.83.2.17-.08.14-.09-.11-.03.12-.05.25-.11.3-.09.01-.02.15-.17-.16-.08.08-.03.01-.03-.02-.03,0-.05.03-.06-.01-.09l-.05.03c-.37.1-.09,0-.15-.03h.04c.24-.17-.14,0,.14-.17l-.23.07c-.5.14.27-.15.07-.14l-.13.05c-.18.03.65-.27.71-.31.04-.02.07-.01.11-.02.27-.15-.3.08-.39.06.16-.06.42-.11.44-.15.13-.05-.55.07-.25-.07-.12.05-.25.09-.35.1-.05-.02.45-.23.05-.14l.1-.03c-.11,0-.19-.03-.41.01.79-.25-.43-.05.3-.25l-.06-.07.08-.02c.04-.06-.15-.03-.33,0,.05-.02.12-.04.16-.04.13-.11.1-.11-.29-.07l.24-.07c-.14.02.35-.2.05-.2.03,0,.07-.02.11-.02-.3,0,.62-.36-.27-.17h-.23c-.05.09-.38.09-.52.15-.06-.01.25-.14.3-.11l-.04.02c.46-.1.14-.13.45-.2-.06-.13.16-.32.16-.45l-.35.1v-.05c.09-.03.29-.08.28-.05.2-.06-.18-.01-.26,0,.13-.09.42-.07.43-.09l-.03-.02-.04.02c-.15.01-.31.05-.3,0,.07-.04.22-.06.23-.07.03,0,.04-.01,0-.02l.02-.06-.28.09c-.14,0,0-.06-.31.04.48-.15.13-.25.28-.31-.21.01-.22-.03-.2-.07-.06.02-.37.1-.34.05.66-.13.27-.13.74-.26-.31.09-.1-.09-.53.05.05-.04.25-.05.39-.11-.27-.02.13-.19.03-.27-.09.02-.22.06-.35.06l.42-.13s-.5.08-.21,0c-.07.02-.18.05-.21.04.39-.26-.41-.3.35-.62-.16.05-.18.04-.19.02-.04.02-.21.04-.33.06l.31-.13c-.33.04-.04-.08-.35-.03h.06c-.37.05-.81.2-1.28.28.42-.04-.6.21,0,.16-.09.03-.15.02-.26.04.2-.02.25,0,.17.04h-.05c.07.09-.13.17-.24.31l.23-.05s-.1.05-.15.07c.36-.04,0-.07.4-.12-.47.12.02.17-.51.29,0,.04.27-.06.27-.03l-.14.04.19-.03s-.21.08-.33.1c.01,0-.04,0-.05-.01-.17.06.08.08.02.1l.08-.05c.16.07-.01.23.3.27l.11-.03c.22.03-.11.08,0,.14h-.03c.11,0,.17,0,.16.03-.13,0-.24.09-.39.1.23.03.18,0,.6-.03l-.18.05c.17-.02.25-.04.31,0-.16,0-.27.09-.48.09-.38.17.43.04-.14.2.51-.07.26-.13.37-.14.16-.05.38-.05.34-.02,0,.03-.63.19-.6.25,0,0-.04,0-.04,0-.12.05.18,0-.02.09.31-.05,0,.04.38-.04l-.1-.04c.11.01.57-.06.36.05-.08.01-.18.02-.24.02-.11.04.08.01-.03.06-.39.09-.1-.05-.4-.02-.16.06.3,0-.13.08.54-.1-.05.08.36.03l-.23.05s.15-.01.15,0l-.3.05c.26-.02-.21.12-.06.13-.03-.07.27-.08.43-.15.33.02-.59.2-.45.27-.04,0,.13-.09.24-.09-.04.03-.12.08-.24.12.06.06.23-.07.38-.07-.27.09.12,0,.22.01l-.23.06c-.13.11.49-.1.33.01l-.33.05.09.02-.27.06c.21,0,.16.02.09.07.16-.05.43-.1.44-.07-.13.06-.23.04-.18.08-.15.03-.34.06-.13-.01-.08.01-.15.03-.23.04-.15.07-.02.07-.01.09,0,0,.02-.02.05-.03h.34c-.08.02-.16.03-.23.04.03,0,.14-.01.16,0-.19.04-.39.1-.48.09h.23c-.08.04-.22.11-.29.12-.1.07.39,0,.26.08.04,0,.07-.01.1,0-.03.06-.25.16.02.15l-.33.12c.09.02.42-.16.56-.12.12.02-.28.1-.37.14.18-.02.54-.07.28.05-.07,0-.02-.02-.05-.03ZM493.47,85.38c-.05,0-.21.03-.07-.02.27-.07.14-.02.07.02ZM494.27,86c-.08.02-.04,0,.04-.05.02,0,.02.02-.04.05ZM496.59,87.51h-.01c.08-.05.05-.03.01,0ZM496.51,87.59s.06-.02.09-.04c-.06.02-.07.01-.05,0-.06.03-.1.05-.04.04ZM494.96,82.93l-.06.02c-.07,0,0-.01.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M493.92,86.01s.08-.03.12-.04c-.04,0-.08.02-.12.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "492.96 84.61 492.96 84.6 492.92 84.61 492.96 84.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M494.34,87.65s.07-.04.11-.06c-.06.02-.1.04-.11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.98,87.66h-.07s-.03.03-.06.05c.05-.02.13-.06.13-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M495.7,88.47s0,0,.04,0l.1-.04s-.1,0-.14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.25,87.99c-.19.08-.12.07-.07.08h0c.26-.11.17-.09.07-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.19,88.06s.02,0,.01.02c.11-.04.02-.02-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M496.66,87.59s.24-.09.17-.06c.24-.09-.31.06-.17.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "495.64 88.26 495.87 88.15 495.68 88.22 495.64 88.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M495.75,88.03l-.05.06s.06-.02.08-.02c0-.02.04-.06-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M495.78,88.07s0,.02.05,0c0,0-.02-.01-.05,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "495.55 88.24 495.6 88.21 495.61 88.18 495.55 88.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M495.66,87.68h-.08c-.08.02-.13.05-.09.05.06-.01.09-.01.17-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M495.06,88.04s.1-.05.17-.09l-.29.11.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M494.95,87.96c-.08.03-.25.04-.21.08.08-.03.16-.02.21-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "495.12 87.29 495.13 87.3 495.6 87.12 495.12 87.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M493.8,87.24c-.1.08.3-.1.17,0,.12-.03.11-.07.21-.1-.13.02-.07-.02-.38.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M494.18,87.13s.04,0,.08-.01c-.03,0-.06,0-.08.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "494.88 81.24 494.98 81.2 494.82 81.25 494.88 81.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M494.5,81.26l.32-.06-.29.03s.05.01-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M492.87,85.65l.08-.02c.08-.03.08-.04.09-.05l-.17.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "492.99 85.19 492.98 85.2 493.26 85.11 492.99 85.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M492.54,84.97s.06.02.05.03c-.06-.02.3-.13-.05-.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.93,71.34s-.17-.08-.21-.1c.03.04.26.12.21.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.29 71.72 523.21 71.69 523.39 71.8 523.29 71.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.21,71.92c.34.12-.02-.09.11-.08l.08.02-.26-.12c.02.06.18.19.07.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.45,71.72c.13.05.1.07.05,0-.01,0-.02,0-.03,0,0,0,0,.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.47,71.71s-.11-.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.5,71.83l-.1-.07c-.08-.03-.1,0-.16-.04.05.05.13.08.26.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.73,71.96l-.04-.03s-.05-.01.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.6,71.85l.09.07c.05.02.16.06-.03-.03.1.04,0,0-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.66,71.85c.08.02.13.01.23.09-.02-.07-.26-.16-.23-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.54,72.07l.1.02-.1-.06c.05.03-.11,0,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.26,71.92c.07.03.19.07.28.1l-.07-.05c-.05-.01-.1,0-.21-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.54,72.03l.11.08s-.03-.05-.11-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.1 72.11 522.86 71.96 523.09 72.12 523.1 72.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "522.21 72.03 522.05 71.94 522.29 72.07 522.21 72.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.21,72.11c-.13-.07-.23-.08-.31-.13.02.03.12.1.22.15-.05-.04-.03-.05.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.26,72.23s-.08-.05-.14-.09c.03.02.07.05.14.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.6,72.14s-.16-.06-.21-.06l.2.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.6,72.15h0s-.02.01-.02.02c0,0,.01,0,.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.6,72.14h0s.03.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.89,72.11c.1.06.21.15.39.18-.13-.07-.23-.09-.39-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.85,72.23h.06c-.05-.03-.13-.06-.18-.09l.12.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "522.91 72.27 522.85 72.23 522.83 72.23 522.91 72.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.46,72.25c.08.05.08.07.09.09.05,0,.07-.01.08-.03-.06-.03-.17-.08-.17-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.54,72.21s0,0,.01,0c.02,0,.02,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "522.48 72.5 522.52 72.51 522.48 72.5 522.48 72.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.67,72.33s0-.03-.06-.06c.02.02.02.03.02.05.03.01.05.02.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.33,72.31s.08.02.12.02c-.07-.02-.17-.05-.12-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.5,72.2h0s-.02-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.5,72.2s.07.04.11.07c-.01-.01-.03-.03-.06-.05-.01,0-.04-.01-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.72,73.1c-.18-.08-.33-.19-.12-.14-.12-.09-.73-.33-1.07-.45.08.04.15.07.25.14.1.03.26.03.41.13.08.08-.08,0-.18-.02.23.08.31.2.64.33l-.1-.09c.05.02.13.07.18.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.56,72.46l-.02-.02s-.11-.02-.26-.06c.08.06.15.09.21.12l.05-.05.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.57,72.39c.19.09.27.16.49.23,0-.04-.15-.1-.23-.16.02.08-.1-.06-.23-.07-.03-.03-.03-.04-.04-.05-.03,0-.06,0-.1,0h.01s0,0,0,0h0s.04.02.03.01h0s.05.03.07.04c-.05,0-.05-.02-.07-.03h-.03s0-.01,0-.01l.08.1s.03-.02.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.69,72.51s-.03-.01-.05-.02c.02.01.04.02.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.56,72.48s-.1-.05-.08-.06c.06.01.1.04.16.07-.05-.03-.13-.09-.24-.1l.03.02c-.08,0-.34-.08-.36-.09.18.07.31.12.49.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.11,72.46l.08.09.18.05-.1-.04c.05-.01-.08-.06-.15-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "522.38 72.46 522.17 72.37 522.46 72.52 522.38 72.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "522.38 72.54 522.2 72.45 522.3 72.52 522.38 72.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.43,77.18l.04.05s-.02-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.51,77.1l-.08-.06s.07.06.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M521.68,73.99c-.17-.07-.43-.2-.24-.09l.19.1s0-.03.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.15,75.65l.06.03c-.06-.05-.11-.09-.16-.13.03.03.07.07.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.87,76.19l-.13-.06s.09.04.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.29,77.79l.18.13s-.09-.07-.18-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.16,73.2c-.08-.02-.12-.02-.14-.01.12.03.3.1.14.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M520.6,75.8s.06.06.1.09c-.02-.03-.05-.06-.1-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522,73.23s.03,0,.05.01c-.03-.03-.05-.05-.03-.06-.09-.03-.15-.03-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M521.45,79.3h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M519.26,79.88s-.02-.02-.02-.04c-.01,0-.01.02.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.18,72.75s-.02-.01,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.99,73.03s.05.03.09.05c-.05-.02-.08-.04-.09-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.15,73.96h0s.03.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.28,72.77s-.05,0-.07-.01c.02,0,.04,0,.07.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.18,72.73s.02,0,.02,0c-.03-.02-.05-.02-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.18,72.77s.01-.01.03-.01c-.01,0-.03,0-.03-.01,0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M521.18,78.22s-.01,0-.02,0c.08.05.07.04.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.41 75.49 523.4 75.48 523.4 75.48 523.41 75.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.52,75.62c-.21-.17-.18-.16-.12-.15l-.54-.32.66.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.33,77.43l.18.08c.24.22.13.18.37.31-.55-.39.02-.15-.53-.55l.13.06s.02.03.01.03c.29.15-.38-.31-.27-.31.05.01.14.06.2.12l-.11-.14s.11.07.09.07v-.09s.01.01.01.01c-.08-.07-.2-.19-.25-.24.09.04.05.05.12.1l-.11-.13c.15.09.27.22.23.23.57.37-.12-.13.25.04l.05.08c.32.21.23.1.45.21-.11-.07-.54-.29-.65-.43.05.02.08.02-.02-.08.19.14.16.09.17.06l.26.19c-.06-.08-.19-.18-.29-.28.05,0,.25.13.42.25.07-.02-.34-.2-.35-.29.13.03.04-.07-.08-.23.11.04.15.12.23.17l-.19-.18s.07.05.1.07c-.06-.08-.26-.19-.3-.27-.28-.22.46.24.17-.04.08.04.15.12.26.19-.17-.21-.12-.16-.37-.41l.2.08c-.22-.11-.42-.32-.59-.48-.1-.06-.19-.11-.23-.13l-.1-.15s.13.09.24.18l-.06-.05c.11.05.25.17.39.28-.06-.03-.11-.06-.17-.1.15.13.32.26.47.37-.03-.02-.05-.05-.06-.07.04.03.08.06.1.08.03.02-.03-.03-.09-.08l.3.2-.11-.09.23.06c-.26-.26-.66-.6-.73-.76.2.17.35.25.6.42-.28-.17.07.14-.01.14.04,0,.16.09.2.12l-.19-.24c.21.15.17.09.27.13-.42-.27-.24-.24-.34-.36.14.09.28.2.22.21.34.17-.45-.38-.16-.24,0,.01-.03,0,.04.05-.11-.1.02-.09.14,0h0c.09-.02.12-.17-.23-.41.05.03.43.29.5.33l-1.15-.87c.3.2,1.07.62,1.21.78.05.01.12.03.03-.07-.05-.02-.47-.25-.49-.28.37.18.2.09.52.22-.08-.03-.56-.34-.53-.35.07.05.49.29.53.33l-.45-.35c.08.07.41.25.55.31-.1-.05.04-.05,0-.09l-.13-.04c.11-.03-.65-.46-.58-.51.1.06.61.38.69.38-.24-.16-1.17-.75-1.33-.91l.15.07-.14-.13c.37.23,1.12.75,1.41.97.13.04.17.09.18.04.14.06.19.14.19.15l.14-.04c-.3-.16-.26-.23-.5-.36l.25.27c-.29-.16-.8-.52-.72-.55.13.05.52.3.62.35-.1-.06-.16-.17-.09-.13l.14.11c.13.02-.36-.27-.06-.16.03,0,.41.16.23.06-.35-.15-1.4-.71-1.65-.85.02,0,.36.1.54.17.28.11.62.36.86.46-.08-.04-.17-.11-.2-.13.08.02.25.14.23.08-.3-.16.06-.05-.25-.15-.07-.08.08,0,.09-.05-.2-.09-.65-.37-.72-.45.08.04.18.08.23.1.06-.05.21-.02.25-.08.08.03.18.04.31.12-.05-.04-.15-.09-.15-.12.28.09.02.06.35.19-.18-.09-.22-.17-.32-.25-.28-.12-.08.04.02.12-.38-.18-.75-.42-.9-.56-.07-.09.26.1.21.06.11-.06-.63-.39-.32-.33.26.08.49.22.67.3.07.08-.18,0-.19.02l.13.02c.07.05.12.11.05.09.23.08.12-.14.35-.12-.08-.05-.15-.11-.25-.15l.02.04c-.21-.07-.25-.17-.36-.18-.12-.09-.33-.22-.2-.22l.28.12c-.08-.04-.18-.05-.1,0-.12-.07.41.1.05-.08l-.21-.06c-.13-.09-.41-.26-.3-.26-.28-.11.03.02-.31-.09.41.16-.06.09.38.24-.39-.14-.18-.02-.52-.13.09.04.18.07.12.08.03.01.06.03.08.04h0s.01,0,.01,0c.01,0,.02,0,0,0,.04.01.09.03.15.05.2.11.18.16.28.22-.05,0-.1-.06-.2-.09l.15.1c-.21-.09-.36-.11-.46-.2l-.03.03c-.12-.03-.18-.02-.11.04-.05,0,.2.15.05.06l.1.12-.05-.02c-.05.05.28.28-.12.17.04.04.09.09.02.1l-.18-.08c.05.06-.21-.01-.03.09-.48-.21-.16.06-.26.06l.22.12s.02.08.09.17l.2.1c.15.12-.18,0-.19.07-.07-.04-.05-.05,0-.03-.48-.19.26.3-.1.17.06.05.03.05-.02.03,0,0,0,0,0,0h0s-.08-.02-.11-.04c.05.02.09.04.11.04,0,.01.01.04.05.08l-.21-.11h0c-.08-.02.09.08.25.16.03.03.07.06.11.09-.34-.18.09.11-.28-.09.17.11.09.15.45.38-.05-.03-.07-.04-.07-.05-.05,0-.1-.02-.01.06l-.27-.15.33.25c-.17-.08-.27-.12-.46-.27.27.24.09.11.36.35l-.17-.11s.2.19.06.11c-.34-.17-.16.15-.51.04.49.31-.24-.11.12.15-.12-.07-.19-.11-.28-.19.08.12-.23-.06.06.19-.12-.07-.16-.13-.23-.17.02.02.09.08.02.04-.07-.04-.09-.07-.13-.12-.01.06.33.31.65.55-.17-.09-.16-.06.04.11-.11-.07-.23-.13-.25-.19-.03,0-.23-.01.03.18-.07-.04-.04,0,0,.04-.04.03-.07.01-.07.07l.05.02c.3.24.05.08.06.14l-.03-.02c-.27-.1.09.11-.22-.01l.2.14c.41.31-.29-.12-.16.04l.12.07c.13.13-.61-.36-.68-.37-.04-.02-.05-.05-.07-.08-.29-.12.25.19.27.28-.14-.09-.34-.27-.39-.26-.12-.07.38.41.09.26.11.07.22.14.29.21.02.06-.46-.21-.15.07-.03-.02-.06-.04-.09-.05.07.09.09.18.26.33-.69-.46.22.38-.4-.06l-.02.1-.06-.05c-.08.02.06.14.2.26-.05-.02-.1-.07-.14-.09-.18-.01-.16.01.12.29l-.21-.13c.11.09-.4-.1-.2.13-.02-.02-.06-.04-.09-.07.19.23-.72-.14.04.35l.16.17c.1-.04.33.21.48.25.03.05-.28-.06-.3-.12l.04.02c-.4-.25-.2,0-.48-.15-.06.16-.37.2-.46.35l.34.14-.04.04c-.08-.02-.27-.1-.24-.13-.2-.06.13.14.2.17-.17.02-.38-.2-.4-.18v.04s.05,0,.05,0c.13.09.27.15.23.19-.08,0-.21-.07-.23-.07-.02-.01-.04-.01-.02.01l-.06.06.28.08c.12.08-.04.06.28.15-.49-.14-.27.19-.42.17.18.11.17.15.13.2.06,0,.37.09.32.12-.64-.21-.3,0-.78-.09.32.05.04.16.49.22-.06.03-.24-.06-.4-.06.23.16-.22.19-.15.34.09.02.22.02.35.06h-.45s.5.09.19.1c.07,0,.19,0,.21.03-.46.22.31.48-.48.78.17-.05.19-.02.19,0,.04-.02.22-.02.34-.03l-.32.14c.33-.02.04.12.35.09l-.06-.03c.37-.01.82-.16,1.29-.2-.43,0,.62-.13,0-.13.1-.02.15,0,.27-.01-.21,0-.25-.02-.16-.05h.05c-.05-.07.15-.11.29-.18h-.24s.11-.02.17-.03c-.36-.05-.02.05-.42,0,.48,0,.02-.14.56-.1,0-.03-.27-.02-.27-.05h.15s-.19-.02-.19-.02c.03-.02.22,0,.34.02-.02,0,.03.02.04.02.18,0-.05-.07,0-.07h-.09c-.13-.09.08-.13-.19-.28l-.11-.02c-.18-.11.13-.02.06-.11h.02c-.1-.03-.15-.07-.13-.08.12.05.25.04.38.11-.19-.13-.16-.08-.54-.26l.18.05c-.15-.07-.24-.1-.27-.15.14.08.27.07.46.17.4.07-.34-.25.22-.07-.47-.22-.29-.04-.38-.1-.16-.04-.35-.16-.29-.17.02-.02.63.2.64.15,0,0,.03.02.03.02.13.03-.15-.11.06-.05-.28-.14.03-.02-.33-.19l.06.09c-.08-.07-.49-.29-.26-.25.07.04.16.1.21.13.11.03-.06-.06.06-.02.36.17.05.1.31.25.16.05-.24-.17.15.02-.49-.25.09-.02-.27-.23l.21.1s-.13-.08-.12-.09l.27.15c-.22-.14.23.05.12-.04-.02.06-.26-.12-.43-.17-.25-.22.57.24.51.11.02.03-.15-.03-.24-.09.05,0,.14.03.26.08-.02-.07-.22-.11-.34-.2.26.12-.09-.08-.16-.15l.21.12c.17.02-.43-.26-.23-.23l.28.19-.06-.07.23.14c-.16-.13-.11-.12-.02-.11-.15-.08-.37-.23-.36-.26.13.05.19.13.18.07.12.09.28.19.08.1.07.04.13.08.19.13.15.06.06-.03.07-.04-.01,0-.03,0-.06-.01l-.25-.23c.08.04.14.08.2.13-.02-.02-.1-.09-.11-.12.16.11.34.21.4.29l-.15-.17c.07.04.21.1.27.14.11.04-.28-.28-.12-.23-.03-.02-.06-.05-.08-.07.06-.01.28.09.09-.1l.31.17c-.04-.08-.39-.22-.46-.35-.06-.1.26.16.35.2-.13-.12-.4-.36-.14-.24.05.05,0,.03,0,.06ZM522.52,76.9s.15.15.03.07c-.22-.17-.1-.1-.03-.07ZM522.57,75.85c.06.05.02.04-.06,0,0-.02,0-.02.06,0ZM522.29,72.97h.01c-.09-.01-.06,0-.01,0ZM522.41,72.97s-.06-.03-.09-.04c.05.03.05.04.03.04.06.02.1.04.06,0ZM519.62,77.72h.06c.05.06,0,.03-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.78,76.13s-.07-.05-.11-.07c.03.03.07.05.11.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "522.26 77.77 522.26 77.77 522.29 77.79 522.26 77.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.9,74.58s-.08-.02-.12-.04c.05.03.1.05.12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.14,72.57l.04.05s.05,0,.08,0c-.05-.02-.13-.05-.13-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.62,72.91s0-.01-.02-.03l-.1-.04s.08.07.13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.89,72.87c.19.08.13.03.11,0h0c-.26-.12-.18-.06-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.99,72.86s0-.02,0-.02c-.1-.05-.03,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.31,72.86c.05.01-.23-.11-.16-.08-.23-.12.26.19.16.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.5 73.12 523.27 73.03 523.45 73.12 523.5 73.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.26,73.21h.08s-.06-.04-.07-.05c-.02.02-.07.02,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.27,73.16s0-.02-.03-.04c0,0,0,.02.03.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.55 73.19 523.5 73.18 523.47 73.2 523.55 73.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.06,73.54l.05.07c.08.04.13.05.1.03-.05-.03-.07-.06-.15-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.73,73.73c-.05-.01-.1-.04-.18-.06l.28.13-.1-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.74,73.86c.08.04.2.16.2.1-.08-.04-.12-.11-.2-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "523.12 74.24 523.12 74.23 522.67 74 523.12 74.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.91,75.32c.13.02-.27-.17-.11-.13-.1-.07-.13-.03-.21-.09.09.09.02.07.32.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.59,75.1s-.03-.03-.06-.05c.02.02.04.04.06.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "519 80.07 518.9 80.12 519.07 80.07 519 80.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M519.39,80.1l-.32.06.29-.02s-.05-.02.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M523.1,77.22l-.06-.05c-.07-.05-.08-.04-.1-.04l.16.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "522.67 77.4 522.68 77.4 522.43 77.24 522.67 77.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M522.8,77.87s-.03-.05-.01-.06c.03.05-.29-.15.01.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.03,93.54s-.11-.15-.13-.19c.02.04.17.23.13.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.25 93.98 545.2 93.91 545.31 94.08 545.25 93.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.18,94.02c.22.28,0-.06.08.03l.05.06-.17-.23s.11.21.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.68,93.43c.08.11.06.1.03.03,0-.01-.02-.02-.02-.03,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.69,93.43s-.07-.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.71,93.52l-.06-.11c-.05-.06-.07-.07-.1-.12.03.06.08.13.17.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.86,93.74l-.03-.05s-.03-.04.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.77,93.59l.06.1s.1.14-.02-.04c.06.09,0,0-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.81,93.63c.05.06.09.09.15.2-.01-.05-.16-.25-.15-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.39,94.32l.07.08-.07-.1c.03.05-.07-.07,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.54,93.41c.05.06.12.16.18.24l-.04-.08s-.07-.07-.14-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.72,93.65l.07.11s-.02-.05-.07-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.09 94.06 544.94 93.82 545.09 94.06 545.09 94.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "544.5 93.43 544.4 93.29 544.55 93.51 544.5 93.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.49,93.48c-.09-.12-.15-.2-.2-.27,0,.03.08.13.14.23-.03-.06-.02-.05.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.52,93.57s-.05-.08-.09-.14c.02.03.04.07.09.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.75,93.75s-.1-.13-.14-.17l.13.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.75,93.75h0s-.02,0-.02,0c0,0,0,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.75,93.75h0s.02.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.95,93.92c.06.1.13.21.25.35-.08-.12-.15-.2-.25-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.92,93.96l.04.03s-.08-.11-.12-.16l.08.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "544.95 94.02 544.92 93.96 544.9 93.95 544.95 94.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.65,93.72c.05.08.05.09.05.1.03.03.05.04.06.04-.04-.05-.11-.15-.11-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.71,93.75h0s.02.03,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "544.65 93.86 544.67 93.9 544.65 93.87 544.65 93.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.79,93.89s0-.01-.03-.07c0,.02.01.03.01.04.02.02.03.04.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.56,93.66s.05.06.08.09c-.04-.05-.11-.14-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.68,93.71h0s-.02-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.68,93.71s.05.07.07.11c0-.02-.02-.04-.03-.06,0-.01-.02-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.43,94.99c-.11-.16-.21-.32-.07-.16-.08-.13-.46-.65-.69-.94.05.07.1.13.15.24.07.08.17.19.27.34.04.09-.05-.05-.12-.13.15.2.19.31.41.6l-.06-.11s.08.12.11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.7,93.9v-.02s-.09-.09-.18-.21c.05.08.09.14.13.2h.04s.02.03.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.71,93.86c.12.18.17.26.31.44,0-.02-.1-.15-.14-.23.01.06-.06-.1-.15-.19-.02-.03-.02-.04-.02-.05-.02-.02-.04-.04-.07-.07h0s0,0,0,0h0s.03.04.02.02h0s.03.05.05.07c-.03-.03-.03-.04-.05-.07l-.02-.03h0s.05.11.05.11c.02.02.02.01.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.46,94.65s-.02-.03-.03-.04c.01.02.02.04.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.37,94.56s-.07-.1-.05-.08c.04.05.06.08.1.14-.03-.05-.08-.13-.15-.21l.02.02c-.05-.05-.22-.26-.24-.29.12.15.2.26.32.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.07,94.25l.04.1.12.14-.07-.09s-.05-.08-.1-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "544.58 93.78 544.45 93.59 544.63 93.86 544.58 93.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "544.57 93.82 544.46 93.66 544.52 93.76 544.57 93.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.54,96.79l.02.05-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.59,96.77l-.05-.08s.05.08.05.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.02,94.23c-.11-.15-.28-.38-.15-.2l.12.18s0-.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.32,95.58l.04.05c-.04-.06-.07-.12-.11-.18.02.04.04.08.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.8,96.34l-.09-.11s.06.08.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.42,97.13l.11.19s-.05-.1-.11-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.39,94.05c-.06-.06-.08-.09-.09-.1.08.1.19.25.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.35,94.82s.04.07.06.12c-.02-.03-.04-.07-.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.28,93.97s.02.02.03.04c-.02-.03-.03-.06-.01-.05-.06-.07-.1-.11-.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.44,97.48s0-.01-.01-.02c.01.03.02.03.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M542.16,95.68s0-.02,0-.02c0-.01-.01,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.43,93.81s-.01-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.95,94.49s.03.05.06.09c-.03-.04-.05-.07-.06-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.99,95.11h0s.02.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.49,93.88s-.03-.04-.04-.05c.01.01.03.03.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.43,93.8s.01.01.02.01c-.02-.03-.03-.05-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.43,93.82s0,0,.02.01c0-.01-.02-.02-.02-.03,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.63,96.71s0,0-.01-.02c.04.08.03.07.01.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.13 96.2 545.13 96.19 545.12 96.18 545.13 96.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.2,96.34c-.14-.23-.12-.21-.08-.16l-.35-.52.43.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.46,96.91l.12.16c.15.29.08.2.23.42-.35-.58.02-.09-.33-.67l.08.12s.01.03,0,.03c.19.27-.24-.43-.17-.36.04.04.09.12.13.19l-.07-.15s.07.11.06.1v-.06s0,.02,0,.02c-.05-.09-.13-.24-.16-.3.06.08.03.06.08.13l-.07-.15c.1.15.18.3.15.28.37.57-.08-.15.16.16l.03.08c.21.32.15.2.29.39-.07-.1-.35-.49-.42-.65.03.04.05.06-.01-.06.13.21.11.15.11.13l.17.27c-.04-.09-.12-.22-.19-.35.03.02.16.23.28.4.05.03-.23-.33-.23-.39.08.09.03-.03-.06-.2.07.09.1.17.16.24l-.13-.22s.05.07.07.1c-.04-.09-.17-.27-.2-.35-.18-.3.3.42.11.07.05.08.1.17.17.27-.12-.24-.08-.17-.25-.48l.13.17c-.14-.19-.28-.44-.39-.65-.07-.1-.13-.18-.15-.22l-.07-.16s.09.14.16.25l-.04-.07c.07.09.17.25.26.41-.04-.05-.08-.11-.11-.16.1.17.21.35.31.51-.02-.03-.03-.06-.04-.08.03.04.05.08.07.11.02.03-.02-.03-.06-.1l.2.3-.08-.12.15.17c-.17-.32-.44-.77-.49-.91.14.22.23.36.4.62-.19-.27.05.13,0,.09.03.02.11.15.13.19l-.13-.27c.14.21.11.16.17.24-.28-.42-.16-.29-.23-.43.09.14.18.29.15.26.22.31-.3-.51-.11-.25,0,0-.02-.01.03.06-.07-.13.01-.04.09.08h0c.06.04.08-.04-.15-.4.03.05.28.43.32.5l-.75-1.22c.2.31.69,1.02.79,1.21.03.04.08.09.02-.03-.03-.04-.3-.43-.31-.47.25.33.13.17.34.45-.05-.06-.36-.54-.34-.53.05.07.31.47.34.52l-.29-.48c.05.09.26.4.36.53-.06-.09.03,0,0-.06l-.08-.1c.07.05-.41-.67-.37-.67.06.1.39.6.44.65-.15-.24-.75-1.17-.85-1.37l.1.13-.09-.17c.23.37.71,1.15.89,1.45.08.1.11.16.12.14.09.12.12.2.12.21l.09.06c-.19-.28-.16-.3-.32-.53l.16.31c-.19-.28-.51-.81-.46-.77.07.11.33.5.39.59-.06-.1-.1-.2-.05-.13l.09.16c.08.1-.23-.38-.03-.13.02.01.26.35.15.18-.22-.32-.89-1.29-1.05-1.53.02.02.23.29.35.44.17.25.4.59.55.81-.05-.08-.11-.17-.13-.2.05.06.16.24.15.19-.19-.28.04,0-.16-.24-.04-.09.05.05.06.03-.13-.18-.41-.63-.46-.71.05.07.12.16.15.2.04,0,.14.13.17.11.05.07.12.14.2.26-.03-.05-.09-.15-.09-.16.18.23.01.05.22.33-.11-.16-.14-.24-.2-.35-.18-.25-.06-.03,0,.08-.24-.35-.48-.72-.57-.9-.04-.1.16.22.13.17.08.04-.39-.62-.19-.39.17.21.31.44.42.59.04.09-.12-.12-.13-.11l.09.1c.05.08.08.14.02.08.15.19.09,0,.24.16-.05-.08-.09-.16-.16-.24v.04c-.12-.17-.14-.26-.21-.33-.08-.13-.2-.34-.12-.25l.18.25c-.05-.07-.12-.14-.07-.06-.07-.12.26.32.04-.01l-.13-.17c-.08-.13-.25-.41-.18-.34-.19-.24.02.03-.2-.25.26.35-.05,0,.24.38-.25-.33-.12-.13-.33-.41.06.08.12.15.08.12.02.02.04.06.05.07h0s0,0,0,0c0,.01.01.02,0,0,.03.04.06.08.09.12.13.19.11.2.17.3-.03-.03-.06-.1-.13-.18l.09.15c-.13-.18-.23-.29-.29-.41h-.02c-.08-.09-.12-.13-.07-.05-.03-.04.13.22.03.07l.06.13-.03-.05s.17.34-.09.02c.02.05.06.11,0,.07l-.11-.16c.03.06-.14-.14-.03.03-.31-.42-.11-.06-.18-.13l.14.21s0,.06.05.16l.13.18c.09.16-.12-.11-.13-.08-.05-.07-.03-.06,0-.02-.31-.4.16.34-.07.05.04.07.02.05-.01,0,0,0,0,0,0-.01h0s-.05-.07-.07-.09c.03.04.06.08.07.1,0,0,0,.03.03.08l-.14-.2h0c-.06-.06.06.1.16.25.02.03.04.08.07.13-.22-.32.06.12-.18-.22.11.17.05.15.28.5-.03-.05-.05-.07-.05-.07-.03-.04-.07-.07,0,.03l-.17-.25.21.35c-.11-.15-.18-.24-.3-.44.17.32.06.12.24.44l-.11-.17s.13.24.04.11c-.22-.3-.11,0-.33-.26.32.48-.16-.21.08.17-.08-.11-.12-.18-.18-.28.05.13-.15-.16.04.16-.07-.12-.11-.17-.15-.24.01.03.06.1.01.04-.05-.07-.06-.1-.09-.15,0,.03.22.39.43.73-.11-.15-.1-.13.03.1-.07-.11-.15-.22-.17-.27-.02-.01-.15-.13.02.14-.05-.07-.02-.01,0,.02-.03,0-.04-.03-.04,0l.03.04c.2.33.03.08.04.13l-.02-.03c-.18-.22.06.12-.14-.13l.13.2c.27.44-.19-.24-.1-.06l.08.11c.08.16-.4-.58-.44-.63-.03-.04-.03-.06-.05-.09-.18-.24.16.27.18.34-.09-.14-.22-.37-.25-.39-.08-.11.25.49.07.22.07.11.14.22.19.31.01.05-.29-.4-.09-.04l-.06-.09c.05.1.06.17.17.36-.44-.7.15.38-.25-.27v.05s-.05-.07-.05-.07c-.05-.03.04.13.13.29-.03-.04-.06-.1-.09-.14-.11-.11-.09-.09.08.26l-.13-.21c.07.13-.24-.31-.12-.04-.01-.02-.04-.07-.05-.1.12.27-.42-.55.02.24l.09.2c.06.04.19.34.28.46.02.05-.17-.22-.18-.27l.02.04c-.23-.41-.12-.12-.28-.4-.04.05-.22-.14-.28-.13l.19.31h-.03c-.05-.08-.15-.25-.13-.25-.11-.18.07.16.1.23-.1-.11-.2-.38-.21-.38v.03s.03.04.03.04c.07.13.14.27.12.27-.05-.06-.12-.19-.13-.2-.01-.02-.02-.03-.01,0h-.04s.15.23.15.23c.06.13-.03,0,.14.28-.26-.43-.17-.11-.26-.24.09.19.07.2.04.18.03.05.19.33.16.31-.32-.59-.17-.24-.41-.65.17.27,0,.09.23.48-.04-.04-.12-.22-.21-.35.1.24-.14-.11-.14-.02.04.08.11.19.17.31l-.23-.38s.24.45.08.19c.04.06.09.16.1.19-.27-.34.02.39-.43-.29.09.15.09.16.09.17.02.03.1.19.16.3l-.18-.28c.15.3-.02.04.12.32l-.02-.06c.16.34.4.73.62,1.15-.18-.38.33.53.07-.02.05.08.07.14.12.24-.09-.19-.1-.23-.04-.15l.02.05c.02-.07.13.1.24.2l-.12-.21s.06.09.09.14c-.16-.32-.04,0-.21-.36.24.42.07-.03.34.45.02,0-.13-.24-.12-.24l.07.13-.09-.17s.12.18.18.29c0-.01.01.03.01.05.1.15,0-.07.04-.02l-.06-.07c-.03-.14.12,0,.01-.29l-.06-.1c-.07-.2.08.09.07,0v.02c-.04-.1-.05-.15-.04-.15.06.12.14.21.2.35-.08-.21-.07-.16-.25-.54l.1.16c-.07-.15-.12-.23-.12-.28.06.15.15.24.24.43.23.33-.15-.39.16.12-.24-.46-.17-.23-.21-.33-.09-.14-.18-.34-.14-.3.02,0,.34.56.36.54v.03c.09.11-.06-.17.06.01-.15-.27.03,0-.17-.34l.02.09c-.04-.1-.25-.51-.12-.33.04.07.08.17.11.22.06.1-.03-.07.04.03.2.34.01.09.15.36.09.14-.11-.27.09.11-.26-.48.06.04-.13-.33l.12.21s-.07-.13-.06-.13l.14.27c-.12-.24.14.18.09.05-.03.02-.15-.24-.25-.39-.12-.3.33.53.32.4.01.03-.09-.11-.14-.21.03.04.09.11.16.22,0-.06-.13-.21-.19-.34.15.24-.05-.11-.08-.2l.12.21c.11.12-.25-.44-.12-.29l.16.3-.03-.08.14.24c-.09-.19-.06-.14,0-.09-.09-.14-.22-.38-.21-.39.08.12.11.2.11.16.07.13.16.3.04.11.04.07.07.13.11.2.09.14.05.02.05.01,0,0-.02-.02-.04-.04l-.14-.3c.05.08.08.14.12.2,0-.03-.06-.12-.06-.15.1.17.2.34.24.43l-.08-.2c.05.07.13.19.17.26.07.09-.16-.35-.06-.23-.02-.03-.03-.07-.05-.09.04.03.18.22.07-.02l.19.29c-.02-.08-.25-.37-.29-.5-.04-.11.16.25.22.33-.08-.16-.25-.48-.08-.24.03.06,0,.02,0,.04ZM544.6,96.64s.1.18.02.06c-.14-.24-.07-.13-.02-.06ZM544.6,95.95c.04.07.01.04-.04-.04,0-.02,0-.01.04.04ZM544.49,94h0c-.06-.06-.04-.03,0,0ZM544.56,94.08l-.06-.08c.03.05.03.06.02.05.04.05.06.08.04.04ZM542.77,95.33l.03.05c.03.06,0,0-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.74,96.25s-.05-.07-.07-.11c.02.04.05.07.07.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "544.4 97.09 544.39 97.09 544.42 97.13 544.4 97.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.46,95.94s-.05-.06-.08-.1c.03.05.06.09.08.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.41,93.68l.03.06s.03.03.06.06c-.03-.05-.08-.11-.08-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.38,94.83s0,0-.01-.03l-.07-.09s.05.09.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.89,94.33c.12.16.09.1.07.07h0c-.16-.23-.12-.15-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.96,94.39s0-.02,0,0c-.07-.09-.02-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.51,93.95s-.15-.21-.1-.15c-.15-.21.16.27.1.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.29 94.87 545.14 94.66 545.25 94.83 545.29 94.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.12,94.76l.05.05s-.04-.06-.05-.07c-.01,0-.05-.04,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.12,94.74s0,0-.01-.04c0,0,0,.01.01.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.31 94.94 545.28 94.9 545.26 94.89 545.31 94.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.96,94.81l.03.07c.05.07.08.11.07.08-.03-.05-.04-.08-.09-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.39,95.35s-.07-.09-.12-.15l.18.25-.06-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.39,95.44c.05.07.12.22.13.19-.05-.07-.07-.14-.13-.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "544.96 95.26 544.96 95.25 544.67 94.83 544.96 95.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.45,96.39c.09.09-.17-.26-.07-.15-.06-.1-.08-.09-.14-.18.06.11.01.06.21.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.25,96.06s-.02-.04-.04-.07c.02.03.03.05.04.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "541.99 95.46 541.93 95.37 542.02 95.52 541.99 95.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M542.15,95.81l-.15-.29.13.26s-.01-.04.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.97,97.18l-.04-.07c-.05-.07-.05-.07-.06-.08l.11.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "544.69 97.07 544.69 97.07 544.54 96.82 544.69 97.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.75,97.47s-.02-.05,0-.05c.02.05-.19-.27,0,.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M546.06,107.28s-.05-.19-.06-.22c0,.05.07.27.06.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "546.05 107.78 546.03 107.7 546.07 107.9 546.05 107.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.92,107.81c.11.34.03-.07.09.05l.03.08-.07-.28c-.02.05,0,.24-.05.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.65,107.09c.04.13.02.12.03.04,0-.01,0-.02-.01-.03,0,0,0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.66,107.09s-.04-.11,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.62,107.18l-.02-.12c-.03-.08-.05-.09-.06-.15,0,.07.03.15.07.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.67,107.44v-.05s-.02-.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.66,107.27v.11c.03.05.06.17,0-.04.03.1,0,0,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.68,107.32c.03.07.06.12.07.24.02-.06-.05-.3-.07-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M546.02,108.17l.04.1-.02-.12c.01.06-.05-.09-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.46,107.03c.02.07.06.19.09.29v-.09s-.06-.09-.09-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.55,107.32l.02.13s0-.05-.02-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.78 107.82 545.74 107.55 545.77 107.83 545.78 107.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.38 107.05 545.34 106.87 545.4 107.13 545.38 107.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.34,107.09c-.03-.14-.08-.23-.09-.32,0,.03.02.15.04.26,0-.06.01-.05.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.31,107.19s-.02-.1-.03-.16c0,.03.01.08.03.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.52,107.42s-.05-.16-.07-.2l.07.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.51,107.43h0s-.02-.01-.02-.01c0,0,0,0,.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.52,107.43h0s0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.67,107.65c.02.12.03.25.1.42-.03-.14-.07-.24-.1-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.6,107.68l.03.04c-.02-.05-.04-.13-.05-.19l.02.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.61 107.75 545.6 107.68 545.59 107.66 545.61 107.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.4,107.37c.02.09,0,.1,0,.12.02.04.04.06.05.05-.02-.06-.04-.18-.05-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.46,107.42h0s0,.04,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.29 107.52 545.3 107.56 545.29 107.52 545.29 107.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.46,107.58s.01-.01,0-.08c0,.02,0,.04-.01.04,0,.03.01.05.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.3,107.3s.03.08.05.11c-.02-.06-.06-.16-.05-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.44,107.38h0c-.02-.05,0-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.44,107.38s.01.08.02.13c0-.02,0-.04,0-.07,0-.01-.01-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.62,108.85c-.05-.19-.08-.37,0-.17-.02-.15-.21-.77-.32-1.12.02.08.04.16.05.28.04.1.11.23.14.41,0,.11-.04-.06-.08-.16.08.23.06.35.16.7v-.13c0,.05.02.14.04.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.34,107.57v-.03s-.05-.1-.1-.25c.01.1.03.17.05.23l.05.02v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.38,107.53c.05.21.06.3.13.52.02-.02-.03-.18-.04-.27-.03.06-.02-.12-.08-.23,0-.04,0-.05,0-.06-.01-.02-.03-.05-.05-.09h0s0,.01,0,.01h0s.01.04,0,.03h0s.01.06.02.08c-.02-.04-.02-.05-.02-.08v-.03s0,0,0,0v.12s.02.02.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.88,108.52s-.01-.03-.01-.05c0,.03,0,.04.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.83,108.4s-.03-.11-.01-.09c.03.06.03.1.05.17,0-.06-.02-.15-.07-.25v.03c-.03-.07-.12-.32-.13-.35.06.18.1.32.16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.62,108.02v.11s.06.17.06.17l-.03-.11s-.01-.09-.03-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.25 107.42 545.2 107.2 545.26 107.51 545.25 107.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.22 107.46 545.17 107.27 545.19 107.38 545.22 107.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.36,110.49v.06s0-.06,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.44,110.49l-.02-.09c.01.05.02.09.02.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.14,107.77c-.06-.17-.15-.45-.09-.23l.06.21s.01-.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.74,109.21l.02.06c-.02-.07-.03-.14-.04-.2,0,.04.01.09.02.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.96,110.08l-.06-.13s.04.09.06.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.02,110.82l.04.22s-.02-.11-.04-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.79,107.65c-.04-.08-.05-.11-.07-.12.05.12.11.29.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M542.81,108.26s.01.08.03.13c0-.04-.01-.08-.03-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.69,107.55s.01.03.02.05c0-.04,0-.07.02-.06-.04-.09-.06-.14-.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M541.53,111.03s0-.01,0-.02c0,.03,0,.03,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M540.58,109.02s0-.02.01-.02c0-.01-.01-.01-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.02,107.41s0-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.29,108.23s.01.05.02.1c-.01-.05-.02-.08-.02-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.95,108.87h0s.01.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.06,107.5s-.02-.04-.03-.06c0,.02.02.03.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.03,107.41s.01.01.01.02c0-.04-.02-.06-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.01,107.43s.01,0,.02.02c0-.01,0-.03-.01-.03,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M542.16,110.26s0-.01,0-.02c.01.09.01.07,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "544.49 110.01 544.49 110 544.49 109.99 544.49 110.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.5,110.17c-.06-.26-.04-.23-.01-.18l-.17-.6.19.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.21,110.6l.07.18c.05.32,0,.22.1.48-.17-.66.08-.09-.09-.75l.05.13s0,.03,0,.03c.11.31-.1-.48-.04-.4.03.05.06.14.07.22v-.17s.03.12.02.11l.03-.06v.02c-.01-.11-.04-.27-.05-.34.04.09.01.07.04.15l-.02-.17c.06.17.08.34.05.32.2.65-.02-.17.13.2v.09c.11.37.09.23.18.45-.04-.12-.21-.57-.23-.74.02.05.04.07.02-.07.06.23.06.17.08.15l.08.31c0-.09-.05-.25-.07-.39.03.02.1.26.16.46.05.04-.13-.38-.1-.45.06.11.05-.02.03-.22.05.1.05.19.08.28l-.05-.25s.02.08.03.12c0-.1-.08-.31-.08-.4-.08-.34.18.48.11.09.03.09.05.19.08.31-.03-.26-.01-.19-.07-.54l.08.19c-.08-.23-.13-.51-.17-.74-.04-.11-.07-.21-.09-.25v-.18s.04.16.06.29v-.08c.03.11.07.29.11.47-.02-.06-.04-.12-.06-.19.04.19.09.4.14.58,0-.04-.01-.07-.01-.09.01.05.02.1.03.13.01.03,0-.04-.02-.12l.1.34-.03-.14.11.2c-.06-.36-.16-.88-.15-1.03.05.26.11.41.19.71-.1-.31,0,.15-.05.09.02.03.06.17.07.22l-.03-.3c.06.25.06.18.1.28-.14-.48-.05-.33-.07-.49.05.16.08.33.05.3.13.36-.12-.58,0-.28,0,0-.02-.02,0,.06-.02-.15.04-.04.07.1h0c.06.05.13-.03.02-.44.01.05.13.5.15.58l-.3-1.4c.09.35.34,1.19.36,1.4.02.05.05.1.04-.03-.02-.05-.15-.5-.15-.54.13.39.07.21.2.53-.03-.07-.17-.63-.15-.62.02.08.14.55.16.6l-.11-.55c.02.1.12.46.17.61-.03-.11.04,0,.03-.06l-.05-.12c.07.07-.16-.77-.11-.76.03.11.17.69.22.76-.07-.28-.32-1.35-.34-1.57l.05.16-.02-.19c.09.42.27,1.32.35,1.67.05.12.06.19.08.17.05.15.05.23.04.24l.09.08c-.09-.32-.04-.34-.12-.61l.03.35c-.09-.32-.21-.93-.16-.88.05.13.15.58.18.69-.02-.11-.02-.22,0-.15l.03.18c.06.12-.08-.44.03-.14.02.02.14.41.09.22-.12-.37-.43-1.51-.5-1.79.01.02.15.34.21.52.1.29.17.7.25.94-.02-.09-.04-.2-.05-.24.03.07.07.28.08.23-.09-.33.05.02-.07-.28,0-.1.04.06.06.04-.07-.21-.18-.73-.18-.83.02.08.06.19.07.24.05.02.12.16.16.15.03.08.07.17.1.31-.01-.06-.04-.17-.02-.18.1.28-.02.05.1.39-.05-.19-.04-.27-.05-.4-.09-.29-.06-.05-.04.08-.11-.41-.2-.84-.21-1.04,0-.11.09.26.08.2.08.05-.14-.72,0-.45.09.25.14.52.2.7,0,.11-.09-.15-.1-.14l.06.12c.01.09.01.16-.02.09.08.23.12.02.23.22-.02-.09-.03-.18-.06-.29v.04c-.08-.21-.06-.3-.1-.39-.02-.15-.06-.39,0-.28l.09.29c-.02-.09-.07-.17-.05-.08-.02-.13.16.39.06,0l-.08-.2c-.02-.15-.08-.47-.03-.39-.09-.29,0,.04-.11-.3.13.42-.07,0,.08.44-.13-.39-.08-.16-.2-.49.03.1.06.18.03.14,0,.03.01.07.02.09h0s0,0,0,0c0,.01,0,.02,0,0,.02.04.03.09.05.15.05.23.01.23.03.35-.03-.04-.03-.11-.06-.22l.03.18c-.06-.22-.13-.35-.14-.49h-.03c-.05-.12-.09-.16-.07-.07-.03-.04.03.25,0,.08v.15s-.02-.05-.02-.05c-.05-.02.01.38-.15,0,0,.06,0,.13-.04.07l-.06-.19c0,.07-.11-.17-.06.02-.16-.5-.12-.09-.18-.17l.07.24s-.03.07-.03.17l.06.22c.02.18-.1-.14-.13-.11-.02-.08,0-.06.02-.02-.18-.48,0,.38-.14.04.01.08,0,.06-.03,0,0,0,0,0,0-.01h0s-.03-.08-.05-.11c.02.05.04.09.04.11,0,0-.01.04,0,.09l-.07-.23h0c-.03-.08.02.12.07.29,0,.04.01.09.02.14-.11-.37,0,.13-.12-.26.05.2-.02.16.09.57-.01-.05-.03-.08-.02-.08-.03-.04-.05-.09-.03.03l-.09-.29.08.4c-.07-.18-.1-.28-.15-.51.05.36,0,.14.06.5l-.05-.19s.04.27-.01.12c-.13-.36-.15-.01-.32-.33.17.56-.1-.24.01.19-.04-.13-.07-.2-.09-.32,0,.14-.11-.2-.04.18-.03-.13-.05-.2-.07-.28,0,.03.02.12,0,.04-.02-.08-.02-.11-.03-.17-.03.03.07.44.17.83-.07-.18-.07-.15-.02.11-.04-.12-.09-.25-.08-.3-.02-.01-.13-.16-.05.15-.03-.08-.02-.02-.02.02-.03-.01-.04-.04-.07,0l.02.05c.09.38,0,.09-.01.14v-.04c-.13-.25,0,.13-.13-.16l.06.23c.13.5-.12-.28-.1-.08l.05.13c.03.17-.23-.67-.26-.72-.02-.04-.01-.07-.02-.1-.12-.28.07.31.06.38-.05-.16-.1-.42-.13-.44-.05-.13.08.55-.04.24.04.12.08.25.09.35-.01.05-.19-.46-.11-.06l-.03-.1c0,.11-.01.19.03.4-.23-.8,0,.42-.2-.32l-.04.05-.02-.08s-.01.14.02.32c-.02-.05-.03-.12-.04-.16-.09-.14-.09-.1-.03.28l-.07-.24c.02.14-.17-.36-.15-.06,0-.03-.02-.07-.02-.11.02.3-.31-.63-.1.25l.02.23c.07.06.09.38.15.52,0,.06-.12-.25-.11-.3v.04c-.09-.46-.09-.15-.17-.46-.09.05-.25-.18-.34-.18l.1.35h-.04c-.03-.09-.08-.29-.06-.28-.06-.2,0,.18.02.25-.08-.13-.09-.42-.1-.42v.03s0,.04,0,.04c.02.15.06.3.03.29-.03-.07-.06-.22-.07-.23,0-.02-.01-.04-.01,0l-.05-.02.09.28c.02.14-.04,0,.06.31-.15-.48-.19-.14-.25-.28.03.21,0,.21-.03.2.02.06.11.37.07.34-.16-.65-.12-.27-.26-.73.1.3-.05.1.09.53-.03-.05-.06-.24-.12-.39.01.27-.15-.13-.2-.03.02.09.06.21.08.34l-.14-.42s.11.5.02.21c.02.07.05.18.05.21-.23-.38-.17.41-.49-.34.06.16.05.18.04.19.02.04.05.21.08.33l-.13-.31c.07.32-.05.04.02.35v-.06c.07.37.23.8.35,1.26-.08-.42.22.59.11,0,.03.09.03.15.06.26-.04-.2-.04-.25,0-.16v.05c.06-.07.14.12.25.23l-.06-.23s.04.1.07.15c-.07-.35-.05,0-.13-.4.14.46.11-.02.26.5.02,0-.07-.26-.05-.27l.04.14-.04-.19s.08.2.11.33c0-.01,0,.04,0,.05.06.16.04-.07.06-.02l-.05-.08c.03-.15.16.01.15-.29l-.03-.11c0-.21.07.11.1,0v.03c-.01-.11-.01-.17,0-.16.02.13.09.24.11.38,0-.23-.02-.18-.08-.59l.05.18c-.03-.17-.05-.25-.04-.31.02.16.09.27.11.48.16.38-.02-.42.15.15-.1-.5-.12-.26-.13-.37-.05-.16-.07-.38-.04-.33.02,0,.19.63.24.61,0,0,0,.04,0,.04.05.12-.01-.18.06.02-.07-.3.03.01-.06-.37l-.02.1c0-.11-.1-.56,0-.35.02.08.03.18.04.24.04.11,0-.08.04.03.1.38-.03.1.02.4.05.16-.02-.29.07.13-.12-.53.06.05-.01-.36l.06.23s-.02-.15-.01-.15l.06.3c-.04-.26.1.21.09.06-.05.02-.08-.27-.15-.44-.02-.32.19.59.23.46,0,.04-.07-.13-.08-.24.03.04.07.13.1.25.03-.06-.07-.23-.08-.38.09.28,0-.12-.01-.21l.06.23c.09.14-.11-.49-.02-.32l.06.33v-.09s.07.27.07.27c-.02-.2,0-.16.04-.09-.05-.16-.11-.42-.09-.44.05.13.05.22.07.18.03.15.07.33,0,.12.02.08.03.15.05.22.06.16.05.03.06.02,0,0-.02-.02-.03-.05l-.04-.34c.03.09.04.16.05.23,0-.03-.02-.14,0-.16.05.19.1.39.1.48v-.22c.01.08.07.22.08.29.05.1-.03-.38.04-.25,0-.04-.01-.07-.01-.1.04.03.13.26.1-.01l.11.33c0-.08-.14-.42-.13-.56,0-.12.09.29.13.38-.03-.18-.09-.53.01-.26,0,.07-.01.02-.02.05ZM543.52,110.35c0,.05.03.21,0,.07-.06-.27-.02-.14,0-.07ZM543.91,109.65c.02.08,0,.04-.04-.04,0-.02.01-.01.04.04ZM544.97,107.63h0c-.04-.08-.02-.04,0,0ZM545.03,107.72s-.01-.07-.03-.1c.01.06,0,.06,0,.05.02.06.03.1.03.05ZM541.66,108.72l.02.06c0,.07,0,0-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.94,109.98s-.02-.08-.04-.13c0,.04.02.09.04.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "543.02 110.78 543.01 110.78 543.02 110.82 543.02 110.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.08,109.83s-.03-.07-.05-.12c.02.06.03.1.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.08,107.28v.07s.02.04.04.07c-.02-.05-.04-.13-.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.66,108.67s0,0,0-.03l-.03-.11s0,.1.03.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.32,108.05c.06.19.05.12.05.09h0c-.07-.27-.06-.18-.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.37,108.13s0-.02.01,0c-.03-.11-.01-.02-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.03,107.58s-.07-.25-.04-.17c-.06-.25.04.31.04.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.51 108.69 545.43 108.45 545.48 108.65 545.51 108.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.35,108.54l.04.06s-.02-.06-.02-.08c-.02,0-.04-.05-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.37,108.52s.01,0,0-.04c0,0,0,.01,0,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "545.5 108.77 545.48 108.72 545.45 108.71 545.5 108.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.09,108.56v.08c.01.08.04.13.04.1,0-.06,0-.09-.04-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.35,109.2s-.03-.1-.06-.18l.08.3-.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M545.29,109.29c.02.08.03.25.06.22-.02-.08-.01-.16-.06-.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "544.81 109.01 544.82 109.01 544.68 108.52 544.81 109.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.8,110.28c.06.11-.08-.31,0-.17-.02-.12-.05-.11-.07-.22.02.13-.01.06.08.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M544.72,109.9s0-.04-.01-.08c0,.03,0,.06.01.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "540.45 108.77 540.4 108.67 540.46 108.84 540.45 108.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M540.5,109.15l-.08-.31.06.29s0-.04.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.74,110.97l-.02-.08c-.02-.08-.03-.09-.04-.1l.06.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "543.42 110.81 543.43 110.81 543.34 110.53 543.42 110.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M543.3,111.23s0-.06.02-.05c0,.06-.11-.31-.02.05Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.56,11.5c-.03-.05-.16.11-.19.13.11.04.23-.17.19-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "9.61 11.82 9.54 11.87 9.78 11.81 9.61 11.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.28,12.43c.17-.33-.28-.18-.32-.38l.03-.08-.25.17c.18.1.49.13.53.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.15,13.34c.07-.13.16-.02-.06-.11,0,.02,0,.03,0,.04.02.01.04.03.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.09,13.27c-.08-.05-.03.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.49,13.49l-.18.02c-.03.08.05.17-.02.19.15.03.18-.05.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.75,13.36h-.08s0,.05.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.48,13.36h.18c.02-.05.09-.14-.08,0,.08-.07-.01-.01-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.45,13.27c0-.1-.05-.2.13-.21-.22-.11-.35.1-.13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.55,12.18v-.14s-.14.04-.14.04c.07-.02.07.19.14.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11,14.14c.05-.05.09-.19.14-.27h-.13c0,.08.05.18-.02.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.14,13.87h.19c-.09-.1-.15-.07-.19,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "11.01 13.07 10.66 13.14 11.05 13.1 11.01 13.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "11.41 14.48 11.24 14.57 11.52 14.45 11.41 14.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.72,14.67c-.14.08-.08.24-.19.28.1.04.24-.02.36-.06-.1,0-.16-.06-.18-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.1,14.83c-.05,0-.12.03-.2.06.05,0,.12-.02.2-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.49,14.03s-.08.15-.05.24l.09-.2-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.54,14.06h0s.07.08.09.09c-.01-.01-.04-.04-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.48,14.02h.01s.01-.02-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.18,13.45c.14-.04.35-.04.34-.28-.14.08-.13.22-.34.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.59,13.77l-.09-.13s-.06.13-.13.15l.22-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "11.69 13.76 11.59 13.77 11.63 13.82 11.69 13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.01,14.52c.11-.04.17,0,.24.03-.04-.08-.1-.15-.17-.2-.05.05-.15.12-.07.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.79,14.29h.02s0-.03-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "12.89 15.01 12.9 14.97 12.88 15 12.89 15.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.1,14.31c-.03-.07-.09-.05-.16-.02.05.01.1.03.15.06.02-.02.04-.04.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.34,14.88c0-.06,0-.11-.02-.16-.01.07-.02.2.02.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.79,14.35h-.01c-.01.05,0,.03.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.79,14.35s.1-.03.15-.05c-.04,0-.08-.01-.13,0,0,.02-.01.04-.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M13.87,14.03c-.12.16-.36.21-.35-.05-.2.04-.5.62-.61.99.05-.07.1-.13.29-.14.02-.12-.12-.4.09-.47.21.03.09.15.1.29.08-.25.4-.15.58-.47h-.21s.13-.08.12-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.68,14.79l-.06-.02c.04.07.03.16.01.34.14-.02.2-.07.24-.12l-.23-.2h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.4,14.62c.17-.15.34-.14.4-.38-.15-.09-.21.07-.35.09.26.12-.14.05-.04.27-.07,0-.11-.02-.16-.04.03.05.05.11.06.17v-.02s0,0,0,0h0s.01-.05.01-.03h0s.04-.04.06-.06c.04.08-.02.05-.06.06l-.02.02h0s.3.08.3.08c-.03-.06-.1-.1-.22-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.92,12.9s-.01.03-.02.04c.03,0,.05-.02.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.93,13.08s-.1.07-.14,0c0-.09.06-.08.11-.14-.07.02-.2.03-.17.19h.03c.04.12,0,.42-.04.43.09-.17.15-.3.21-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.19,13.81l.25.05v-.22s-.05.09-.05.09c-.08-.11-.14.01-.21.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "12.85 15.12 12.69 15.28 12.99 15.1 12.85 15.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "13.11 15.28 12.99 15.43 13.13 15.38 13.11 15.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.23,21.62h.09s-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.8,21.37l-.06.08s.07-.07.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M19.57,19.18c0,.21-.04.52.06.31l.08-.21c-.08,0-.12-.05-.13-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M24.68,20.45v-.07c-.05.05-.1.1-.15.15.05-.02.1-.05.15-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.16,19.69l.05.19c0-.06-.02-.12-.05-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.72,22.81l.18-.15c-.11-.07-.12.06-.18.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M15.81,16.94c.03.12.07.18.12.23-.03-.16,0-.36-.12-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.94,23.54c.06-.01.09-.04.12-.09-.06.01-.1.04-.12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M16.14,17.29s0-.04-.01-.07c-.07,0-.14-.01-.2-.06.02.12.06.21.22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.55,28.99s0,.02,0,.03c.02-.02.01-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M40.63,32.41s-.08-.03-.12-.05c.01.02.05.04.12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M14.1,16.05c-.06-.02-.02.01,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M14.31,15.16s.05-.03.08-.07c-.03.04-.06.06-.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M17.39,16.47h0s0-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M14.07,15.91s.02.07.03.1c0-.02-.01-.05-.03-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M14.02,16.01s-.03-.04-.04-.05c-.03.03-.03.05.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M14.18,16.09s-.06-.05-.08-.08c0,.02,0,.03,0,.04.02,0,.04.02.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.15,26.03s0,.01,0,.02c.11-.03.08-.04,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "22.12 18 22.1 18.01 22.11 18.02 22.12 18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M22.39,17.97c-.21.19-.25.14-.29.05l-.23.59.51-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.3,22.17l-.04-.25c.33-.18.4-.01.41-.32-.36.58-.59-.26-.95.32l-.02-.18s.05-.01.07.01c-.02-.39-.38.35-.56.13-.06-.09-.07-.21.03-.25l-.27.05s.02-.14.07-.1l-.31-.11v-.02c-.08.07-.25.17-.33.2-.02-.12.07-.04.09-.13l-.23.06c.02-.19.23-.27.33-.19.18-.67-.21.08-.33-.44h.19c.09-.38-.09-.33-.14-.63-.02.13.04.71-.21.77-.02-.07-.07-.13-.23-.06.11-.21,0-.21-.12-.26l.16-.28c-.16.02-.23.16-.37.25-.12-.1-.03-.33.04-.53-.19-.16-.04.43-.32.35-.12-.2-.31-.15-.61-.1-.07-.16.11-.16.11-.27l-.23.17s.02-.08.04-.12c-.14.04-.16.28-.35.28-.21.29-.06-.61-.43-.36,0-.1.11-.16.16-.28-.37.1-.3.05-.67.26l-.07-.28c.01.28-.28.44-.53.58,0,.13-.02.24-.01.29l-.31.03c0-.06.07-.15.17-.24-.03.02-.05.03-.08.05-.03-.15.1-.29.24-.42,0,.07,0,.14-.01.22.15-.14.3-.3.38-.48-.03.02-.08.04-.12.04.04-.04.07-.08.08-.11,0-.03-.05.02-.12.07l.12-.34-.08.12-.19-.35c-.38.2-.81.57-1.22.52.21-.19.22-.37.37-.64-.06.34.33.02.47.17-.08-.08.01-.2.06-.23l-.45.1c.13-.22.02-.2,0-.34-.17.48-.39.17-.59.24.07-.15.18-.29.32-.17,0-.42-.5.4-.51.03.04.02.05.05.1-.02-.16.08-.32-.13-.2-.24l.04.02c-.22-.19-.76-.41-1-.06.02-.05.28-.43.33-.5l-1.12,1.02c.21-.3.47-1.15.78-1.22-.03-.08-.08-.17-.27-.12.02.07-.15.52-.22.52.04-.44,0-.25-.02-.65.02.1-.32.57-.4.5.06-.07.26-.5.32-.53l-.51.36c.11-.06.24-.41.26-.58-.03.11-.2-.12-.29-.11l.04.17c-.23-.22-.65.55-.9.38.09-.08.43-.58.32-.72-.2.22-.95,1.06-1.29,1.12l.03-.17-.27.06c.32-.31,1.09-.93,1.43-1.15-.04-.17.07-.19-.09-.25.02-.16.2-.16.24-.14l-.3-.28c-.15.3-.43.14-.55.4l.55-.09c-.15.3-.68.71-.9.52,0-.15.34-.49.39-.6-.09.08-.34.06-.32-.02l.19-.1c-.07-.19-.44.26-.45-.11-.05-.05.05-.47-.06-.31-.1.39-.67,1.43-.88,1.64,0-.03-.12-.49-.09-.69.06-.31.5-.54.55-.81-.05.08-.16.15-.2.17-.02-.1.17-.23.02-.27-.19.28-.25-.17-.21.21-.18.01-.1-.14-.25-.21-.06.22-.51.57-.69.57.05-.07.08-.18.09-.24-.24-.18-.3-.4-.54-.55.02-.08-.04-.24.08-.33-.07.03-.16.11-.24.07.01-.34.19.06.26-.31-.11.16-.33.12-.5.16-.13.28.21.2.38.16-.22.36-.63.63-.99.64-.26-.03.06-.28,0-.25-.34-.29-.71.42-.86-.03.02-.31.28-.45.36-.63.21.02.15.3.27.37l-.06-.19c.1-.04.24-.03.26.07.03-.27-.59-.44-.75-.82-.1.04-.24.06-.26.18l.11.03c-.04.24-.33.14-.28.3-.2.05-.47.16-.58-.06l.14-.28c-.05.08,0,.22.11.18-.15.07-.03-.51-.33-.23v.25c-.21.05-.55.22-.64.03-.1.3.05,0-.04.36.16-.43.38.27.49-.21-.12.41.09.27.05.66.05-.09.06-.19.16-.07.02-.02.06-.04.08-.06,0,0,0,0,0,.01h0s.02-.03,0-.02c0-.06,0-.12.02-.17.19-.15.39-.01.52-.07.05.09-.1.08-.11.19l.2-.08c-.11.19,0,.45-.25.44l.16.11c.03.17.13.3.26.27.05.09.33-.08.17.02l.33.04-.03.05c.24.18.72,0,.8.52.11,0,.24,0,.35.14l-.07.18c.14,0,.23.37.38.22-.15.53.48.41.63.6l.13-.22c.13.09.29.1.51.11l.1-.2c.23-.08.29.35.53.46-.06.07-.1.01-.12-.06.02.6.75,0,.82.46.1-.04.13.01.15.08,0,0-.01,0-.02,0,0,0,.01.01.02.02,0,.05.01.1.03.15,0-.06,0-.11-.01-.14.05.02.14.04.23.03l-.09.23s.01,0,.02,0c.03.12.11-.07.16-.25.05-.02.11-.04.16-.08-.13.37.25-.01.13.39.14-.15.43.06.67-.29-.02.05-.02.08-.06.07.06.09.11.17.24.1l-.11.29.37-.27c.02.22,0,.34-.21.49.42-.19.27-.01.65-.21l-.1.17c.08.03.33-.13.3.03,0,.42.82.5,1.09,1.04.19-.56.08.34.31-.05-.04.14-.01.24-.14.3.29,0,.23.37.57.12-.04.14-.14.15-.16.24.03-.02.13-.07.11.02-.02.08-.09.08-.15.12.24.1.46-.26.66-.61.03.23.1.24.3.05-.02.14-.02.29-.18.26.07.06.4.43.55.15-.01.08.1.08.14.06.17.11.17.15.36.21l-.02-.07c.25-.3.19,0,.35.04l-.02.03c.19.42.2-.04.37.41l.1-.22c.27-.44.14.42.42.34v-.16c.18-.1-.06.77.01.88,0,.05-.07.04-.12.06.12.41.18-.26.42-.21-.05.17-.25.35-.14.45,0,.16.65-.27.67.11.02-.14.05-.27.19-.31.16.04.14.64.46.35,0,.04,0,.07-.02.1.16-.04.43.04.6-.12-.31.78.86.03.47.69l.34.15-.05.06c.18.16.35.05.51-.07.02.07-.05.11-.07.15.22.31.26.3.71.13l-.1.23c.14-.08.22.59.67.53-.02.02-.05.06-.09.07.49-.05.4,1.06,1.01.38l.33-.05c-.23-.24.26-.3.23-.5.14.03.13.41-.03.36v-.05c-.3.36.25.37.06.63.56.33.91.91,1.37,1.28l.16-.33.16.14c0,.1-.11.27-.22.17-.06.21.3,0,.36-.05.14.29-.35.27-.28.33l.11.05v-.05c.17-.06.28-.18.41-.06.05.12-.09.21-.06.25-.02.02-.01.04.05.05l.18.19.1-.29c.18-.04.18.17.29-.16-.18.51.64.77.62.96.26-.05.38.05.52.2,0-.08.2-.34.3-.19-.49.46.04.43-.17.88.12-.32.43.28.58-.19.07.14-.16.19-.18.38.43.04.47.65.87.87.06-.06.09-.21.25-.25l-.11.49c.1.02.39-.34.32,0,.03-.07.08-.18.14-.16.42.9,1.59.81,1.99,1.96-.03-.21.06-.18.14-.14-.03-.07.11-.19.16-.3.06.16.12.32.18.48.21-.26.39.17.56-.1h-.13c.3-.27.16-.84.4-1.26-.35.3-.07-.74-.59-.35,0-.11.12-.11.15-.22-.16.14-.25.14-.33-.02l.04-.03c-.38-.18-.41-.45-.7-.84l-.11.21c-.06-.09-.03-.16-.04-.23-.31.22.22.19-.11.44.18-.46-.57-.45-.3-.94-.12-.1-.14.24-.26.14l.06-.14-.15.12c-.06-.09.02-.27.1-.37,0,.03.08.02.1.03.01-.22-.33-.2-.33-.27l.06.17c-.42-.17-.69-.68-1.22-.75l-.05.1c-.38-.07-.11-.27-.45-.44h.03c-.13.02-.24,0-.31-.08.16-.04.04-.31.23-.33-.43-.07-.26.01-.72.17l.08-.18c-.17.07-.24.14-.41.05.22-.02.09-.29.36-.34-.04-.56-.71-.06-.47-.63-.46.28.08.44-.07.46-.04.18-.36.2-.42.08-.09-.09.25-.65,0-.84.02.02.05,0,.07.01-.01-.17-.29,0-.28-.25-.25.2-.14-.13-.4.18l.29.1c-.19-.02-.6.26-.67-.07.06-.05.19-.09.27-.1,0-.14-.17-.03-.16-.17.26-.3.33.14.66,0,.03-.18-.44.03-.11-.26-.43.36-.21-.24-.63-.03l.15-.18s-.17.06-.22.02l.27-.18c-.29.11-.14-.39-.35-.37.29.2-.1.28-.09.51-.53,0,.17-.66-.3-.84.07,0,.12.25-.03.29-.05-.09-.1-.23-.07-.37-.29-.14-.1.23-.29.27.07-.3-.2.01-.36.01l.13-.2c-.21-.33-.36.36-.52.03l.3-.2-.19-.02.18-.21c-.27.07-.28,0-.39-.17-.06.17-.26.35-.39.27-.01-.18.17-.16-.03-.26.12-.1.27-.23.23.02.05-.06.12-.1.18-.16,0-.2-.23-.2-.3-.24.02.02.05.05.04.09l-.46.11c0-.1.08-.14.15-.18-.07-.01-.17.06-.26.02.13-.15.23-.33.4-.33l-.38.02c.03-.08-.01-.28.06-.32-.09-.19-.56.1-.68-.15-.03.03-.07.04-.13.04-.16-.15-.2-.46-.56-.36l.05-.37c-.21-.03-.06.48-.41.43-.26-.02.08-.3.05-.43-.19.09-.55.31-.59-.05.09-.02.12.05.19.06ZM28.1,21.1c.07-.02.22-.11.19.03-.18.22-.15.08-.19-.03ZM24.58,19.87c.07-.05.1,0,.11.12-.05,0-.09-.03-.11-.12ZM14.8,16.28s0,0,.01,0c.04.14.03.09-.01,0ZM14.68,16.07s-.05.04-.06.08c.05-.04.09-.02.13.03.02-.06.02-.11-.06-.1ZM34.71,27.72v-.07c.12,0,.06.03,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.1,19.78s-.03.08-.04.13c.04-.03.06-.07.04-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "31.68 22.84 31.69 22.84 31.72 22.81 31.68 22.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M18.61,16.08c.02.05.02.1.01.15.03-.05.04-.1-.01-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M13.47,15.77l.15.03c-.06-.03-.06-.09-.06-.14-.03.05-.05.13-.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M13.32,13.84s-.04-.02-.07,0l-.06.09c.07.04.18,0,.13-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M13.81,15.03c.11-.17,0-.16-.11-.19,0,0,.01,0,.01.01-.18.22-.05.2.09.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M13.68,14.83s-.06-.02-.08-.05c-.07.09.02.04.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M14.37,16.03c-.01-.07-.17.2-.14.12-.19.19.43-.09.14-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "14.12 14.44 14.01 14.66 14.17 14.53 14.12 14.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M14.66,15.01l-.09-.14s-.05.05-.08.05c.08.06.14.16.17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M14.49,14.92s-.08-.05-.13-.03c.02.01.08.04.13.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "14.34 14.49 14.35 14.56 14.43 14.64 14.34 14.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M16.04,15.96l.18.03c.06-.06.05-.13-.02-.14-.07.03-.14.02-.16.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M15.97,15.11c.01.07-.02.12-.04.2l.17-.26-.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M16.43,15.31c.06-.06.34-.08.15-.18-.06.06-.24.04-.15.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "18.41 16.95 18.37 16.93 18.12 17.37 18.41 16.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M20.96,16.98c-.12-.2-.19.25-.28.03-.1.08.07.18-.02.25.17-.05.19.04.3-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M20.66,17.26s-.06.02-.09.04c.05-.01.07-.02.09-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "40.98 32.9 41.06 33.06 41.05 32.86 40.98 32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.39,32.67l-.1.31.2-.23s-.1,0-.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.09,20.36l-.05.06c-.02.08,0,.1.05.15v-.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "29.53 21.43 29.51 21.41 29.41 21.69 29.53 21.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.02,21.85s-.14-.02-.19-.06c.14.02.02.39.19.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M46.85,24.97s.15-.12.18-.14c-.08,0-.22.18-.18.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "46.09 24.89 46.16 24.83 45.95 24.92 46.09 24.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.7,24.49c-.22.29.18.1.16.26l-.05.07.24-.17c-.12-.05-.36-.03-.35-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M46.04,23.73c-.09.11-.13.04.02.08,0-.01.01-.02.02-.03-.01,0-.02-.02-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M46.07,23.78s.06-.11,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.83,23.64l.14-.03c.05-.07.01-.13.07-.15-.1,0-.15.06-.22.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.59,23.77h.07s.02-.05-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.79,23.75l-.14.02s-.12.13.06,0c-.08.07,0,0,.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.79,23.82c-.02.09-.02.16-.16.19.14.07.3-.12.16-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.42,24.72l-.03.11.12-.05c-.06.02-.01-.15-.09-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.62,23.17c-.06.05-.13.16-.19.23l.1-.02c.02-.06.01-.13.09-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.43,23.4l-.15.03c.04.06.1.03.15-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "45.3 24.04 45.59 23.95 45.27 24.02 45.3 24.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "45.4 22.93 45.56 22.84 45.31 22.96 45.4 22.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.23,22.79c.13-.08.14-.21.23-.24-.06-.02-.18.03-.3.07.08,0,.1.04.06.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.99,22.68s.1-.03.17-.06c-.04,0-.09.02-.17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.2,23.3s.11-.13.11-.2l-.13.17.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.18,23.28h0s-.04-.06-.04-.07c0,0,.02.03.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.21,23.31h0s-.02.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.28,23.74c-.12.05-.29.06-.34.26.13-.08.16-.19.34-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.05,23.52l.03.1s.09-.11.15-.13l-.17.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "44.97 23.54 45.05 23.52 45.03 23.48 44.97 23.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.96,22.94c-.09.04-.13.01-.17-.01,0,.07.03.12.06.16.05-.04.16-.11.11-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.05,23.11h-.01s-.01.03.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "44.45 22.58 44.43 22.61 44.46 22.59 44.45 22.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.83,23.11c0,.06.05.04.11,0-.04,0-.07-.02-.09-.04-.02.02-.04.03-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.83,22.66s-.03.09-.04.13c.03-.06.08-.16.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.07,23.07h.01s0-.03-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.07,23.07s-.08.03-.13.05c.03,0,.06,0,.1,0,0-.01.02-.03.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.37,23.43c.15-.13.35-.19.26.03.17-.04.6-.53.81-.84-.06.06-.12.11-.27.13-.06.1-.04.32-.22.39-.16-.02-.02-.12.02-.23-.14.21-.36.14-.61.41h.16s-.13.06-.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.54,22.75h.04s.03-.12.1-.27c-.11.02-.17.06-.22.11l.11.15h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.69,22.88c-.18.13-.3.13-.43.33.09.07.18-.07.29-.09-.16-.09.12-.05.12-.22.05,0,.08.01.11.03,0-.04,0-.08,0-.13h0s0,.01,0,.01h0s-.02.04-.02.02h0s-.04.04-.06.05c0-.07.03-.04.06-.05l.02-.02h0s-.21-.05-.21-.05c0,.05.04.08.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.54,24.26s.02-.03.03-.04c-.03.01-.04.02-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.58,24.12s.1-.06.11-.02c-.02.07-.07.07-.12.12.06-.02.17-.05.19-.17h-.03c0-.09.13-.34.16-.36-.12.15-.21.26-.31.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.59,23.53l-.18-.03-.08.18.08-.08c.03.09.11-.02.18-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "44.52 22.49 44.7 22.35 44.41 22.51 44.52 22.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "44.37 22.37 44.52 22.24 44.4 22.29 44.37 22.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.29,16.09h-.07s.05,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.48,16.34l.08-.06c-.05.02-.08.05-.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.16,19c.09-.17.26-.42.1-.26l-.15.16c.06,0,.06.05.05.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.05,17.5l-.04.06c.07-.04.13-.07.18-.11-.05.02-.09.03-.15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.35,18.07l.05-.16s-.04.1-.05.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M33.99,14.95l-.2.1c.05.06.11-.04.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.97,21.02c.02-.1.02-.15,0-.19-.05.13-.15.3,0,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.11,14.68s-.09.03-.12.06c.05,0,.09-.02.12-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.86,20.72s-.01.04-.02.06c.05,0,.1.01.12.06.03-.1.04-.18-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.15,10.04s0-.02.01-.03c-.02.02-.02.02-.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.74,7.27s.04.03.06.05c0-.02-.01-.04-.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.91,21.76s.02-.01,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.42,22.49s-.05.03-.09.06c.04-.03.07-.05.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.6,21.36h0s-.02.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.88,21.87s.01-.06.01-.08c0,.02-.01.04-.01.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.95,21.79s0,.03,0,.04c.03-.02.04-.04,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.86,21.73s.03.04.03.06c0-.02.01-.03.02-.03-.01,0-.02-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M32.71,12.25s0-.01.01-.02c-.1.03-.07.03-.01.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "38.78 19.75 38.8 19.74 38.8 19.73 38.78 19.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.57,19.75c.24-.14.24-.09.23-.01l.43-.46-.66.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M34.75,15.57l-.08.21c-.32.12-.3-.02-.44.23.52-.43.31.26.84-.18l-.06.15s-.04,0-.05-.01c-.16.31.43-.25.47-.06,0,.08-.05.17-.14.2h.21s-.08.1-.1.06l.17.12h-.02c.1-.04.27-.1.34-.12-.04.1-.07.03-.13.09l.2-.02c-.1.15-.29.19-.32.12-.44.52.19-.04.04.39l-.13-.02c-.24.3-.09.27-.19.52.08-.1.3-.58.5-.6-.02.06,0,.11.14.07-.18.16-.09.17-.03.22l-.24.21c.13,0,.24-.11.39-.17.04.09-.13.27-.27.43.06.15.23-.34.39-.25,0,.18.15.16.39.15-.02.14-.16.12-.2.2l.24-.11s-.05.07-.09.09c.12-.02.24-.21.38-.19.28-.21-.24.5.14.33-.05.08-.16.12-.24.21.31-.04.24-.01.61-.14l-.07.23c.12-.23.41-.33.65-.41.06-.1.12-.19.15-.24h.24c-.03.06-.12.12-.24.19l.08-.03c-.05.12-.21.22-.37.31.03-.06.07-.12.11-.18-.17.1-.36.21-.49.35.03-.02.07-.02.1-.02-.05.03-.09.05-.11.08-.02.03.04,0,.12-.04l-.24.27.11-.09-.02.31c.37-.13.85-.38,1.12-.3-.23.13-.33.28-.56.48.2-.27-.23-.05-.26-.19.02.07-.1.16-.15.18l.37-.03c-.19.17-.11.16-.15.28.34-.37.36-.1.54-.14-.12.12-.26.22-.31.11-.2.34.54-.28.39.03-.02-.02-.01-.05-.08,0,.15-.05.17.14.04.21l-.02-.02c.08.17.37.41.7.14-.04.04-.39.33-.47.38l1.27-.73c-.29.23-.86.89-1.11.92,0,.07-.02.15.14.13.02-.06.34-.41.39-.4-.23.35-.11.2-.27.54.03-.09.48-.44.52-.37-.07.05-.41.39-.47.41l.53-.25c-.1.04-.36.32-.45.45.07-.09.09.12.17.11l.05-.14c.07.2.71-.39.82-.23-.1.06-.56.44-.55.56.24-.16,1.15-.79,1.43-.82l-.1.14.23-.03c-.37.24-1.2.69-1.54.83-.05.14-.13.15-.04.22-.09.13-.21.12-.24.1l.1.26c.24-.24.38-.09.58-.28l-.44.03c.24-.24.81-.53.89-.36-.07.12-.46.38-.54.46.1-.06.28-.03.23.04l-.18.07c-.02.16.44-.18.29.12.01.04-.23.39-.08.26.23-.31,1.09-1.13,1.33-1.29,0,.03-.12.41-.23.57-.17.26-.59.41-.74.63.07-.06.18-.11.21-.12-.03.09-.22.18-.12.22.26-.22.11.16.24-.16.13,0,.02.12.1.19.14-.18.61-.44.75-.44-.07.06-.13.15-.17.19.11.16.07.34.18.47-.05.07-.06.2-.19.27.06-.02.16-.09.21-.05-.14.28-.12-.06-.32.24.15-.13.3-.08.44-.11.21-.23-.08-.17-.22-.14.31-.29.72-.5.99-.5.18.03-.15.23-.09.21.14.25.7-.34.63.04-.13.25-.38.37-.51.52-.16-.02,0-.25-.07-.3l-.02.16c-.09.03-.2.02-.17-.06-.12.22.29.37.27.68.09-.03.2-.05.26-.15l-.07-.02c.11-.19.3-.12.32-.25.17-.04.42-.13.42.04l-.2.23c.06-.06.07-.19-.02-.15.13-.06-.16.43.17.19l.09-.21c.17-.04.49-.19.49-.04.18-.25-.04,0,.16-.3-.27.36-.19-.22-.44.18.24-.34.03-.22.21-.54-.07.07-.11.16-.14.06-.03.02-.06.04-.08.05h0s0,0,0,0c-.01,0-.02,0,0,0-.02.05-.04.1-.08.14-.2.13-.3.01-.42.06,0-.07.1-.06.16-.16l-.18.07c.16-.16.17-.37.35-.36l-.07-.09c.04-.14.01-.24-.1-.22,0-.07-.28.07-.12-.02l-.23-.04.04-.04c-.11-.15-.53-.02-.38-.45-.08,0-.18,0-.2-.12l.13-.15c-.1-.01-.02-.31-.19-.19.32-.42-.18-.36-.21-.52l-.19.17c-.05-.08-.17-.1-.33-.12l-.16.16c-.2.05-.06-.3-.19-.4.07-.05.08,0,.06.05.24-.49-.55-.05-.4-.43-.09.02-.09-.02-.07-.08,0,0,0,0,.02,0,0,0,0-.01-.01-.02.02-.04.03-.09.05-.13-.03.05-.05.09-.05.12-.03-.02-.08-.04-.16-.04l.16-.18s0,0-.01,0c.03-.1-.11.05-.23.19-.05,0-.1.02-.15.05.26-.29-.19,0,.08-.33-.17.11-.28-.08-.62.18.04-.04.05-.07.07-.05,0-.07,0-.15-.13-.1l.21-.22-.39.19c.09-.18.15-.28.37-.38-.39.11-.2-.02-.57.11l.15-.13s-.3.08-.2-.06c.2-.34-.37-.48-.32-.95-.39.44.1-.28-.25.01.09-.11.12-.19.24-.23-.21-.03,0-.32-.35-.15.09-.11.17-.11.22-.18-.03.01-.12.04-.07-.02.05-.07.1-.06.16-.08-.13-.1-.45.17-.76.42.09-.19.04-.2-.2-.07.08-.11.15-.23.25-.19-.02-.06-.09-.39-.33-.18.05-.07-.04-.07-.07-.06-.07-.11-.06-.14-.16-.21l-.02.06c-.32.22-.13-.02-.23-.07l.03-.02c.06-.36-.17.01-.08-.37l-.17.17c-.4.33.09-.35-.14-.32l-.07.13c-.18.06.39-.62.39-.71.02-.04.07-.03.11-.03.1-.34-.25.19-.4.13.11-.13.35-.26.31-.35.07-.13-.6.16-.44-.16-.08.11-.16.21-.28.23-.1-.05.19-.53-.18-.33.02-.03.04-.06.07-.08-.13.01-.3-.07-.5.04.58-.6-.62-.1-.04-.6l-.19-.15.06-.05c-.06-.15-.23-.07-.41,0,.02-.06.09-.09.12-.11-.03-.27-.07-.26-.48-.16l.18-.18c-.14.06.09-.5-.27-.47.02-.02.06-.04.1-.05-.38,0,.15-.89-.6-.38l-.27.02c.08.21-.32.23-.38.39-.09-.03.07-.34.17-.29l-.02.04c.38-.28-.04-.31.21-.51-.28-.3-.34-.77-.57-1.08l-.25.27-.07-.12c.04-.08.19-.22.24-.14.13-.17-.24-.01-.3.04,0-.24.37-.22.34-.27l-.07-.04-.02.04c-.16.05-.28.14-.34.04.01-.1.15-.17.14-.2.02-.02.02-.03-.02-.04l-.08-.15-.18.24c-.16.03-.09-.13-.29.14.31-.41-.26-.6-.19-.76-.23.05-.29-.03-.35-.15-.03.06-.27.28-.3.17.54-.39.1-.34.41-.72-.2.26-.26-.19-.53.19-.02-.11.19-.16.27-.32-.34,0-.17-.48-.41-.64-.07.05-.15.17-.29.21l.25-.39c-.07-.01-.43.28-.25.01-.05.06-.12.14-.17.13,0-.68-.96-.63-.66-1.56-.09.16-.13.14-.17.1,0,.05-.17.13-.26.21l.12-.38c-.29.17-.17-.18-.43,0l.09.02c-.35.16-.57.62-.95.91.4-.18-.32.61.27.37-.05.09-.14.07-.22.16.19-.09.26-.08.25.06l-.05.02c.21.19.13.41.22.74l.17-.17c.02.07-.03.13-.06.19.33-.16-.1-.16.25-.35-.32.37.29.38-.09.77.06.08.19-.2.26-.11l-.1.11.17-.1c.02.07-.1.22-.2.3,0-.02-.06-.02-.08-.02-.08.18.2.16.18.22v-.14c.29.14.36.53.77.55l.07-.09c.29.03.01.21.23.33h-.03c.12-.02.2-.01.23.04-.14.04-.13.25-.29.28.32.04.21-.02.62-.17l-.12.14c.16-.07.23-.12.34-.06-.18.03-.17.24-.4.29-.16.45.54.02.16.48.47-.24.09-.34.21-.36.1-.15.35-.17.36-.08.04.07-.42.52-.29.66-.01-.02-.04,0-.05,0-.05.14.23,0,.12.2.27-.16.06.1.37-.14l-.18-.08c.14.01.56-.21.49.06-.07.04-.18.07-.25.08-.06.11.12.02.06.14-.31.24-.2-.11-.51,0-.09.15.35-.03-.01.21.47-.29.07.19.47.03l-.19.15s.16-.05.18-.01l-.28.14c.27-.09-.04.31.13.29-.14-.16.19-.22.26-.4.41,0-.38.51-.1.67-.05,0,.01-.21.14-.23,0,.07-.02.19-.1.3.16.12.17-.18.33-.21-.18.24.15,0,.28,0l-.18.16c.03.27.42-.28.41,0l-.31.15.13.02-.22.16c.23-.04.21.02.23.15.11-.13.34-.27.41-.2-.07.14-.2.12-.08.2-.14.07-.3.17-.17-.02-.07.04-.13.08-.2.12-.08.16.09.16.12.2,0-.02-.01-.05,0-.08l.39-.06c-.05.08-.12.11-.19.14.05.01.15-.04.2,0-.16.12-.31.25-.44.24h.29c-.06.07-.11.23-.18.26-.02.16.46-.05.44.16.03-.02.07-.03.11-.03.05.13-.05.38.26.32l-.21.3c.14.04.26-.38.49-.31.18.04-.19.24-.23.34.18-.06.54-.2.41.09-.08,0-.06-.05-.11-.07ZM35.87,16.62c-.06.01-.21.07-.12-.04.23-.16.15-.05.12.04ZM37.85,17.98c-.07.04-.07-.02-.02-.1.03,0,.05.04.02.1ZM43.46,21.58s0,0-.01,0c.02-.11.01-.07.01,0ZM43.48,21.75s.06-.04.08-.06c-.05.04-.07.02-.09-.02-.04.05-.06.09,0,.09ZM33.69,10.88l-.03.06c-.09,0-.03-.03.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.43,18s.06-.06.09-.1c-.04.02-.07.05-.09.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "34.03 14.93 34.03 14.92 33.99 14.95 34.03 14.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M40.54,21.61s.03-.09.05-.12c-.04.04-.07.08-.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.27,21.98l-.11-.02s.01.07,0,.11c.04-.04.09-.11.11-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.73,23.57s.02.02.05,0l.08-.08s-.13,0-.13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.75,22.6c-.14.15-.05.14.02.16h0c.22-.19.1-.17,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.78,22.76s.04.02.04.04c.09-.07,0-.03-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.7,21.78c-.02.06.2-.17.15-.1.21-.15-.36.08-.15.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "43.31 23.1 43.47 22.91 43.3 23.02 43.31 23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.1,22.62l.02.12s.06-.04.08-.04c-.04-.05-.05-.13-.1-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.2,22.7s.04.04.08.03c-.01-.01-.05-.03-.08-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "43.16 23.05 43.18 22.99 43.14 22.93 43.16 23.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.41,21.82l-.13-.03c-.07.05-.09.11-.04.11.06-.02.11-.02.16-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.14,22.53c.02-.06.06-.1.11-.17l-.23.21.12-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.87,22.35c-.07.05-.29.06-.18.14.07-.05.2-.02.18-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "41.05 20.91 41.07 20.92 41.44 20.57 41.05 20.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.18,20.69c0,.18.25-.19.22,0,.11-.06.03-.15.12-.2-.15.03-.12-.05-.34.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.52,20.48s.05-.01.08-.02c-.04,0-.06.01-.08.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "30.77 6.86 30.8 6.74 30.7 6.88 30.77 6.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.37,6.98l.24-.22-.26.14s.07.02.02.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.53,17.22l.06-.05c.05-.06.05-.08.03-.12l-.09.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "34.98 16.22 34.99 16.24 35.19 16.02 34.98 16.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M34.08,15.76s.09.03.11.07c-.09-.03.16-.31-.11-.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.95,8.09s-.18.07-.21.08c.06.02.26-.11.21-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "42.55 8.23 42.47 8.26 42.68 8.22 42.55 8.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.69,8.55c.31-.18-.11-.09-.02-.2l.07-.04-.27.1c.07.05.29.06.22.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.08,9.05c.12-.07.13-.01.02-.06-.01.01-.02.02-.03.02,0,0,0,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.07,9.02s-.09.07,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.22,9.14h-.13c-.07.05-.07.1-.13.11.08.02.15-.03.26-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.47,9.07h-.06s-.04.03.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.29,9.07h.12s.15-.08-.05,0c.1-.04,0,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.33,9.02c.06-.06.09-.11.22-.12-.08-.06-.31.06-.22.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.04,8.41l.08-.08-.12.02c.06-.01-.06.11.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.18,9.5c.07-.03.18-.1.26-.15h-.09s-.07.1-.17.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.44,9.35h.14c0-.06-.07-.04-.14,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "42.83 8.91 42.55 8.95 42.84 8.92 42.83 8.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "42.26 9.69 42.09 9.74 42.35 9.67 42.26 9.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.35,9.8c-.14.04-.21.13-.3.15.04.02.17,0,.28-.02-.07,0-.07-.04.02-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.5,9.9s-.1.01-.17.03c.04,0,.09,0,.17-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.59,9.44s-.14.08-.18.13l.18-.11s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.6,9.46h0s0,.04,0,.05c0,0,0-.02,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.59,9.44s0,0,0,0c.02-.01.02-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.72,9.12c.12-.02.27-.02.4-.15-.14.04-.22.12-.4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.82,9.3l.02-.07c-.05.02-.12.07-.18.08h.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "42.89 9.3 42.82 9.3 42.81 9.33 42.89 9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.64,9.72c.09-.02.11,0,.14.03.02-.05.03-.09.02-.12-.06.02-.18.06-.16.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.64,9.59s0,0,.01,0c.01-.01.02-.02-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.9,10.03s.02-.01.03-.02c-.01,0-.02,0-.03.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.82,9.61s-.03-.03-.09-.02c.03,0,.05.02.06.04.03-.01.05-.02.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.62,9.93s.06-.06.09-.09c-.06.04-.14.11-.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.6,9.62s0,0-.01,0c-.04.03-.02.02.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.6,9.62s.09-.02.13-.03c-.02,0-.05,0-.08,0-.01,0-.03.02-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.18,9.52c-.18.08-.37.1-.21-.04-.16.01-.73.33-1.04.53.08-.04.15-.07.28-.07.09-.06.17-.22.36-.26.12.02-.04.09-.12.16.21-.13.37-.07.69-.24h-.14c.05-.03.14-.05.18-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.91,9.9h-.03s-.08.08-.21.18c.1,0,.17-.03.23-.06l-.02-.12h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.83,9.79c.2-.08.31-.06.51-.2-.04-.06-.18.03-.29.04.1.08-.12.02-.2.15-.04,0-.06-.02-.08-.03-.01.03-.04.06-.06.09,0,0,0,0,.01,0h0s0,0,0,0c.02-.02.04-.02.02-.01,0,0,0,0,0,0,.03-.01.05-.02.08-.03-.03.05-.05.03-.08.03,0,0-.02,0-.03.01,0,0,0,0,0,0l.15.05s0-.06-.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.57,8.82s-.03.02-.04.02c.03,0,.04-.01.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.47,8.92s-.11.04-.1,0c.05-.05.09-.04.16-.08-.06.01-.16.02-.24.11h.03c-.05.07-.27.23-.3.24.17-.09.29-.16.45-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.2,9.33l.14.04.15-.12-.1.05c.02-.07-.1,0-.18.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "42.81 10.08 42.6 10.17 42.92 10.08 42.81 10.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "42.89 10.18 42.71 10.26 42.83 10.24 42.89 10.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M48.03,15.28h.06s-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M47.96,15.1l-.09.04c.05-.01.09-.03.09-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.18,12.85c-.15.12-.39.28-.19.18l.19-.1s-.03-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M46.22,14.13s.04-.03.05-.04c-.07.02-.14.04-.2.06.04,0,.09-.02.14-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M47.05,13.77l-.1.11s.07-.07.1-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M48.7,16.16l.21-.07s-.11.02-.21.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.49,11.26c-.06.07-.08.11-.08.13.09-.09.25-.2.08-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.92,16.2s.09-.01.13-.04c-.04,0-.08,0-.13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.45,11.48s.02-.02.04-.04c-.04,0-.08-.02-.08-.05-.07.07-.11.12.04.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M50.22,19.77s-.01.01-.02.02c.03-.01.03-.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M48.73,21.74s-.02-.02-.03-.04c-.01.01,0,.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.01,10.66s-.02,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.73,10.18s.05-.02.1-.04c-.05.02-.08.03-.1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.78,11.14s0,0,0,0c.04-.03.03-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.08,10.58s-.04.04-.04.06c.01-.01.03-.03.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.99,10.63s0-.02,0-.03c-.03.01-.05.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.04,10.69s0-.03,0-.05c-.01.01-.02.02-.03.02,0,0,.01.01.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M48.79,18.13s0,0-.02.01c.09-.02.07-.02.02-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "46.5 12.48 46.49 12.49 46.49 12.49 46.5 12.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M46.69,12.5c-.26.08-.24.05-.2,0l-.55.3.75-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M48.29,15.68l.15-.14c.32-.07.25.03.47-.14-.62.28-.17-.2-.79.09l.11-.1s.04,0,.04.01c.26-.21-.47.15-.43.02.03-.06.11-.12.19-.13h-.19s.11-.08.11-.05l-.1-.09h.02c-.1.02-.27.06-.34.07.07-.07.07-.02.15-.06h-.18c.15-.09.33-.11.32-.06.58-.35-.18.02.12-.28l.11.02c.33-.2.18-.19.37-.36-.11.07-.48.39-.67.4.04-.04.05-.08-.09-.06.22-.1.15-.11.11-.15l.29-.13c-.11,0-.25.06-.4.1,0-.07.22-.19.4-.29,0-.11-.33.23-.43.15.08-.12-.07-.12-.28-.12.08-.1.18-.07.25-.13l-.25.06s.07-.04.11-.06c-.11,0-.29.13-.4.11-.33.14.41-.34.01-.25.07-.06.18-.08.29-.13-.29.01-.21,0-.57.06l.16-.16c-.19.16-.48.21-.72.25-.1.07-.18.13-.22.16l-.2-.02s.15-.07.27-.11c-.03,0-.05.01-.08.02.09-.08.27-.15.44-.2-.05.04-.11.08-.16.12.19-.06.39-.13.56-.22-.04,0-.07.01-.09,0,.05-.02.09-.03.12-.05.03-.02-.04,0-.12.02l.31-.17-.13.06.14-.22c-.37.07-.88.22-1.08.14.25-.08.39-.18.67-.31-.28.18.18.05.15.15.01-.05.15-.11.2-.12h-.33c.23-.11.16-.11.24-.19-.44.24-.35.05-.51.06.15-.08.31-.14.3-.06.31-.23-.57.16-.32-.04.01.01,0,.03.07,0-.15.03-.09-.11.06-.15h.01c0-.11-.15-.3-.54-.13.05-.02.47-.21.55-.24l-1.38.43c.34-.14,1.09-.58,1.32-.58.04-.05.08-.1-.06-.1-.04.04-.46.27-.5.26.34-.24.18-.14.45-.36-.06.06-.59.28-.59.23.08-.03.51-.25.57-.26l-.55.14c.1-.02.43-.2.57-.29-.09.06-.03-.09-.09-.09l-.1.1c.02-.15-.77.23-.79.11.11-.04.66-.27.7-.36-.27.1-1.31.48-1.55.48l.14-.09h-.2c.41-.13,1.3-.39,1.65-.48.1-.1.17-.09.13-.15.13-.09.23-.07.24-.05l.02-.19c-.3.15-.36.03-.61.16h.39c-.3.16-.91.33-.9.2.11-.08.55-.24.65-.29-.11.04-.25,0-.18-.05l.18-.03c.09-.11-.45.1-.19-.11,0-.03.36-.26.18-.18-.33.2-1.4.72-1.67.82.02-.02.27-.28.43-.39.25-.17.68-.25.89-.39-.08.04-.2.06-.23.07.06-.06.26-.11.2-.15-.31.14-.03-.12-.27.1-.11-.01.04-.09,0-.14-.19.11-.7.27-.82.25.08-.03.18-.09.22-.12-.02-.12.09-.25.04-.35.07-.04.14-.14.28-.18-.06.01-.17.05-.19.02.24-.19.07.05.37-.15-.18.08-.29.04-.42.05-.27.15,0,.13.13.12-.38.18-.82.29-1.04.27-.13-.04.23-.15.17-.14,0-.19-.73.18-.52-.08.22-.17.48-.23.65-.33.12.02-.1.18-.07.22l.09-.11c.09-.02.17,0,.12.06.2-.15-.08-.29.06-.5-.09.02-.19.02-.28.08l.05.02c-.18.13-.31.06-.37.15-.16.01-.41.06-.33-.07l.27-.15c-.08.04-.14.13-.05.11-.14.03.32-.29-.06-.15l-.17.14c-.16.01-.49.09-.43-.02-.26.16.04,0-.26.2.38-.23.06.17.45-.09-.35.22-.12.16-.41.37.09-.05.16-.1.15-.03.03-.01.06-.02.09-.03,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,.03-.03.08-.07.13-.09.22-.07.26.02.38,0-.03.05-.11.04-.2.1l.18-.03c-.2.1-.3.25-.45.23l.02.07c-.09.09-.11.17-.01.16-.03.05.26-.03.09.02l.18.05-.05.02c.02.12.44.06.13.35.07.01.15.02.12.1l-.17.1c.08.02-.11.22.08.15-.45.27,0,.27-.04.39l.23-.11c.01.06.1.08.23.11l.2-.1c.19-.02-.07.22,0,.3-.08.03-.07,0-.03-.04-.4.33.44.08.16.34.09,0,.07.02.03.06,0,0,0,0-.01,0,0,0,0,0,0,.01-.03.03-.06.06-.09.09.04-.03.08-.06.09-.08.01.02.05.04.12.04l-.21.12s0,0,0,0c-.07.07.11-.03.27-.12.04,0,.09,0,.15-.02-.34.19.15.02-.21.23.19-.07.21.08.6-.09-.05.02-.07.04-.08.03-.03.05-.06.11.06.08l-.27.15.41-.11c-.15.12-.24.19-.47.25.38-.05.16.02.53-.04l-.18.08s.28-.04.15.05c-.31.23.12.37-.11.7.51-.28-.2.19.21,0-.12.07-.18.13-.3.15.17.03-.13.23.24.13-.12.07-.19.07-.26.11.03,0,.12-.02.05.02-.07.04-.11.04-.17.05.07.08.45-.09.82-.25-.15.13-.11.14.14.06-.11.07-.22.16-.29.12,0,.04-.08.28.21.15-.07.04,0,.06.04.05.02.08,0,.1.06.16l.04-.04c.36-.14.11.02.18.06l-.04.02c-.19.25.15,0-.08.27l.21-.11c.47-.21-.22.25,0,.24l.11-.09c.18-.03-.58.42-.62.49-.04.03-.07.02-.11.02-.22.24.29-.12.4-.07-.15.09-.4.17-.4.23-.11.09.57-.08.31.14.11-.07.22-.15.33-.15.07.04-.37.37.03.24-.03.02-.06.04-.09.05.12,0,.23.07.44,0-.73.4.49.1-.2.43l.1.12-.07.03c0,.11.18.06.36.01-.04.04-.11.06-.15.07-.08.19-.04.19.35.14l-.22.12c.14-.03-.26.35.06.35-.03.01-.07.03-.11.03.33.02-.46.63.38.29h.24c0-.15.36-.15.47-.27.07.02-.19.24-.26.2l.04-.03c-.44.18-.08.22-.37.35.13.23,0,.57.09.8l.32-.18.02.09c-.07.06-.25.15-.26.09-.17.12.2.02.27-.01-.08.17-.41.14-.4.18l.05.03.03-.03c.15-.03.3-.09.31-.02-.05.07-.19.12-.2.14-.02.01-.03.02,0,.03l.02.11.24-.16c.15-.02.03.1.3-.09-.42.28,0,.44-.11.55.22-.03.24.03.26.12.05-.04.33-.19.33-.11-.62.26-.21.24-.62.5.27-.18.16.15.53-.12-.02.08-.23.11-.35.22.29.01-.02.35.13.47.08-.04.19-.12.32-.14l-.36.27c.05.01.47-.19.22,0,.06-.04.16-.1.19-.09-.24.49.61.47.03,1.13.13-.12.16-.09.18-.06.03-.04.2-.09.3-.15l-.24.27c.31-.12.09.13.38,0l-.07-.02c.36-.11.71-.43,1.15-.63-.41.12.49-.43-.11-.27.08-.06.15-.05.24-.11-.2.06-.25.05-.19-.05l.05-.02c-.12-.14.03-.29.06-.53l-.21.11c.01-.05.07-.09.12-.14-.35.11.03.12-.34.25.41-.26-.12-.28.36-.55-.03-.06-.24.14-.26.07l.13-.08-.18.07c0-.05.17-.15.28-.21,0,.02.04.01.06.02.13-.13-.12-.12-.08-.16l-.06.1c-.2-.1-.12-.38-.47-.41l-.1.06c-.24-.03.07-.15-.08-.24h.03c-.11.01-.18,0-.19-.04.13-.02.2-.17.35-.19-.26-.03-.19.01-.6.1l.16-.1c-.17.04-.25.08-.32.03.17-.01.24-.16.45-.19.3-.31-.47-.03.04-.35-.49.16-.2.24-.32.25-.14.1-.37.11-.35.05-.01-.05.56-.36.5-.46,0,.01.04,0,.04,0,.1-.1-.2,0-.03-.15-.29.1-.02-.07-.38.09l.13.06c-.12-.01-.56.13-.41-.06.08-.03.18-.04.25-.05.09-.08-.1-.02,0-.1.36-.16.14.09.44.02.14-.1-.31,0,.09-.15-.51.19.01-.14-.4-.04l.22-.1s-.15.03-.16,0l.3-.09c-.27.05.15-.22,0-.21.06.12-.25.15-.38.28-.36-.01.52-.35.34-.47.04,0-.09.15-.2.16.03-.05.09-.13.19-.21-.1-.09-.21.12-.37.14.24-.16-.13,0-.24-.01l.22-.1c.08-.19-.47.18-.36-.01l.32-.1-.11-.02.25-.11c-.21.02-.18-.02-.14-.12-.15.09-.4.18-.43.13.11-.1.22-.08.15-.14.14-.05.33-.11.14.02.07-.03.15-.05.22-.08.13-.11-.02-.12-.03-.15,0,.01,0,.03-.04.06l-.36.03c.07-.06.15-.07.22-.09-.03-.01-.14.02-.18,0,.18-.08.36-.16.47-.15l-.25-.02c.07-.04.18-.16.26-.17.08-.11-.41.01-.32-.13-.04.01-.07.02-.11.01,0-.1.19-.27-.1-.24l.29-.2c-.11-.04-.37.26-.54.2-.14-.04.26-.16.33-.23-.18.03-.54.12-.32-.08.07,0,.03.04.07.05ZM47.73,14.88c.05,0,.21-.04.09.04-.26.1-.15.03-.09-.04ZM46.58,13.8c.08-.02.05.01-.02.08-.03,0-.03-.03.02-.08ZM43.31,10.83s0,0,.01,0c-.07.08-.04.05-.01,0ZM43.37,10.7s-.06.02-.09.04c.06-.02.07,0,.06.02.05-.03.09-.06.03-.06ZM47.44,19.07l.05-.04c.08,0,.02.02-.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M46.95,13.81s-.07.04-.12.06c.04-.01.08-.03.12-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M48.66,16.17s0,0,0,0c.01,0,.03-.01.04-.02h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M45.79,11.04s-.06.06-.1.08c.05-.02.1-.05.1-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.8,10.46l.08.02s.02-.05.05-.08c-.05.03-.12.07-.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.94,9.39s-.01-.01-.04,0l-.1.05s.11.01.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.5,10.07c.18-.09.1-.09.05-.11,0,0,0,0,0,0-.26.11-.16.11-.06.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.55,9.96s-.02-.02-.02-.03c-.1.04-.02.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M43.2,10.66s-.24.1-.17.06c-.24.09.33-.02.17-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "44.09 9.76 43.87 9.88 44.06 9.81 44.09 9.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.06,10.12l.04-.09s-.06.02-.08.02c0,.04-.02.1.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.01,10.05s-.02-.04-.06-.03c0,0,.02.03.06.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "44.2 9.8 44.16 9.84 44.16 9.89 44.2 9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.3,10.74l.09.03c.08-.03.12-.07.08-.08-.06.01-.1,0-.17.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.83,10.26s-.09.06-.16.11l.28-.13-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M44.98,10.41c.08-.03.27-.02.21-.09-.08.03-.17,0-.21.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "45.07 11.5 45.06 11.49 44.6 11.71 45.07 11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M46.55,11.79c.08-.12-.29.12-.19-.01-.12.03-.09.11-.19.13.14-.01.08.04.37-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M46.18,11.91s-.05,0-.08.01c.03,0,.06,0,.08-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "48.56 22.03 48.49 22.12 48.63 22.02 48.56 22.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M48.95,21.96l-.29.15.28-.1s-.05-.01,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M48.26,14.47l-.07.03c-.07.04-.07.06-.07.08l.15-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "48.34 15.2 48.35 15.19 48.09 15.34 48.34 15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M48.94,15.57s-.07-.02-.07-.05c.07.02-.26.21.07.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.59,36.89s.09-.17.1-.21c-.07.02-.12.26-.1.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "37.94 37.15 37.98 37.08 37.83 37.25 37.94 37.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.49,36.98c-.08.35.18,0,.22.16l-.02.08.14-.25c-.11,0-.31.14-.34.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.52,36.17c-.03.14-.09.09.04.06,0-.02,0-.02,0-.04-.01,0-.02,0-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.57,36.19c.05,0,.01-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.32,36.19l.11-.09c.02-.08-.03-.12,0-.17-.09.04-.1.12-.11.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.17,36.41l.05-.04s0-.05-.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.33,36.29l-.11.08c-.01.06-.05.17.05-.03-.04.1,0,0,.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.35,36.36c0,.09.04.15-.07.24.14,0,.21-.24.07-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M37.34,37.32v.12s.09-.1.09-.1c-.04.05-.06-.12-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.99,35.87c-.03.07-.05.2-.08.29l.08-.06c0-.06-.03-.12,0-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.92,36.16l-.11.1c.06.04.09-.02.11-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "37.02 36.78 37.23 36.56 37 36.77 37.02 36.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "36.73 35.76 36.83 35.61 36.67 35.84 36.73 35.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.55,35.73c.08-.13.04-.25.11-.32-.06,0-.14.11-.22.2.06-.04.1-.01.11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.32,35.74s.07-.08.12-.13c-.03.02-.07.06-.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.7,36.18s.04-.16.02-.22l-.05.21h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.67,36.17h0s-.05-.03-.05-.04c0,0,.02.02.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.7,36.18h0s0,.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.91,36.53c-.08.1-.21.19-.19.39.08-.13.07-.24.19-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.65,36.45l.06.07c.02-.05.03-.14.07-.18l-.13.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "36.59 36.5 36.65 36.45 36.62 36.42 36.59 36.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.38,35.98c-.06.08-.1.07-.15.07.03.05.06.09.1.11.03-.06.09-.17.04-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.51,36.09h-.01s0,.03.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "35.85 35.91 35.84 35.94 35.85 35.91 35.85 35.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.33,36.19c.02.05.05,0,.09-.05-.03.01-.06.02-.09,0-.01.03-.02.05,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.18,35.8s0,.09.01.13c0-.07.01-.18-.01-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.51,36.04h0c0-.05,0-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.51,36.04s-.06.07-.09.11c.02,0,.05-.02.08-.05,0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.27,37.15c.07-.18.22-.33.22-.1.12-.11.3-.74.36-1.11-.03.08-.06.16-.17.24-.01.11.07.3-.05.44-.13.06-.05-.09-.07-.21-.04.25-.24.29-.34.64l.13-.09c-.02.05-.08.13-.07.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.97,36.01h.04c-.02-.06-.02-.14-.01-.3-.08.07-.12.14-.14.2l.14.08-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.15,36.05c-.1.19-.2.25-.24.49.09.02.12-.15.21-.22-.16,0,.08-.1.02-.25.04-.02.07-.03.1-.03-.02-.03-.03-.07-.04-.12h0s0,.01,0,.01h0s0,.05,0,.03h0s-.02.05-.03.08c-.03-.06.01-.06.03-.07v-.03s.01,0,.01,0l-.18.06s.06.05.13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.48,37.32s0-.03.01-.05c-.02.02-.03.04-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.47,37.18s.06-.1.08-.07c0,.07-.04.1-.06.16.04-.05.12-.12.1-.24l-.02.02c-.03-.09-.01-.37,0-.39-.05.19-.08.32-.11.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M36.28,36.66l-.15.06v.2s.03-.11.03-.11c.05.07.08-.07.12-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "35.87 35.8 35.96 35.59 35.79 35.87 35.87 35.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "35.71 35.77 35.78 35.59 35.7 35.68 35.71 35.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.28,35.28l-.05.04s.04-.03.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.52,35.37l.03-.09s-.04.08-.03.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.92,34.49c0-.19.04-.48-.02-.27l-.05.21s.07,0,.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.92,34.89v.07c.03-.07.06-.13.09-.19-.03.04-.06.08-.09.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.62,35.74l-.03-.15c0,.05,0,.1.03.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M24.83,35.11l-.1.2c.06.02.07-.1.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M34.11,35.29c-.02-.1-.04-.14-.07-.16.01.14,0,.33.07.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.02,33.1s-.05.07-.07.12c.03-.03.06-.07.07-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M33.92,35.09s0,.04,0,.06c.04-.02.09-.04.12-.01,0-.1-.03-.17-.13-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M19.86,33.61s0-.02,0-.03c0,.03,0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M18.88,31.12s.04,0,.07,0c0-.02-.03-.02-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.12,35.46s.01-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M34.99,36.33s-.03.05-.05.09c.02-.05.04-.08.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M33.15,36.25h0s0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.14,35.57s-.01-.06-.02-.08c0,.02,0,.04.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.17,35.47s.02.02.02.03c.02-.03.02-.06-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.07,35.46s.03.02.05.04c0-.02,0-.03,0-.04-.01,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M22.71,33.73s0-.01,0-.02c-.06.08-.04.07,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "30.37 36.35 30.38 36.34 30.37 36.33 30.37 36.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.2,36.47c.13-.24.15-.2.17-.13l.15-.61-.32.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.65,35.16l.03.21c-.19.28-.23.15-.23.44.2-.65.34.03.54-.62v.15s-.01.03-.03.02c.01.34.22-.45.32-.32.03.06.04.17-.02.24l.15-.13s-.01.13-.04.11h.18s0,.01,0,.01c.05-.1.15-.24.2-.3.01.11-.04.06-.05.15l.14-.13c-.01.18-.14.32-.19.28-.11.67.12-.14.19.29l-.11.06c-.06.39.05.27.08.53.01-.13-.02-.64.13-.77.01.06.04.09.13-.02-.07.23,0,.19.07.2l-.1.31c.1-.07.14-.23.22-.35.07.05.01.3-.03.5.11.09.03-.41.19-.42.07.15.18.04.35-.1.04.13-.07.18-.07.28l.14-.23s-.01.08-.03.12c.08-.08.1-.3.21-.36.13-.33.02.54.24.19,0,.09-.07.18-.1.3.22-.21.18-.14.4-.45l.04.23c0-.25.18-.5.33-.69,0-.12.01-.22.02-.27l.18-.12c0,.06-.05.16-.11.28l.05-.07c.01.13-.07.3-.15.46,0-.06,0-.13.01-.2-.09.18-.18.37-.23.55.02-.03.05-.06.07-.07-.02.05-.04.09-.05.12,0,.03.03-.03.07-.1l-.08.35.05-.13.1.27c.23-.3.49-.78.73-.86-.13.23-.14.4-.23.7.05-.33-.19.09-.27,0,.04.05-.01.19-.04.23l.27-.23c-.08.24-.02.19,0,.31.12-.49.23-.28.35-.4-.05.16-.12.32-.19.25-.02.39.3-.52.3-.18-.02,0-.03-.03-.06.05.1-.13.18.03.11.16h-.02c.13.1.44.14.59-.26-.02.05-.18.48-.21.56l.7-1.28c-.14.34-.32,1.2-.5,1.35.02.06.04.13.15.03,0-.06.1-.52.15-.54-.04.42,0,.23,0,.59-.01-.09.21-.62.26-.58-.04.08-.17.54-.21.59l.31-.49c-.07.08-.15.45-.17.61.02-.11.12.05.17,0l-.02-.14c.13.13.4-.7.55-.62-.06.1-.27.66-.21.76.13-.26.59-1.26.8-1.43l-.03.17.17-.14c-.2.39-.68,1.19-.89,1.5.02.14-.04.19.05.2-.02.16-.12.21-.15.21l.17.16c.1-.32.26-.27.34-.54l-.33.26c.1-.32.43-.86.55-.76,0,.14-.22.56-.25.67.06-.1.21-.16.19-.08l-.12.15c.04.15.27-.38.27-.04.03.03-.04.44.03.26.07-.38.44-1.51.57-1.77,0,.03.06.41.03.6-.04.3-.31.65-.35.91.03-.09.1-.18.12-.21,0,.09-.11.26-.02.25.12-.32.14.08.13-.26.11-.07.06.09.15.11.04-.22.32-.68.43-.75-.03.08-.05.19-.06.24.14.08.17.26.31.31-.01.08.02.2-.06.33.04-.05.1-.15.14-.15-.01.31-.11,0-.16.37.07-.19.2-.22.3-.31.08-.3-.12-.11-.23-.01.14-.4.39-.78.6-.91.15-.06-.04.28,0,.23.2.15.43-.63.52-.28-.02.28-.17.51-.22.69-.13.06-.09-.21-.16-.23l.04.15c-.06.07-.15.12-.16.03-.02.25.36.17.45.44.06-.07.14-.14.15-.25l-.07.02c.02-.22.2-.25.17-.37.12-.12.28-.31.35-.16l-.08.3c.03-.08,0-.2-.07-.12.09-.11.02.45.2.09v-.23c.12-.12.32-.39.38-.27.06-.3-.03.03.02-.33-.09.43-.23-.1-.29.37.07-.41-.06-.21-.02-.57-.03.1-.03.19-.09.12-.02.03-.03.06-.05.08h0s0,0,0,0c0,.01,0,.02,0,0,0,.05,0,.1-.01.16-.12.21-.23.16-.31.25-.03-.06.06-.1.07-.21l-.12.15c.07-.21,0-.39.15-.48l-.09-.04c-.01-.14-.08-.21-.16-.14-.03-.06-.2.19-.1.04l-.2.08.02-.05c-.14-.08-.43.24-.47-.2-.07.04-.14.08-.21,0l.05-.19c-.09.04-.13-.25-.22-.07.1-.52-.28-.21-.36-.34l-.09.24c-.07-.04-.17,0-.3.07l-.07.21c-.14.15-.16-.22-.3-.25.04-.08.06-.05.07.01,0-.53-.45.24-.48-.16-.06.07-.08.03-.09-.03,0,0,0,0,.01,0,0,0,0,0-.01,0,0-.04,0-.09-.01-.13,0,.06,0,.1,0,.13-.03,0-.08,0-.14.05l.06-.23s0,0-.01,0c-.01-.1-.07.1-.1.28-.03.03-.07.07-.1.12.09-.38-.15.09-.06-.32-.09.18-.25.08-.41.47.02-.05.01-.08.04-.08-.03-.06-.06-.12-.14-.02l.08-.3-.23.36c0-.2,0-.31.14-.51-.26.3-.16.09-.39.39l.07-.19s-.2.22-.17.06c.02-.39-.47-.21-.62-.62-.13.57-.04-.29-.19.14.03-.14.01-.22.09-.32-.17.09-.13-.27-.33.07.03-.14.09-.18.1-.27-.02.03-.08.1-.07.02s.05-.1.09-.16c-.14-.02-.28.38-.41.76-.01-.2-.05-.19-.18.05.02-.13.02-.27.11-.29-.04-.03-.23-.27-.33.03,0-.08-.06-.04-.08-.01-.1-.05-.1-.08-.21-.08v.06c-.14.36-.1.06-.19.08v-.04c-.09-.32-.11.1-.2-.26l-.06.23c-.17.49-.08-.34-.24-.18v.14c-.11.15.04-.72,0-.8,0-.05.04-.06.07-.09-.07-.34-.11.29-.25.33.03-.17.15-.4.08-.46,0-.14-.38.46-.4.12-.01.13-.03.26-.11.34-.1.02-.08-.54-.28-.17,0-.04,0-.07.01-.1-.09.08-.26.11-.36.31.17-.81-.51.27-.29-.46l-.21-.02.03-.07c-.11-.08-.21.08-.3.24-.01-.06.03-.12.04-.16-.14-.2-.17-.17-.42.15l.05-.24c-.08.13-.16-.45-.42-.22,0-.03.03-.07.05-.1-.28.22-.3-.8-.61.05l-.19.18c.15.11-.13.37-.1.53-.08.03-.1-.31,0-.33v.05c.16-.45-.17-.22-.08-.53-.34-.07-.61-.41-.92-.51l-.06.36-.11-.05c0-.09.03-.29.11-.25.01-.21-.18.13-.2.21-.12-.18.17-.4.12-.42h-.07s0,.05,0,.05c-.09.13-.14.28-.23.24-.04-.09.03-.23,0-.25,0-.02,0-.04-.03-.02l-.13-.07-.02.29c-.1.12-.13-.05-.15.28.03-.51-.48-.31-.5-.48-.14.18-.22.16-.32.1.01.06-.05.38-.13.32.2-.64-.1-.32-.05-.81-.01.33-.28.01-.29.48-.06-.07.06-.24.04-.41-.24.2-.36-.26-.61-.23-.02.08-.02.22-.1.34v-.46c-.07.03-.18.48-.19.17,0,.07-.02.19-.05.21-.34-.53-.98.12-1.25-.77.02.18-.02.19-.07.18.02.05-.05.21-.07.33l-.11-.37c-.11.31-.21-.03-.3.28l.07-.04c-.16.34-.08.83-.2,1.3.18-.39.09.67.37.11,0,.1-.06.14-.07.26.08-.19.14-.22.2-.11l-.02.05c.24,0,.29.22.52.42l.04-.23s.04.12.05.18c.15-.33-.15-.06,0-.43-.04.49.39.1.31.65.08.02.04-.27.12-.25v.15s.05-.18.05-.18c.05.04.03.23,0,.35-.01-.02-.05.02-.06.03.03.19.22,0,.23.05l-.06-.11c.27-.08.5.18.8-.05v-.11c.23-.16.12.15.33.11v.02c.05-.1.12-.14.16-.11-.08.11.03.27-.07.39.24-.17.13-.15.36-.52l-.02.19c.08-.15.11-.24.22-.26-.12.13-.01.29-.15.47.1.44.39-.32.34.28.22-.47-.1-.32-.02-.41,0-.17.17-.35.22-.29.06.03-.06.66.1.7-.01,0-.03.03-.04.02.03.14.16-.14.18.08.12-.29.09.04.2-.34l-.17.05c.11-.08.3-.51.38-.25-.03.07-.1.17-.14.21,0,.12.1-.05.11.07-.11.38-.2.04-.36.31,0,.17.24-.23.09.17.2-.51.14.11.35-.27l-.07.23s.09-.13.12-.12l-.14.28c.15-.23.11.27.23.15-.17-.04.04-.29,0-.47.3-.25-.04.63.23.59-.04.02-.08-.17,0-.26.03.06.07.16.06.29.17,0,.04-.24.15-.36-.02.29.11-.09.2-.16l-.06.23c.14.2.18-.47.29-.25l-.16.3.11-.06-.09.26c.15-.17.16-.11.23-.01.02-.17.13-.42.21-.4.02.15-.09.21.03.21-.07.14-.14.31-.13.09-.03.07-.06.14-.09.21.01.17.14.08.18.09-.01-.01-.03-.03-.03-.07l.25-.28c0,.09-.04.16-.08.22.04-.02.09-.12.15-.12-.07.19-.12.38-.21.45l.21-.17c-.01.08.02.25-.02.31.06.13.31-.31.39-.13.02-.04.04-.07.07-.09.1.07.13.33.33.11l-.02.36c.12-.05.02-.45.23-.53.15-.07-.04.3-.02.41.11-.15.31-.47.34-.16-.05.05-.07,0-.11.01ZM26.93,35.38s-.13.18-.11.04c.11-.26.09-.12.11-.04ZM28.97,35.39c-.04.07-.06.02-.06-.07.03-.01.05,0,.06.07ZM34.7,35.52s0,0,0,.01c-.02-.11-.02-.07,0-.01ZM34.78,35.66s.03-.06.04-.09c-.03.05-.05.05-.08.02-.01.06-.01.11.04.07ZM22.76,32.07v.07c-.06.05-.03,0,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.66,35.64s.02-.08.03-.13c-.02.04-.04.08-.03.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "24.85 35.07 24.85 35.07 24.83 35.11 24.85 35.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M32.41,37s0-.09,0-.13c-.02.06-.03.11,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.5,35.48l-.09.03s.03.05.04.1c.02-.05.03-.14.05-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.6,37.1s.02,0,.04-.02l.04-.11s-.11.07-.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.29,36.26c-.06.19,0,.14.07.13h0c.11-.27.03-.2-.06-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M35.37,36.38s.04,0,.05.01c.04-.1-.01-.03-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M34.96,35.58c0,.06.1-.24.09-.16.11-.23-.26.24-.09.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "35.11 36.9 35.17 36.66 35.08 36.84 35.11 36.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M34.78,36.59l.06.09s.03-.06.05-.07c-.05-.03-.08-.09-.1-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M34.89,36.61s.05.02.08-.02c-.01,0-.05,0-.08.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "34.97 36.93 34.97 36.88 34.92 36.84 34.97 36.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M33.95,36.25l-.11.04c-.04.08-.03.14.01.11.04-.05.08-.07.1-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M33.98,36.98c0-.06.01-.11.03-.19l-.11.29.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M33.71,36.97c-.04.08-.21.19-.09.21.04-.08.15-.12.09-.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "32.55 36.15 32.57 36.16 32.73 35.67 32.55 36.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.03,36.93c.06.15.12-.29.17-.12.06-.11-.04-.14.02-.23-.1.1-.11.02-.19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.21,36.58s.03-.04.06-.06c-.03.02-.04.04-.06.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "18.7 30.8 18.65 30.68 18.66 30.86 18.7 30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M18.48,31.14l.06-.32-.11.28s.05-.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.92,36.06l.03-.07c.01-.08,0-.09-.03-.12v.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "26.1 35.56 26.12 35.57 26.17 35.28 26.1 35.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.25,35.7s.08-.03.11-.01c-.08.03-.02-.34-.11.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M32.96,44.78s.03-.19.04-.23c-.05.04-.04.28-.04.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "32.44 45.23 32.45 45.14 32.37 45.35 32.44 45.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.97,45.2c.02.36.17-.05.25.08v.08s.06-.28.06-.28c-.1.04-.25.22-.31.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.76,44.41c0,.14-.06.12.06.05,0-.02,0-.02,0-.04-.01,0-.02,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.81,44.42c.05,0-.03-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.58,44.49l.07-.12c0-.08-.07-.1-.04-.16-.07.06-.06.15-.03.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.5,44.75l.04-.05s-.01-.05-.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.62,44.59l-.08.11c0,.06,0,.17.03-.04-.01.1,0,0,.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.65,44.65c.03.08.08.13,0,.25.13-.04.12-.29,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.93,45.56l.04.11.05-.12c-.02.06-.09-.1-.09.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.18,44.28c0,.08.01.2.01.3l.05-.08c-.02-.05-.07-.1-.06-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.19,44.58l-.08.13c.06.02.08-.04.08-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "31.47 45.14 31.6 44.87 31.45 45.14 31.47 45.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "30.91 44.26 30.96 44.09 30.87 44.35 30.91 44.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.73,44.28c.04-.14-.03-.25,0-.34-.05.02-.1.15-.14.26.04-.06.09-.04.14.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.52,44.36s.05-.09.07-.16c-.02.03-.05.08-.07.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.99,44.67s0-.17-.04-.22l.02.21s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.97,44.67h0s-.05-.02-.06-.02c0,0,.03,0,.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31,44.67s0,0,0,0c0,.02,0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.29,44.94c-.05.12-.14.24-.07.43.04-.14,0-.25.07-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.02,44.94l.07.05c0-.06,0-.14.02-.2l-.09.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "30.98 45 31.02 44.94 31 44.92 30.98 45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.64,44.57c-.04.09-.07.1-.12.11.04.04.09.07.13.07,0-.07.03-.19-.01-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.8,44.63s0,0,0,.01c0,.02,0,.02,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.12,44.65s0,.03,0,.04c0-.01,0-.02,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.66,44.79s.05,0,.08-.07c-.03.02-.05.03-.08.03,0,.03,0,.05,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.4,44.45s.03.08.05.12c-.01-.07-.04-.18-.05-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.78,44.59s0,0,0,0c0-.05,0-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.78,44.59s-.03.08-.05.13c.02-.02.04-.04.06-.07,0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.93,46.02c.02-.2.11-.38.18-.16.08-.14.07-.8.02-1.16,0,.09-.01.17-.09.28.02.11.15.26.08.44-.11.1-.08-.07-.12-.18.03.25-.15.35-.14.72l.09-.12c0,.06-.04.14-.02.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.27,44.72l.03-.02s-.05-.12-.09-.27c-.06.09-.07.17-.08.23l.15.04v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.44,44.7c-.04.21-.12.3-.08.54.09,0,.07-.18.13-.27-.15.05.05-.12-.05-.25.03-.04.06-.04.08-.05-.02-.03-.05-.06-.07-.1,0,0,0,0,0,.01h0s0,0,0,0c0,.03,0,.04,0,.03,0,0,0,0,0,0,0,.03,0,.06-.01.08-.04-.05,0-.06.01-.08,0-.01,0-.02,0-.03,0,0,0,0,0,0l-.15.11s.07.03.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.12,45.82s0-.03,0-.05c-.01.03-.02.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M31.07,45.69s.03-.12.06-.09c.03.07,0,.1,0,.17.02-.06.08-.15.02-.26v.03c-.07-.08-.13-.35-.12-.38,0,.19.01.33.04.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.75,45.25l-.13.1.05.19v-.11c.07.05.06-.09.08-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "30.11 44.54 30.14 44.32 30.05 44.64 30.11 44.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "29.95 44.56 29.97 44.37 29.92 44.48 29.95 44.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M20.84,46.53l-.04.05s.03-.03.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M21.1,46.55v-.1c0,.05-.01.09,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.04,44.37c-.04-.19-.09-.48-.09-.25v.22s.07-.01.09.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M23.3,45.52s0,.04.01.07c.02-.07.03-.14.05-.21-.02.04-.04.09-.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M23.21,46.41l-.06-.14s.03.1.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M19.41,46.68l-.05.22c.07,0,.04-.11.05-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.32,44.55c-.04-.09-.07-.12-.11-.14.05.13.08.32.11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M21.07,44.23s-.04.08-.04.13c.02-.04.04-.08.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.08,44.41s.01.03.02.05c.04-.03.07-.06.11-.05-.04-.09-.08-.15-.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M14.26,46.22s0-.01-.01-.03c0,.03,0,.03.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.87,43.95s.04-.01.06-.01c-.01-.02-.03-.02-.06.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.32,44.43s0-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.44,45.3s-.02.05-.02.1c0-.05.01-.08.02-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.67,45.74s0,0,0,0c0,.04,0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.36,44.53s-.02-.05-.04-.07c0,.02.02.04.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.36,44.43s.02.02.03.02c0-.04,0-.06-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.27,44.44s.04,0,.05.03c0-.02,0-.03,0-.03-.01,0-.02,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M17.05,45.79s0-.01,0-.02c-.04.09-.02.07,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "25.04 46.57 25.05 46.56 25.04 46.56 25.04 46.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M24.91,46.73c.07-.27.09-.23.13-.17v-.63s-.13.8-.13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M20.21,46.55l.07.2c-.12.31-.19.2-.12.48.05-.68.33-.05.38-.73l.05.15s-.02.03-.04.02c.09.33.11-.49.24-.38.05.05.07.15.04.23l.12-.16s.02.13-.01.12l.17-.05v.02c.03-.1.09-.27.12-.33.04.1-.03.07-.02.16l.1-.16c.03.18-.06.34-.12.32.05.68.09-.17.25.24l-.09.08c.04.39.11.25.2.5-.02-.13-.16-.62-.05-.78.03.05.06.08.12-.05-.01.24.04.18.11.17l-.02.32c.08-.09.08-.25.13-.39.08.04.08.28.09.49.12.06-.07-.4.09-.45.1.13.18,0,.32-.18.07.11-.02.19,0,.29l.08-.25s0,.08,0,.12c.06-.1.02-.32.11-.4.04-.35.15.52.28.13.02.09-.02.19-.02.32.16-.25.14-.18.28-.53l.09.22c-.06-.24.05-.52.15-.75-.02-.12-.04-.22-.05-.27l.15-.16c.01.05,0,.16-.04.29.01-.03.02-.05.03-.08.04.12,0,.3-.04.48-.01-.06-.03-.13-.04-.2-.04.19-.09.41-.09.59.01-.04.03-.07.05-.08-.01.05-.02.1-.02.13,0,.03.02-.04.05-.12v.36s.03-.14.03-.14l.17.23c.15-.35.29-.87.5-1.01-.06.26-.03.43-.05.73-.04-.33-.16.13-.26.06.05.04.03.18.02.23l.2-.29c-.02.25.03.19.07.3,0-.5.16-.33.24-.47,0,.17-.03.34-.12.29.08.38.16-.58.25-.25-.02,0-.03-.02-.05.06.06-.15.18-.02.15.12h-.02c.15.07.46.03.5-.39,0,.06-.05.51-.06.6l.35-1.41c-.04.36,0,1.24-.14,1.44.03.05.07.12.16,0-.02-.05-.03-.53,0-.56.07.41.05.22.15.57-.03-.08.04-.65.1-.63-.01.08-.03.56-.05.62l.17-.55c-.04.1-.03.48,0,.64,0-.11.12.02.16-.04l-.05-.13c.16.09.2-.78.36-.74-.03.12-.09.71,0,.79.05-.29.24-1.37.4-1.59l.02.17.12-.18c-.09.43-.33,1.33-.46,1.68.05.13,0,.19.1.19.02.16-.06.23-.09.24l.21.11c0-.34.18-.33.19-.61l-.25.34c0-.34.18-.95.33-.88.03.14-.06.6-.06.71.03-.11.15-.21.16-.13l-.07.18c.08.13.16-.44.24-.11.03.02.08.44.1.24-.04-.39.02-1.57.07-1.86.01.03.16.38.19.57.04.3-.12.71-.09.97,0-.09.04-.2.06-.24.03.08-.03.28.05.25.03-.34.16.04.05-.29.08-.09.08.07.17.06-.02-.22.12-.74.2-.84,0,.09,0,.2,0,.25.16.04.23.2.38.21,0,.08.07.19.04.33.02-.06.05-.17.1-.18.07.3-.1.04-.06.4.02-.2.13-.27.2-.39,0-.31-.15-.07-.22.05.02-.42.16-.86.32-1.04.13-.1.04.27.06.22.23.09.24-.73.41-.41.06.27-.03.53-.02.73-.11.1-.14-.18-.21-.17l.08.13c-.04.09-.11.15-.14.07.05.24.39.07.55.3.04-.09.1-.18.08-.29l-.06.03c-.04-.22.12-.29.06-.4.08-.15.18-.38.28-.25v.31c0-.09-.06-.19-.09-.09.05-.13.14.42.21.02l-.06-.22c.08-.15.2-.47.28-.37-.03-.3-.02.03-.07-.32.03.44-.24-.03-.17.44-.05-.41-.11-.18-.18-.54,0,.1.02.19-.05.14,0,.03-.02.07-.02.09,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.02,0,0,.02.04.03.1.03.16-.05.23-.18.22-.23.33-.04-.05.03-.11,0-.22l-.07.18c0-.22-.1-.38.01-.5l-.1-.02c-.05-.13-.13-.18-.18-.09-.04-.05-.13.24-.08.07l-.16.13v-.06c-.15-.04-.34.35-.49-.06-.05.05-.11.12-.2.05v-.19c-.08.06-.2-.21-.24,0-.04-.53-.32-.13-.43-.23l-.02.25c-.08-.02-.16.05-.27.15v.22c-.1.18-.22-.17-.36-.16.01-.08.05-.06.07,0-.14-.51-.36.35-.49-.03-.04.08-.07.05-.09,0,0,0,0,0,0-.01,0,0,0,0-.01,0-.01-.04-.03-.08-.04-.12.01.06.02.1.04.12-.03,0-.07.03-.12.08v-.24s-.01,0-.01,0c-.04-.09-.04.11-.03.29-.02.04-.05.08-.06.14-.01-.39-.12.12-.14-.29-.04.2-.22.14-.27.56,0-.06,0-.08.01-.08-.04-.05-.09-.1-.14.02v-.31s-.13.41-.13.41c-.05-.19-.07-.3,0-.53-.17.35-.13.13-.28.48l.02-.2s-.13.27-.15.1c-.08-.38-.5-.08-.74-.44.02.58-.11-.27-.14.18,0-.14-.04-.22,0-.34-.14.13-.19-.23-.3.15,0-.14.04-.2.03-.28-.01.03-.05.12-.06.03,0-.08.03-.11.05-.17-.14.02-.17.44-.21.84-.06-.19-.09-.17-.16.09-.02-.13-.05-.27.04-.31-.05-.02-.28-.21-.3.11-.01-.08-.07-.03-.08,0-.11-.02-.11-.05-.22-.03l.03.05c-.06.38-.09.08-.18.12v-.04c-.17-.29-.09.13-.26-.2v.24c-.05.51-.16-.31-.28-.12l.03.14c-.07.17-.13-.71-.19-.78-.01-.05.02-.07.05-.1-.14-.31-.04.31-.16.38-.01-.17.05-.43-.03-.46-.03-.14-.26.54-.35.21.02.13.03.26-.03.36-.09.04-.2-.51-.3-.1,0-.04-.01-.07,0-.1-.07.1-.22.17-.27.39-.01-.83-.42.38-.38-.38l-.2.03v-.08c-.11-.06-.17.12-.22.3-.03-.05,0-.12,0-.16-.18-.16-.2-.13-.37.24v-.25c-.05.14-.25-.4-.45-.12,0-.03,0-.08.03-.11-.22.28-.45-.71-.58.18l-.15.21c.17.08-.05.39.02.54-.07.05-.16-.28-.08-.32v.05c.07-.47-.2-.18-.18-.5-.35,0-.67-.27-.99-.31l.02.37-.11-.03c-.02-.09-.02-.29.06-.27-.03-.21-.14.17-.15.25-.15-.16.08-.42.04-.43l-.07.02v.04c-.05.15-.06.3-.16.28-.06-.08-.02-.23-.04-.24,0-.03,0-.04-.04-.01l-.14-.04.04.29c-.07.14-.13-.02-.08.31-.07-.51-.52-.21-.57-.37-.1.21-.19.2-.29.17.02.06.02.39-.07.34.07-.67-.15-.3-.2-.78.05.32-.27.06-.19.52-.07-.06,0-.25-.04-.41-.2.25-.4-.19-.63-.12,0,.09.02.22-.03.35l-.1-.45s-.07.5-.13.2c0,.07.02.19-.01.21-.42-.45-.93.3-1.34-.53.05.17.01.19-.04.19.03.04-.01.22-.01.34l-.17-.34c-.05.33-.2.01-.24.33l.06-.05c-.1.37.07.83.03,1.31.11-.42.2.64.38.04.03.1-.04.15-.02.26.05-.2.1-.24.17-.15v.05c.22-.04.31.17.57.32v-.24s.06.11.08.17c.08-.36-.16-.03-.08-.42.05.49.4.03.42.58.09,0-.01-.27.08-.27v.15s.05-.19.05-.19c.06.03.07.22.07.35-.01-.02-.04.03-.06.04.06.18.21-.05.23.01l-.08-.1c.24-.13.52.08.77-.2v-.11c.17-.2.12.13.32.05v.03c.04-.11.09-.16.14-.15-.06.13.08.26,0,.4.2-.21.1-.17.25-.58l.02.19c.05-.17.06-.25.16-.3-.09.15.05.29-.05.49.18.42.32-.39.38.2.12-.51-.16-.29-.1-.4-.03-.17.1-.38.16-.32.06.02.07.66.24.66-.02,0-.02.04-.03.03.05.13.13-.17.19.05.06-.31.1.02.13-.37l-.15.08c.09-.1.19-.56.32-.33-.02.08-.06.18-.09.24.03.12.08-.07.12.05-.03.4-.18.08-.29.37.03.17.19-.28.12.15.09-.54.16.08.29-.33l-.02.24s.06-.15.09-.14l-.07.3c.1-.26.16.24.25.1-.18,0-.02-.29-.09-.46.24-.31.09.63.34.53-.04.03-.12-.15-.06-.26.04.05.1.15.12.27.17-.04-.01-.25.07-.39.04.29.09-.11.16-.2v.24c.16.16.06-.5.22-.3l-.09.33.09-.08-.03.27c.11-.2.13-.14.22-.06-.01-.17.04-.44.12-.44.05.15-.04.23.07.2-.03.15-.07.34-.11.11,0,.08-.03.15-.04.23.05.17.15.05.19.05-.02,0-.03-.02-.04-.06l.19-.32c.02.09,0,.16-.03.23.04-.02.07-.13.12-.15-.02.19-.03.4-.11.49l.17-.21c0,.09.07.24.04.31.08.12.24-.37.35-.21,0-.04.02-.07.05-.1.11.05.19.3.34.03l.06.35c.11-.07-.08-.45.1-.57.13-.11.03.3.07.4.07-.17.19-.53.29-.24-.04.06-.07.01-.1.03ZM21.49,46.47s-.08.2-.1.06c.04-.27.06-.14.1-.06ZM23.46,45.99c-.02.08-.05.04-.08-.06.02-.02.05,0,.08.06ZM28.94,44.61s0,0,0,.01c-.05-.1-.03-.06,0-.01ZM29.05,44.72s.01-.07.01-.1c-.01.06-.04.06-.07.04,0,.06.02.11.05.06ZM16.78,44.15l.02.06c-.05.07-.04,0-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M23.22,46.31s0-.09,0-.13c-.01.04-.01.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M19.42,46.64s0,0,0,0c0,.01,0,.03,0,.04v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.17,46.67s-.03-.08-.04-.13c0,.06,0,.11.04.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.67,44.34l-.08.06s.05.04.06.08c0-.06,0-.14.02-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M30.23,45.87s.02,0,.04-.03v-.11s-.08.09-.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.7,45.15c0,.2.04.14.1.1,0,0,0,0,0,0,.03-.28-.03-.19-.09-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.81,45.24s.03-.01.05,0c.01-.11-.02-.02-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.2,44.59c.02.05.03-.26.04-.17.04-.26-.18.3-.04.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "29.7 45.82 29.7 45.57 29.66 45.77 29.7 45.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.31,45.61l.08.07s.01-.07.03-.08c-.05-.01-.1-.06-.1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.41,45.6s.05,0,.07-.04c-.01,0-.05,0-.07.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "29.59 45.89 29.57 45.83 29.51 45.81 29.59 45.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.43,45.52l-.09.07c-.01.09,0,.14.04.11.02-.06.06-.09.05-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.66,46.22c-.02-.05-.02-.11-.03-.19l-.02.31.05-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.4,46.27c-.01.09-.14.24-.03.23.01-.08.11-.15.03-.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "27.07 45.81 27.1 45.81 27.12 45.3 27.07 45.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.82,46.96c.1.13.04-.31.13-.15.03-.12-.07-.13-.04-.23-.07.12-.1.05-.09.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.91,46.57s.02-.04.04-.08c-.02.03-.03.05-.04.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "12.64 43.66 12.58 43.55 12.61 43.73 12.64 43.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.49,44.03v-.33s-.06.29-.06.29c.02-.01.05-.04.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M21.65,47.13v-.08c0-.08-.01-.09-.04-.11l.04.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "20.74 46.84 20.75 46.85 20.74 46.55 20.74 46.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M19.94,47.17s.07-.05.1-.04c-.07.05-.09-.33-.1.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.84,7.21s-.19.02-.23.03c.05.01.28-.04.23-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "52.34 7.32 52.26 7.33 52.47 7.33 52.34 7.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.37,7.51c.35-.08-.07-.06.05-.11l.08-.02-.29.03c.05.03.25.05.16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.63,7.74c.14-.03.12,0,.04-.03-.01,0-.02,0-.03.01,0,0,0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.63,7.72s-.11.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.73,7.8h-.13c-.08.02-.09.04-.15.04.07.02.15,0,.28-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.99,7.78h-.05s-.04,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.82,7.76h.11c.06,0,.17-.02-.04,0,.1-.02,0,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.87,7.74c.07-.03.12-.05.25-.05-.06-.04-.3,0-.25.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.74,7.46l.1-.04h-.12c.06,0-.09.06.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.57,7.99c.08-.01.2-.04.29-.06h-.09s-.09.04-.2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.87,7.93h.13s-.05-.02-.13,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "52.38 7.71 52.1 7.71 52.38 7.72 52.38 7.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "51.58 8.1 51.41 8.11 51.67 8.1 51.58 8.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.62,8.17c-.15.01-.24.06-.33.06.03.02.16.01.27,0-.06,0-.05-.02.06-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.73,8.23s-.1,0-.17,0c.03,0,.08,0,.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.97,7.99s-.16.04-.21.06l.21-.05s0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.98,8h0s0,.02,0,.03c0,0,0-.01.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.97,7.98s0,0,0,0c.02,0,.03,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.2,7.82c.12,0,.25,0,.43-.06-.15.01-.24.05-.43.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.23,7.93l.04-.04c-.06.01-.14.03-.2.03h.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "52.3 7.93 52.23 7.93 52.22 7.94 52.3 7.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.92,8.14c.09,0,.1.01.12.02.04-.02.06-.05.05-.06-.07,0-.19.02-.18.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.96,8.07s0,0,.01,0c.02,0,.02,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.06,8.33s.03,0,.04,0c-.01,0-.02,0-.04,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.13,8.1s-.01-.02-.08-.01c.02,0,.04.01.04.02.03,0,.05,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.83,8.26s.08-.03.11-.04c-.07.02-.17.05-.11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.92,8.09h0s-.02,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.92,8.09s.08,0,.13,0c-.02,0-.04,0-.07,0-.01,0-.04,0-.06.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.42,8.14c-.2.03-.38.03-.18-.04-.15,0-.79.13-1.14.21.09-.01.16-.03.28-.02.1-.03.24-.11.42-.11.11.02-.06.04-.16.08.24-.06.36-.01.72-.08h-.13c.06-.02.15-.03.2-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.11,8.26h-.03s-.11.04-.26.08c.1,0,.17,0,.24-.01l.02-.06h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.08,8.19c.21-.03.31-.01.54-.07-.02-.03-.18,0-.28,0,.06.05-.12,0-.23.07-.04,0-.05-.01-.06-.02-.02.01-.05.03-.09.05,0,0,0,0,.01,0h0s0,0,0,0c.03,0,.04-.01.03,0,0,0,0,0,0,0,.03,0,.06,0,.08-.01-.04.02-.05.01-.08.01-.01,0-.02,0-.03,0,0,0,0,0,0,0l.13.04s.02-.03-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.09,7.72s-.03,0-.05.01c.03,0,.04,0,.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.97,7.76s-.12.01-.1,0c.06-.02.1-.02.17-.03-.06,0-.16,0-.26.04h.03c-.07.04-.33.11-.36.11.19-.04.32-.07.51-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.58,7.97l.11.03.18-.06-.11.02s-.1,0-.18,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "51.96 8.35 51.73 8.38 52.06 8.36 51.96 8.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "52 8.41 51.8 8.44 51.92 8.44 52 8.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M55.03,11.55h.06s-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M55.03,11.44h-.1c.05,0,.09,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.29,9.95c-.18.05-.46.12-.24.08l.21-.04s-.02-.02.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.75,10.79s.04-.01.06-.02c-.07,0-.14.01-.21.02.04,0,.09,0,.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M54.64,10.65l-.13.05s.09-.03.13-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M55.36,12.07l.22-.02s-.11,0-.22.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.19,9.04c-.08.03-.11.05-.12.07.12-.04.3-.09.12-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.76,11.9s.08,0,.13-.01c-.04,0-.08,0-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.08,9.16s.03-.01.05-.02c-.04,0-.07-.01-.06-.03-.09.03-.14.06,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M55.54,14.15s-.01,0-.02,0c.03,0,.03,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.48,15.12s-.02-.01-.02-.02c-.01,0-.01.01.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.95,8.68s-.02,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.78,8.47s.06,0,.1-.01c-.05,0-.08.01-.1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.43,9.06s0,0,0,0c.04-.01.03,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.04,8.64s-.05.02-.06.03c.02,0,.04-.01.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.94,8.66s.01-.01.02-.02c-.04,0-.06,0-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.96,8.7s0-.02.02-.03c-.01,0-.03,0-.03,0,0,0,0,0,.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M54.78,13.15s-.01,0-.02,0c.09,0,.08,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "54.57 9.92 54.56 9.92 54.55 9.92 54.57 9.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M54.74,9.94c-.27.03-.24,0-.19-.02l-.61.12.8-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M55.14,11.78l.19-.07c.32-.01.22.03.48-.04-.67.11-.09-.12-.76,0l.14-.05s.03,0,.03,0c.31-.1-.49.05-.4-.02.05-.03.14-.06.22-.06h-.17s.13-.05.12-.03l-.06-.06h.02c-.11,0-.27.01-.34.01.09-.03.07,0,.16-.02h-.17c.17-.05.34-.05.32-.02.66-.15-.17,0,.2-.14l.09.02c.38-.09.23-.09.46-.17-.12.03-.58.18-.76.17.05-.02.07-.04-.07-.04.24-.04.18-.05.16-.08l.32-.05c-.1-.01-.26.02-.4.03.03-.04.27-.09.47-.13.04-.06-.39.1-.46.05.11-.06-.02-.07-.22-.09.1-.05.19-.03.28-.05l-.26.02s.08-.02.12-.02c-.1,0-.32.05-.41.03-.35.05.5-.16.09-.13.09-.03.19-.03.32-.05-.27-.01-.2-.02-.55,0l.2-.08c-.23.07-.52.08-.75.09-.11.03-.21.06-.26.07l-.18-.02c.05-.02.16-.03.29-.04-.03,0-.05,0-.08,0,.11-.04.3-.06.48-.08-.06.02-.13.04-.19.05.19-.02.41-.04.59-.08-.04,0-.07,0-.09,0,.05,0,.1-.01.13-.02.03,0-.04,0-.12,0l.35-.07-.14.02.21-.11c-.36.01-.89.06-1.05,0,.26-.02.42-.07.73-.12-.32.08.15.04.09.09.03-.03.18-.05.23-.05l-.31-.02c.25-.04.18-.05.28-.09-.49.1-.34,0-.49,0,.17-.03.34-.05.3,0,.36-.1-.59.05-.28-.05,0,0-.02.02.07,0-.15,0-.04-.07.1-.08h0c.05-.06-.03-.17-.45-.11.05-.01.51-.08.59-.09l-1.43.14c.36-.05,1.21-.24,1.42-.22.05-.02.11-.05-.03-.06-.05.02-.52.11-.55.11.39-.11.21-.06.54-.17-.07.03-.64.11-.63.08.09-.01.56-.1.62-.1l-.56.04c.1,0,.47-.08.62-.12-.11.02,0-.05-.06-.06l-.12.05c.07-.08-.79.07-.77,0,.12-.01.71-.1.77-.15-.29.03-1.38.17-1.6.15l.16-.04h-.19c.43-.06,1.34-.14,1.7-.16.12-.05.19-.04.17-.07.15-.04.23-.02.24-.01l.08-.1c-.33.06-.34,0-.62.04l.36.03c-.33.06-.95.11-.9.04.13-.04.59-.09.7-.11-.12.01-.23-.02-.15-.04h.18c.12-.06-.45.02-.14-.08.02-.02.42-.11.22-.08-.37.09-1.54.3-1.83.33.02,0,.35-.13.53-.18.29-.07.71-.09.96-.15-.09.01-.2.02-.24.02.07-.03.28-.04.23-.07-.34.05.02-.07-.29.03-.1-.01.06-.04.04-.08-.22.05-.74.1-.85.08.09-.01.2-.04.25-.05.02-.07.17-.13.16-.19.08-.02.17-.06.32-.08-.06,0-.18.01-.19,0,.28-.09.05.03.4-.05-.2.03-.28,0-.4,0-.3.06-.05.07.08.07-.42.07-.86.1-1.06.08-.11-.03.27-.07.2-.07.06-.1-.74.05-.45-.08.26-.08.53-.09.72-.13.11.02-.16.09-.14.11l.12-.05c.09,0,.16.01.09.04.23-.07.02-.16.23-.27-.09,0-.19,0-.29.03l.04.02c-.21.06-.3,0-.4.05-.16,0-.4,0-.28-.06l.3-.06c-.09.02-.18.06-.08.05-.14,0,.4-.14,0-.09l-.2.07c-.16,0-.48.01-.4-.04-.3.07.04,0-.31.09.43-.1,0,.1.45-.02-.4.1-.16.08-.5.17.1-.02.19-.05.14,0,.03,0,.07,0,.09,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.02,0,0,0,.04-.01.09-.03.15-.04.23-.02.23.03.35.02-.04.03-.12.01-.22.04h.18c-.22.04-.36.11-.5.09v.04c-.12.04-.17.09-.07.09-.04.03.25,0,.08.02l.15.04h-.06c-.02.08.39.07,0,.21.06.01.13.02.07.07l-.19.04c.07.01-.18.11.02.09-.51.12-.09.15-.17.21l.25-.04s.07.05.17.08l.22-.04c.19,0-.14.12-.11.17-.09.01-.07,0-.02-.02-.49.15.39.07.03.19.08,0,.06.02,0,.04,0,0,0,0-.01,0,0,0,0,0,0,0-.04.01-.08.03-.11.04.05-.02.1-.03.12-.04,0,.01.04.02.1.03l-.24.05s0,0,0,0c-.08.03.11,0,.29-.05.04,0,.09,0,.15,0-.38.08.14.02-.27.11.2-.02.16.06.58,0-.05.01-.08.02-.08.01-.04.03-.09.05.03.05l-.3.06.41-.03c-.18.06-.28.09-.52.1.37,0,.14.02.51.01l-.2.03s.28,0,.12.04c-.36.1-.02.21-.34.37.57-.12-.25.09.2.02-.13.03-.21.06-.33.06.14.03-.2.12.18.09-.14.03-.2.02-.28.04.03,0,.12,0,.04.02-.08.02-.12.01-.18.01.03.05.45-.02.85-.08-.18.06-.15.07.11.04-.13.03-.26.07-.31.05-.02.02-.17.15.15.09-.08.02-.02.03.02.03-.01.05-.04.05,0,.09l.05-.02c.38-.05.09.02.14.05h-.04c-.26.13.14.02-.16.15l.24-.05c.51-.08-.29.12-.09.13l.13-.04c.18,0-.68.19-.74.22-.04.01-.07,0-.11,0-.29.12.31-.05.39-.01-.17.04-.43.06-.45.1-.13.04.56,0,.25.1.13-.03.25-.06.35-.06.05.03-.47.17-.06.13-.03.01-.07.02-.1.02.11,0,.19.05.41.03-.81.17.42.09-.33.22l.05.07h-.08c-.04.07.14.06.33.04-.05.02-.12.02-.16.03-.14.1-.11.1.28.1l-.24.05c.14,0-.36.17-.07.2-.03,0-.08.01-.11.01.3.03-.64.31.25.19l.23.02c.06-.08.39-.06.53-.11.06.02-.26.12-.31.09h.04c-.47.06-.15.1-.47.15.05.13-.19.31-.18.44l.36-.08v.05c-.09.03-.29.06-.28.03-.2.05.18.02.26.01-.14.09-.42.05-.43.07l.03.02h.04c.15-.02.31-.04.3,0-.07.04-.22.05-.23.06-.03,0-.04,0,0,.02l-.02.06.28-.07c.14,0,0,.06.31-.03-.49.12-.14.24-.29.29.21,0,.22.03.2.08.06-.02.38-.08.34-.04-.66.1-.27.12-.74.23.31-.08.1.09.54-.03-.05.04-.25.04-.4.1.27.03-.14.19-.04.26.09-.01.22-.05.35-.05l-.42.12s.5-.07.21.01c.07-.02.18-.04.21-.04-.39.25.41.3-.35.62.16-.05.18-.04.19-.02.04-.02.21-.04.33-.06l-.31.13c.33-.04.04.08.35.03h-.06c.37-.05.81-.2,1.28-.28-.42.04.6-.2,0-.16.09-.03.15-.02.26-.04-.2.02-.25,0-.17-.04h.05c-.07-.09.13-.16.24-.29l-.23.05s.1-.05.16-.07c-.36.04,0,.07-.4.11.47-.11-.02-.16.52-.27,0-.03-.27.06-.27.02l.14-.03-.19.02s.21-.07.33-.09c-.01,0,.04,0,.05.01.17-.06-.07-.07-.02-.09l-.08.05c-.15-.07.02-.22-.29-.26l-.11.03c-.22-.03.11-.08,0-.14h.03c-.11,0-.17,0-.16-.03.13,0,.24-.08.39-.08-.23-.04-.18,0-.6.01l.18-.04c-.17.01-.26.03-.31,0,.16,0,.27-.07.49-.07.39-.15-.42-.05.15-.19-.51.05-.27.12-.38.12-.16.05-.38.04-.34,0,0-.03.64-.16.62-.22,0,0,.04,0,.04,0,.12-.05-.18-.02.02-.08-.31.04.01-.04-.38.02l.1.04c-.11-.02-.57.03-.36-.06.08,0,.19-.01.25,0,.11-.04-.08-.02.03-.05.39-.06.1.06.4.04.16-.05-.29-.02.13-.07-.54.07.06-.07-.36-.05l.23-.04s-.15,0-.15,0l.31-.03c-.26,0,.21-.11.07-.12.02.07-.28.06-.44.12-.33-.03.6-.16.47-.23.04,0-.13.07-.24.07.04-.03.13-.07.25-.1-.06-.06-.24.05-.39.05.28-.07-.12-.01-.22-.02l.24-.04c.14-.1-.5.07-.33-.03l.33-.03-.09-.02.27-.04c-.21,0-.16-.02-.09-.07-.17.04-.43.07-.45.04.14-.05.23-.03.19-.07.15-.02.34-.04.12.02.08-.01.15-.02.23-.03.16-.05.03-.07.02-.08,0,0-.02.02-.05.03h-.34c.09-.04.16-.04.23-.04-.03,0-.14,0-.16-.02.19-.03.39-.06.49-.05l-.23-.03c.08-.02.23-.07.3-.08.11-.05-.39-.02-.25-.09-.04,0-.07,0-.1,0,.04-.05.27-.13,0-.14l.34-.09c-.09-.03-.43.12-.57.07-.12-.03.29-.07.39-.1-.18,0-.54.03-.27-.07.07,0,.02.02.05.03ZM54.9,11.31c.05,0,.21,0,.07.03-.27.04-.15,0-.07-.03ZM54.19,10.64c.08,0,.04.01-.04.04-.02,0-.01-.02.04-.04ZM52.17,8.79s0,0,.01,0c-.09.04-.05.02-.01,0ZM52.26,8.73s-.07,0-.1.01c.06,0,.07,0,.05.02.06-.01.1-.03.05-.03ZM53.2,13.57l.06-.02c.07,0,0,.01-.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M54.53,10.67s-.08.02-.13.03c.04,0,.09-.01.13-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M55.32,12.08s0,0,0,0c.01,0,.03,0,.04,0h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M54.4,9.08s-.08.03-.12.04c.06,0,.11-.02.12-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M51.82,8.56l.07.02s.04-.03.07-.04c-.06.01-.13.03-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.24,8.05s0,0-.03,0l-.11.02s.1.01.15-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.6,8.4c.2-.04.13-.04.09-.06,0,0,0,0,0,0-.28.04-.18.05-.09.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.68,8.34s-.02-.01,0-.02c-.11.02-.02.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M52.12,8.69s-.26.04-.18.02c-.26.03.32.01.18-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "53.26 8.26 53.01 8.32 53.21 8.29 53.26 8.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.1,8.46l.06-.04s-.07,0-.09,0c0,.02-.05.05.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.08,8.42s0-.02-.05-.02c0,0,.01.02.05.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "53.34 8.3 53.29 8.32 53.28 8.34 53.34 8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.12,8.81l.08.02c.09-.01.14-.03.1-.04-.06,0-.1,0-.18.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.78,8.59s-.1.03-.18.05l.31-.05h-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.86,8.68c.09-.01.25,0,.23-.03-.08.01-.16-.01-.23.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "53.57 9.28 53.56 9.27 53.06 9.36 53.57 9.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M54.85,9.54c.11-.06-.31.04-.17-.02-.12.01-.12.05-.22.06.13,0,.06.03.39-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M54.46,9.58s-.05,0-.08,0c.03,0,.06,0,.08,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "53.23 15.26 53.13 15.31 53.3 15.26 53.23 15.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M53.61,15.25l-.32.06.29-.03s-.04-.01.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M55.53,11.12h-.08c-.08.03-.09.04-.1.05l.18-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "55.35 11.53 55.36 11.52 55.07 11.58 55.35 11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M55.78,11.77s-.06-.02-.05-.03c.06.02-.31.1.05.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.63,51.58s-.1-.16-.12-.2c0,.05.15.24.12.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "27.72 52.08 27.68 52.01 27.77 52.2 27.72 52.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.56,52.18c.21.29.03-.09.12,0l.05.07-.14-.25c0,.06.05.25-.03.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.06,51.58c.08.11.05.11.04.02,0-.01-.02-.02-.02-.03,0,0,0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.08,51.58s-.07-.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.05,51.7l-.04-.12c-.05-.07-.08-.07-.1-.12.01.07.06.14.15.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.17,51.93l-.02-.05s-.03-.04.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.11,51.77l.03.11s.1.14-.01-.04c.05.09,0,0-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.16,51.81c.05.06.1.09.14.21.02-.07-.12-.28-.14-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.75,52.5l.07.08-.05-.11c.02.05-.08-.06-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.81,51.62c.04.06.11.17.17.25l-.03-.08s-.08-.07-.14-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.98,51.87l.04.13s0-.06-.04-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "27.37 52.27 27.27 52.01 27.37 52.28 27.37 52.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "26.72 51.67 26.64 51.51 26.75 51.76 26.72 51.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.67,51.74c-.07-.13-.14-.2-.18-.28,0,.03.05.15.09.25-.02-.06,0-.06.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.65,51.86s-.04-.09-.06-.15c.01.03.03.08.06.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.97,51.99s-.09-.14-.13-.17l.12.18h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.96,52h0s-.03,0-.03,0c0,0,.01,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.97,51.99h0s.02.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.21,52.14c.05.11.09.24.21.37-.07-.13-.14-.21-.21-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.12,52.21l.05.03s-.08-.11-.1-.17l.05.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "27.14 52.28 27.12 52.21 27.1 52.2 27.14 52.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.8,52c.04.09.03.1.02.12.04.03.06.04.08.03-.03-.06-.09-.17-.1-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.89,52.02s0,0,0,.01c.01.01.02.02,0-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "26.69 52.2 26.71 52.23 26.69 52.2 26.69 52.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.93,52.18s.01-.02-.02-.08c0,.02,0,.04,0,.05.01.03.03.04.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.67,51.96s.06.06.08.09c-.04-.05-.11-.14-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.86,51.98h0s-.02-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.86,51.98s.03.08.05.12c0-.02,0-.04-.02-.07,0-.01-.02-.03-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.35,53.4c-.1-.17-.16-.35-.03-.18-.05-.14-.41-.69-.62-.99.04.07.09.14.12.26.06.09.19.18.26.35.02.11-.06-.04-.14-.12.14.2.14.33.33.64l-.03-.13s.06.13.1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.77,52.22v-.03s-.08-.08-.18-.21c.03.09.07.16.1.22h.07s.01.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.81,52.17c.1.19.13.28.26.47.02-.03-.07-.17-.1-.26-.02.08-.05-.11-.15-.19,0-.04,0-.05,0-.06-.02-.02-.05-.04-.08-.07h0s0,0,0,0h0s.03.04.01.03h0s.03.05.04.08c-.04-.03-.03-.05-.04-.07l-.02-.03h0s.01.13.01.13c.03.02.04,0,.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.64,52.93s-.02-.03-.03-.04c.01.02.02.04.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.55,52.83s-.05-.1-.03-.09c.04.05.05.09.09.15-.02-.05-.06-.15-.13-.22v.03s-.22-.26-.23-.29c.11.16.19.27.3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.21,52.55v.12s.13.15.13.15l-.06-.1s-.03-.09-.07-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "26.63 52.11 26.51 51.92 26.66 52.21 26.63 52.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "26.59 52.17 26.49 52 26.53 52.11 26.59 52.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M24.44,56.07v.06s0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M24.55,56.03l-.04-.09c.02.05.03.09.04.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.24,52.96c-.11-.15-.26-.4-.15-.2l.11.19s.02-.02.05.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M24.87,54.61l.03.06c-.03-.07-.05-.13-.08-.19.01.04.03.09.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.25,55.42l-.09-.11s.06.08.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M23.97,56.53l.07.21s-.03-.11-.07-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.07,52.57c-.06-.06-.09-.09-.1-.09.08.1.19.25.1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M23.53,53.95s.02.08.04.12c0-.04-.02-.08-.04-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.92,52.5s.02.03.03.04c0-.04,0-.07.01-.07-.06-.07-.1-.11-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M21.84,57.17s0-.01-.01-.02c0,.03.01.03.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M20.53,55.31s.01-.02.02-.02c0-.01-.02,0-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.32,52.22s-.01-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.81,52.92s.03.05.05.09c-.02-.05-.04-.08-.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.47,53.75h0s.02.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.39,52.29s-.03-.04-.05-.05c.01.01.03.03.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.33,52.21s.02,0,.02.01c-.02-.03-.03-.05-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.31,52.24s.02,0,.03,0c0-.01-.02-.02-.02-.03,0,0,0,.01-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M22.74,56.21s0,0-.01-.02c.02.09.02.07.01.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "25.98 55.12 25.97 55.11 25.97 55.1 25.98 55.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26,55.29c-.1-.25-.08-.23-.04-.18l-.3-.55.34.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M24.22,56.23l.11.16c.09.31.02.22.16.46-.27-.62.1-.12-.17-.74l.08.12s0,.03,0,.03c.18.28-.17-.46-.08-.4.04.04.09.12.11.2l-.03-.17s.06.12.05.11l.04-.08v.02c-.02-.1-.07-.26-.09-.33.06.08.02.07.06.14l-.03-.17c.09.15.13.32.09.31.32.6-.04-.17.2.16v.09c.19.34.15.2.29.4-.06-.11-.33-.51-.36-.68.03.04.06.06.02-.08.1.22.1.16.12.13l.13.29c-.01-.1-.08-.24-.13-.38.04.01.16.24.25.42.07.02-.2-.34-.17-.43.09.09.07-.04.03-.24.08.09.08.18.13.26l-.08-.24s.04.07.06.11c-.02-.1-.14-.29-.14-.38-.14-.32.29.43.16.05.05.08.08.18.14.29-.06-.26-.03-.2-.14-.54l.13.17c-.13-.2-.22-.48-.29-.7-.06-.1-.12-.19-.14-.23l-.03-.18s.07.15.12.27l-.02-.07c.07.1.14.27.21.43-.03-.05-.07-.11-.11-.17.07.18.16.38.24.55-.01-.04-.02-.07-.02-.09.02.05.04.09.05.12.02.03,0-.04-.04-.11l.17.31-.06-.13.17.17c-.11-.35-.3-.84-.3-1.01.1.24.19.38.33.66-.17-.28,0,.15-.07.11.04.02.1.15.12.2l-.06-.3c.11.23.1.16.17.25-.24-.44-.1-.32-.14-.48.08.15.15.31.1.29.21.32-.22-.55-.03-.28,0,0-.02-.01.01.07-.05-.14.05-.06.11.07h0c.08.03.17-.08-.01-.46.02.05.23.46.26.54l-.56-1.32c.16.33.6,1.08.64,1.29.04.04.08.08.05-.04-.03-.04-.27-.46-.27-.49.22.34.12.18.33.46-.05-.06-.3-.58-.27-.57.04.08.27.5.28.56l-.21-.53c.03.1.22.42.31.56-.06-.09.05-.02.04-.07l-.08-.1c.1.04-.31-.73-.24-.74.05.11.32.64.38.69-.12-.26-.59-1.25-.65-1.48l.09.14-.05-.19c.18.39.55,1.23.68,1.57.08.1.1.17.13.14.09.13.09.22.09.23l.13.04c-.16-.29-.1-.33-.24-.57l.08.35c-.16-.29-.4-.87-.32-.84.08.11.28.53.33.63-.05-.11-.05-.22,0-.15l.06.17c.09.09-.16-.42.03-.16.02.01.25.36.15.18-.21-.32-.78-1.36-.91-1.62.02.02.24.29.35.44.17.25.32.64.46.86-.04-.08-.09-.19-.1-.22.05.06.13.25.14.2-.16-.3.07,0-.13-.26-.02-.1.06.04.09.01-.12-.19-.34-.67-.36-.77.04.08.1.17.13.21.07,0,.18.11.23.08.05.07.12.14.18.27-.02-.06-.07-.16-.06-.18.18.24-.01.06.19.35-.1-.17-.09-.26-.13-.38-.16-.26-.08-.02-.05.1-.21-.37-.39-.77-.43-.97,0-.12.16.23.13.17.12.02-.3-.68-.08-.45.16.22.27.46.37.62.02.11-.14-.12-.16-.09l.09.09c.03.08.04.16,0,.1.14.2.16-.04.34.11-.03-.08-.06-.18-.13-.26v.04c-.13-.18-.12-.28-.19-.35-.05-.15-.14-.37-.04-.29l.16.26c-.05-.08-.12-.14-.08-.06-.05-.13.27.32.08-.03l-.13-.17c-.05-.15-.19-.45-.11-.38-.17-.25.01.03-.19-.26.25.37-.09.03.18.41-.23-.34-.13-.12-.34-.41.05.09.11.16.06.13.01.03.03.06.04.08h0s0,0,0,0c0,.01,0,.02,0,0,.03.03.06.08.09.12.1.21.06.23.1.34-.04-.03-.05-.1-.12-.19l.07.17c-.12-.19-.23-.3-.26-.43h-.04c-.08-.09-.14-.11-.11-.02-.04-.03.08.24,0,.08l.02.15-.03-.05c-.07,0,.08.39-.19.07.01.06.03.13-.04.09l-.1-.17c.01.07-.16-.13-.07.05-.28-.44-.17-.04-.25-.1l.12.22s-.03.08-.01.19l.11.2c.06.18-.15-.1-.19-.05-.04-.08-.01-.06.02-.02-.3-.41.05.39-.17.09.03.08,0,.06-.03.01,0,0,0,0,0-.01h0s-.05-.07-.07-.1c.03.04.06.08.07.1,0,0,0,.04,0,.1l-.12-.21h0c-.06-.06.04.11.14.27.01.04.03.08.05.14-.19-.34.02.14-.19-.22.08.18,0,.17.19.56-.03-.05-.04-.07-.04-.08-.04-.03-.08-.07-.04.05l-.15-.27.15.38c-.11-.15-.17-.25-.25-.47.11.35.02.14.14.49l-.09-.18s.08.26,0,.12c-.21-.32-.21.05-.46-.22.28.51-.16-.21.04.19-.07-.12-.11-.18-.15-.3.01.15-.17-.16-.03.2-.07-.12-.08-.19-.12-.26,0,.03.04.11,0,.04-.04-.07-.04-.11-.06-.16-.04.04.15.43.32.79-.11-.16-.11-.13-.01.12-.07-.11-.14-.23-.13-.29-.03,0-.19-.12-.05.17-.04-.07-.03,0-.02.03-.05,0-.06-.02-.09.02l.03.04c.15.35,0,.09,0,.15l-.02-.04c-.19-.22.03.13-.18-.12l.11.21c.21.47-.19-.25-.15-.05l.07.12c.05.17-.36-.6-.41-.65-.02-.04-.02-.07-.03-.1-.19-.25.13.29.11.37-.08-.15-.17-.4-.21-.41-.07-.12.15.54-.03.26.06.11.13.23.15.33-.01.06-.29-.41-.15-.02l-.05-.09c.02.11,0,.2.07.41-.36-.75.02.43-.3-.26l-.06.07-.03-.07c-.07-.03-.01.15.05.32-.03-.04-.05-.11-.07-.15-.13-.11-.12-.08-.03.3l-.1-.23c.04.14-.25-.31-.21-.02-.01-.03-.03-.07-.04-.11.04.3-.45-.56-.13.29l.04.23c.09.04.14.37.23.49,0,.06-.17-.22-.16-.28l.02.04c-.17-.44-.15-.12-.27-.42-.12.07-.34-.11-.47-.09l.15.33h-.05c-.04-.08-.12-.26-.08-.26-.09-.19.01.18.04.26-.11-.11-.13-.41-.15-.41v.03s0,.04,0,.04c.04.15.09.29.05.29-.05-.06-.09-.21-.11-.21,0-.02-.02-.03-.02,0h-.06s.13.25.13.25c.03.14-.06,0,.09.3-.22-.46-.26-.09-.34-.23.04.21,0,.22-.04.21.03.05.15.35.1.33-.22-.63-.17-.25-.36-.69.14.29-.07.11.12.52-.05-.04-.09-.23-.17-.37.02.27-.21-.1-.27.01.03.08.09.2.11.33l-.19-.4s.15.48.02.21c.03.07.07.17.07.2-.31-.34-.24.46-.67-.25.08.15.07.17.05.19.02.03.07.21.11.32l-.18-.29c.09.32-.07.05.02.35v-.06c.09.37.31.77.46,1.23-.1-.41.29.56.16-.03.04.09.04.15.08.25-.05-.2-.05-.25.02-.17v.05c.09-.08.2.1.35.19l-.09-.22s.06.09.09.14c-.09-.35-.07,0-.18-.38.19.44.16-.05.36.46.04,0-.1-.25-.07-.26l.06.14-.05-.18s.11.19.15.31c-.01-.01,0,.04,0,.05.09.15.06-.09.09-.04l-.06-.07c.05-.16.23-.02.22-.34l-.05-.1c0-.22.1.09.14-.02v.03c-.02-.11-.02-.17,0-.17.03.13.13.22.15.37,0-.24-.02-.18-.12-.58l.08.17c-.04-.16-.07-.25-.05-.31.03.16.12.25.16.46.23.35-.03-.43.22.11-.15-.49-.17-.24-.19-.35-.08-.15-.11-.37-.07-.33.03,0,.28.6.34.56,0,0,0,.04,0,.04.07.11-.02-.18.09,0-.1-.3.04,0-.1-.37l-.02.11c0-.11-.14-.55,0-.36.03.08.05.18.06.24.06.1,0-.08.06.02.14.37-.04.11.04.4.08.15-.04-.29.1.11-.18-.52.09.04-.02-.36l.09.22s-.03-.15-.02-.15l.09.29c-.06-.26.15.19.13.04-.07.04-.12-.26-.22-.41-.03-.33.28.56.34.41,0,.04-.1-.11-.12-.22.04.04.1.11.15.22.05-.07-.1-.22-.13-.37.13.26-.01-.12-.02-.22l.09.22c.13.11-.17-.47-.04-.33l.1.32v-.09s.1.26.1.26c-.04-.2,0-.16.06-.1-.07-.15-.16-.41-.14-.43.08.12.08.22.11.17.05.14.11.32,0,.13.03.07.05.14.08.22.09.14.08,0,.09,0-.01,0-.02-.01-.04-.04l-.06-.34c.05.08.07.15.09.22,0-.03-.03-.14-.02-.16.07.18.15.37.16.47l-.02-.23c.04.08.12.2.14.27.08.09-.06-.39.04-.27-.01-.04-.02-.07-.02-.1.06.02.2.23.14-.04l.17.31c0-.09-.22-.39-.2-.54,0-.12.14.27.2.35-.05-.17-.15-.52,0-.28.01.07-.02.02-.02.05ZM24.65,55.87c.01.05.06.2,0,.08-.11-.26-.04-.14,0-.08ZM25.14,54.99c.03.08,0,.04-.05-.03,0-.02.01-.02.05.03ZM26.29,52.46h0c-.07-.06-.04-.03,0,0ZM26.38,52.53s-.03-.06-.05-.09c.03.05.02.06,0,.05.03.05.06.09.05.03ZM22,54.76l.03.06c0,.07-.01.01-.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.21,55.32s-.04-.08-.06-.12c.01.04.03.08.06.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "23.96 56.49 23.96 56.48 23.97 56.53 23.96 56.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.76,54.67s-.05-.06-.08-.1c.03.05.06.09.08.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.38,52.05v.07s.04.03.07.05c-.03-.05-.08-.12-.07-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.37,53.2s0,0,0-.04l-.06-.1s.02.1.06.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.82,52.73c.11.17.09.1.09.06h0c-.14-.24-.11-.15-.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.9,52.78s0-.02.01-.01c-.06-.1-.02-.02-.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.37,52.39s-.13-.23-.08-.16c-.12-.23.1.3.08.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "27.17 53.29 27.04 53.08 27.13 53.26 27.17 53.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.94,53.22l.06.04s-.03-.06-.04-.08c-.02,0-.07-.03-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.97,53.19s.02-.01,0-.05c0,0-.01.02,0,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "27.17 53.38 27.14 53.34 27.11 53.34 27.17 53.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.6,53.36v.08c.04.08.08.12.07.08-.02-.06-.03-.09-.07-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.04,53.9s-.06-.09-.11-.16l.15.27-.04-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.98,54.02c.04.08.08.24.11.2-.04-.08-.04-.16-.11-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "26.3 53.95 26.3 53.94 26.06 53.5 26.3 53.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.44,55.26c.1.09-.14-.28-.03-.17-.05-.11-.09-.09-.13-.19.04.12-.01.07.16.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.28,54.9s-.01-.04-.02-.07c.01.03.02.05.02.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "20.35 55.08 20.29 54.99 20.36 55.14 20.35 55.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M20.42,55.45l-.11-.31.08.28s0-.05.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25,56.42l-.03-.07c-.04-.07-.05-.08-.07-.08l.1.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "24.54 56.37 24.55 56.37 24.41 56.11 24.54 56.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M24.38,56.85s0-.06.02-.06c0,.06-.17-.28-.02.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M6.4,28.81s-.05.18-.06.22c.03-.04.08-.27.06-.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "6.73 28.4 6.71 28.48 6.79 28.28 6.73 28.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M6.94,28.45c.07-.35-.09.04-.09-.09v-.08s-.07.28-.07.28c.05-.03.16-.21.16-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M6.86,29.23c.03-.14.05-.11-.01-.05,0,.02,0,.02,0,.04,0,0,.01,0,.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M6.84,29.21s-.01.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M6.96,29.16l-.06.11c-.01.08,0,.1-.02.16.04-.06.06-.14.07-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.04,28.91l-.03.05s0,.05.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M6.96,29.06l.06-.1c0-.06.04-.17-.02.04.03-.1,0,0-.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M6.96,29c0-.08,0-.13.05-.24-.06.03-.12.28-.05.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.03,28.09v-.11s-.04.11-.04.11c.02-.06.02.1.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.08,29.38c.02-.07.04-.2.06-.29l-.04.08c0,.05,0,.1-.02.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.14,29.09l.06-.12s-.04.04-.06.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "7.15 28.53 7.03 28.78 7.16 28.53 7.15 28.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "7.19 29.42 7.13 29.59 7.23 29.34 7.19 29.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.28,29.41c-.05.14-.04.24-.08.33.03-.02.08-.14.12-.24-.03.06-.05.04-.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.38,29.34s-.04.09-.07.15c.02-.03.04-.07.07-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.25,29.02s-.03.16-.03.22l.04-.21h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.26,29.02h0s.02.02.02.02c0,0,0,0-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.25,29.02h0s0-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.18,28.74c.05-.11.12-.23.12-.41-.05.14-.05.24-.12.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.3,28.75l-.02-.06c-.01.06-.03.14-.05.19l.07-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "7.33 28.69 7.3 28.75 7.3 28.77 7.33 28.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.38,29.13c.04-.09.05-.09.08-.1,0-.05-.02-.07-.04-.08-.02.06-.06.18-.04.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.33,29.06s0,0,0-.01c0-.02,0-.02,0,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "7.62 29.08 7.63 29.04 7.62 29.08 7.62 29.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.42,28.92s-.02,0-.05.07c.02-.02.03-.03.04-.03,0-.03.01-.05,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.46,29.26s0-.08,0-.12c-.01.07-.02.17,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.32,29.11h0c0,.05,0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.32,29.11s.03-.08.05-.12c-.01.01-.03.03-.04.06,0,.02,0,.04-.01.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.03,27.77c-.05.19-.14.36-.12.14-.07.14-.22.77-.28,1.13.02-.08.04-.16.11-.27.02-.11,0-.26.07-.43.07-.09.02.08.01.18.05-.24.15-.33.23-.69l-.07.11c.01-.05.05-.14.05-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.57,29.01l-.02.02s0,.12-.02.27c.05-.09.07-.16.09-.22l-.06-.04v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.5,29.01c.06-.21.12-.29.16-.52-.04,0-.07.17-.12.25.08-.04-.05.11-.03.24-.02.03-.04.04-.05.05,0,.03,0,.06,0,.1h0s0-.01,0-.01h0s0-.05,0-.03h0s.02-.06.02-.08c0,.05-.01.05-.02.08v.03s0,0,0,0l.09-.1s-.02-.03-.06-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.45,27.88s0,.03-.01.05c.01-.02.02-.04.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.44,28.02s-.04.11-.05.09c0-.07.03-.1.04-.17-.02.05-.07.14-.07.25v-.03c.02.08-.01.35-.03.37.04-.19.07-.33.1-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.49,28.46l.08-.09.02-.19-.03.11c-.02-.05-.05.08-.07.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "7.6 29.19 7.53 29.4 7.65 29.1 7.6 29.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "7.67 29.18 7.62 29.37 7.67 29.26 7.67 29.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.26,28.43l.04-.04s-.03.03-.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.17,28.37l-.05.08s.05-.08.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M9.22,29.65c-.05.18-.13.45-.05.25l.07-.2s-.03,0-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.79,28.94l.02-.06c-.04.06-.08.12-.11.18.03-.04.05-.07.08-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.21,28.15l-.04.14s.03-.09.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.88,28.48l.11-.19s-.06.1-.11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.36,29.29c0,.09,0,.12,0,.14.02-.13.05-.31,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.16,30.46s.05-.07.07-.11c-.03.03-.05.06-.07.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.41,29.44s0-.03,0-.05c-.02.03-.05.05-.06.04-.01.09-.01.15.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M14.5,29.09s0,.01,0,.03c0-.03,0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M15.4,31.17s-.02.02-.03.02c0,.01.02,0,.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.91,29.34s0,.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.07,28.5s.02-.05.03-.1c-.02.05-.03.08-.03.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.96,28.2h0s0-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.91,29.24s0,.05,0,.07c0-.02,0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.89,29.34s0-.02,0-.02c-.01.03-.02.06,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.93,29.33s-.01-.01-.02-.03c0,.01,0,.03,0,.03,0,0,.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M13.47,29.52s0,.01,0,.02c.04-.08.03-.07,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "10.44 27.72 10.43 27.73 10.43 27.73 10.44 27.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.56,27.59c-.13.24-.13.2-.13.14l-.23.58.36-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.52,28.5l.06-.19c.18-.27.16-.16.25-.42-.31.61-.15,0-.46.6l.04-.14s.02-.03.02-.02c.11-.31-.25.42-.26.31,0-.06.04-.15.09-.22l-.12.13s.05-.12.06-.1l-.09.02v-.02c-.05.09-.15.22-.19.28.03-.09.04-.06.08-.14l-.11.13c.07-.16.18-.3.19-.26.28-.62-.11.14,0-.25l.07-.06c.16-.35.07-.24.14-.47-.05.12-.21.57-.33.7.01-.05.01-.08-.07.03.11-.21.06-.17.03-.17l.15-.28c-.07.07-.15.21-.23.33-.02-.04.09-.27.18-.46-.03-.07-.15.37-.24.39.01-.13-.08-.03-.22.11.02-.11.1-.17.13-.26l-.15.21s.03-.08.05-.11c-.07.08-.15.28-.23.34-.17.31.17-.49-.06-.16.03-.09.1-.17.15-.28-.18.2-.14.14-.35.43l.05-.21c-.08.23-.25.46-.39.65-.04.11-.08.2-.1.25l-.13.13c.02-.05.07-.15.14-.26l-.04.06c.03-.12.13-.27.22-.43-.02.06-.05.12-.07.19.1-.17.21-.35.3-.52-.02.03-.04.06-.06.07.03-.04.05-.09.06-.12.01-.03-.02.03-.07.1l.15-.32-.07.12.03-.24c-.22.29-.5.74-.64.83.14-.23.19-.38.33-.66-.12.31.13-.09.14-.01,0-.04.06-.17.09-.21l-.21.23c.11-.23.07-.18.09-.28-.2.46-.21.27-.3.39.07-.15.15-.3.18-.25.12-.36-.31.5-.22.19.01,0,0,.03.05-.05-.09.12-.09,0-.02-.14h.01c-.04-.08-.2-.09-.38.29.02-.05.22-.46.26-.54l-.69,1.26c.16-.33.46-1.15.6-1.31,0-.05,0-.12-.08-.02,0,.05-.18.5-.21.52.12-.39.06-.21.14-.55-.01.08-.25.6-.27.57.04-.08.22-.52.25-.57l-.28.49c.05-.09.18-.44.23-.59-.03.1-.05-.03-.09.01l-.02.13c-.04-.11-.36.71-.42.65.05-.11.28-.66.27-.74-.12.26-.57,1.26-.7,1.45l.05-.16-.11.16c.17-.4.58-1.22.75-1.53.02-.13.06-.18.01-.19.04-.15.11-.21.12-.21l-.06-.13c-.11.32-.19.29-.29.55l.23-.29c-.11.32-.39.87-.44.79.03-.13.22-.56.26-.66-.05.11-.14.18-.12.1l.09-.16c0-.13-.21.4-.15.08,0-.03.1-.43.03-.24-.1.37-.49,1.49-.6,1.76,0-.03.05-.37.09-.56.07-.29.27-.67.33-.92-.03.09-.08.19-.1.22,0-.08.1-.27.05-.24-.12.32-.06-.05-.11.27-.07.08-.01-.08-.06-.08-.06.21-.27.7-.33.78.03-.08.06-.19.07-.24-.06-.05-.05-.21-.11-.23.02-.08.02-.19.07-.32-.03.05-.07.16-.09.16.05-.29.06-.03.13-.38-.06.19-.13.24-.2.35-.08.29.05.08.11-.03-.13.4-.3.81-.43.98-.08.08.06-.27.03-.21-.08-.1-.29.68-.28.37.04-.27.15-.51.2-.7.07-.09.02.18.05.18v-.13c.04-.08.09-.14.08-.06.04-.24-.15-.09-.17-.33-.04.08-.09.17-.11.27l.03-.03c-.04.21-.13.28-.12.38-.07.14-.17.36-.18.23l.07-.3c-.02.09-.02.18.02.1-.05.13.04-.42-.09-.04l-.02.21c-.07.14-.2.44-.21.34-.06.3.02-.03-.05.32.09-.43.09.04.18-.41-.08.4,0,.18-.06.53.03-.1.04-.19.06-.13.01-.03.02-.06.03-.08h0s0,0,0,0c0-.01,0-.02,0,0,0-.04.01-.1.03-.15.08-.22.13-.2.18-.31,0,.05-.04.11-.06.22l.08-.17c-.06.22-.05.37-.13.49l.04.02c-.01.13,0,.19.05.1,0,.05.12-.22.05-.06l.1-.11-.02.05c.05.04.24-.32.19.09.04-.05.08-.11.09-.04l-.05.19c.05-.06.02.21.09.02-.14.51.09.15.1.25l.08-.24s.08-.03.15-.12l.07-.21c.1-.16.03.18.09.18-.03.08-.04.05-.03,0-.11.5.26-.3.19.07.04-.07.04-.04.03.02,0,0,0,0,0,0h0s-.02.09-.02.12c.01-.05.02-.1.03-.12.01,0,.04-.02.08-.07l-.08.23h0c-.02.08.05-.11.11-.28.02-.03.05-.08.08-.13-.13.37.09-.1-.05.29.09-.18.14-.11.31-.5-.02.05-.03.08-.04.08,0,.05,0,.1.06,0l-.11.29.2-.36c-.05.18-.08.29-.2.49.2-.31.1-.11.29-.41l-.08.18s.16-.23.1-.07c-.12.36.17.14.12.5.24-.53-.07.26.13-.15-.06.13-.08.2-.15.3.11-.1-.02.23.18-.09-.06.13-.1.17-.13.25.02-.02.07-.1.04-.02-.03.08-.06.1-.09.15.06,0,.26-.37.44-.72-.06.18-.03.16.1-.06-.05.12-.1.25-.15.27,0,.03.02.23.17-.06-.03.08.01.03.04,0,.03.04.02.07.08.06v-.05c.21-.33.09-.06.14-.08l-.02.03c-.05.29.1-.1.02.22l.11-.21c.25-.45-.08.3.06.15l.05-.13c.11-.14-.26.66-.27.73-.02.04-.04.06-.06.08-.08.3.16-.27.24-.31-.07.15-.21.38-.2.42-.05.13.35-.44.24-.13.05-.12.1-.24.17-.32.06-.02-.13.49.09.14-.01.03-.03.07-.04.09.08-.08.17-.11.29-.3-.35.75.35-.27,0,.41h.1s-.04.07-.04.07c.03.07.13-.08.23-.24-.01.05-.05.11-.07.15.01.18.04.15.27-.16l-.1.23c.08-.12-.04.41.16.18-.01.03-.03.07-.05.1.2-.23-.03.73.34-.09l.15-.18c-.05-.1.16-.36.18-.51.05-.04-.02.28-.08.31v-.04c-.18.43.05.19-.07.49.17.04.25.34.41.41l.08-.36.05.04c0,.09-.06.28-.09.25-.03.21.12-.15.14-.22.04.16-.14.4-.12.42l.04-.02v-.04c.07-.14.11-.29.16-.26.01.08-.04.22-.03.24,0,.02,0,.04.02.02l.07.05.04-.29c.07-.13.06.03.11-.3-.07.5.23.23.23.39.08-.2.12-.19.18-.16,0-.06.04-.38.07-.34-.11.66.04.3.03.78,0-.32.15-.06.14-.52.03.06-.02.25,0,.41.12-.25.21.19.36.1,0-.09-.02-.22.01-.35l.07.44s.02-.51.07-.2c0-.07-.02-.19,0-.21.29.42.43-.38.84.36-.07-.16-.05-.18-.03-.19-.03-.04-.05-.21-.08-.33l.18.3c-.06-.33.11-.05.03-.36l-.02.06c-.07-.37-.28-.78-.39-1.25.07.42-.22-.59-.13,0-.03-.09-.02-.15-.05-.26.03.2.02.25-.02.16v-.05c-.07.06-.14-.13-.23-.26l.03.24s-.03-.1-.04-.16c0,.36.05.02.07.41-.07-.48-.14,0-.18-.54-.03,0,.02.27-.01.27v-.15s-.01.19-.01.19c-.02-.03-.03-.22-.03-.34,0,.01.01-.04.02-.05-.02-.17-.06.06-.07,0l.02.09c-.08.14-.15-.06-.26.23v.11c-.09.2-.04-.12-.12-.04v-.03c-.02.11-.05.16-.07.15.04-.13,0-.26.05-.4-.1.21-.06.17-.17.57l.02-.18c-.05.16-.06.25-.11.29.06-.15.03-.28.1-.48.01-.41-.19.38-.1-.21-.15.49,0,.29-.04.4-.02.17-.11.37-.13.31-.02-.02.11-.65.05-.65,0,0,.01-.03.02-.03.01-.13-.09.16-.06-.05-.1.3-.03-.03-.14.35l.08-.07c-.06.09-.21.53-.21.3.03-.08.07-.17.1-.22.02-.12-.05.07-.03-.05.12-.38.09-.06.2-.35.03-.16-.14.26,0-.15-.17.52-.03-.08-.19.31l.07-.23s-.06.14-.07.13l.11-.29c-.11.24.01-.24-.06-.11.06.01-.08.28-.1.45-.18.28.15-.6.03-.52.02-.03,0,.15-.06.25,0-.05,0-.15.04-.27-.07.03-.07.23-.15.36.08-.28-.07.1-.13.18l.08-.23c-.01-.17-.2.46-.19.27l.15-.3-.06.07.11-.25c-.11.18-.1.12-.1.04-.06.16-.17.4-.2.4.03-.14.1-.21.04-.19.07-.14.15-.31.08-.09.03-.07.06-.14.1-.21.04-.16-.04-.06-.05-.06,0,.01,0,.03,0,.06l-.19.28c.03-.09.06-.15.1-.21-.02.02-.07.12-.1.13.08-.18.16-.36.22-.44l-.14.17c.03-.08.07-.23.1-.29.02-.12-.23.31-.21.16-.02.03-.04.06-.06.09-.02-.06.05-.29-.12-.07l.13-.33c-.07.05-.16.42-.28.51-.09.08.12-.28.14-.37-.1.15-.3.45-.21.17.04-.05.03,0,.06-.02ZM11.97,28.39s.12-.17.07-.04c-.14.24-.09.12-.07.04ZM10.92,28.49c.04-.07.04-.03,0,.06-.02.01-.03,0,0-.06ZM8.11,29.19h0c0,.09,0,.05,0,0ZM8.1,29.08s-.02.06-.03.1c.02-.06.03-.06.04-.04.01-.06.02-.11,0-.06ZM13.21,31.13v-.06c.05-.06.02,0,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M11.16,28.24s-.04.08-.06.12c.02-.03.04-.08.06-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "12.86 28.52 12.86 28.52 12.88 28.48 12.86 28.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M9.47,27.37s0,.08-.02.12c.02-.06.03-.1.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.74,29.41l.05-.05s0-.04,0-.08c-.01.05-.03.13-.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.86,27.89s-.01,0-.02.03l-.03.11s.06-.09.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.92,28.63c.05-.2.01-.14-.02-.1h0c-.08.27-.03.19.01.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M7.9,28.53s-.02.01-.02,0c-.03.11,0,.03.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8,29.19c0-.05-.08.25-.06.17-.08.25.15-.28.06-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "8.08 27.98 8.02 28.22 8.09 28.03 8.08 27.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.21,28.2l-.02-.08s-.02.06-.03.08c.02.01.03.07.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.16,28.2s-.02,0-.04.03c0,0,.02,0,.04-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "8.15 27.92 8.15 27.97 8.17 27.99 8.15 27.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.57,28.36l.06-.06c.03-.08.03-.13,0-.11-.03.05-.05.08-.07.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.65,27.66c0,.05-.02.11-.04.19l.09-.3-.05.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M8.78,27.63c.03-.08.13-.22.07-.22-.03.08-.09.14-.07.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "9.25 28.19 9.24 28.19 9.07 28.68 9.25 28.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.2,27.25c0-.13-.13.29-.12.13-.06.11,0,.13-.06.22.08-.11.06-.03.17-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M10.03,27.6s-.02.04-.04.07c.02-.03.03-.05.04-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "15.62 31.4 15.69 31.49 15.62 31.33 15.62 31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M15.59,31.02l.1.31-.06-.29s-.01.05-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.2,27.77l-.04.07c-.04.08-.03.09-.03.1l.06-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "12.44 28.17 12.44 28.16 12.31 28.43 12.44 28.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M12.89,27.97s-.05.04-.05.02c.05-.04-.1.31.05-.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.1,3.66s-.14.13-.16.16c.04-.03.2-.2.16-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "25.49 3.39 25.43 3.45 25.59 3.31 25.49 3.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.55,3.45c.25-.26-.06.02.02-.08l.06-.06-.21.2s.2-.14.14-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.04,4.03c.1-.1.09-.08.02-.04-.01.01-.02.02-.02.03,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.04,4.01s-.08.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.12,3.99l-.1.08c-.06.06-.06.08-.11.12.06-.04.11-.1.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.31,3.81l-.04.03s-.03.03.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.18,3.91l.09-.07s.12-.12-.03.02c.08-.07,0,0-.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.22,3.87c.05-.06.08-.1.17-.18-.05.02-.23.2-.17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.81,3.19l.07-.08-.09.08s-.06.08.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.04,4.17c.05-.05.14-.14.21-.21l-.07.06s-.06.08-.14.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.25,3.95l.1-.08s-.04.02-.1.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "25.6 3.53 25.39 3.71 25.6 3.53 25.6 3.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "25.07 4.21 24.94 4.33 25.13 4.15 25.07 4.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.11,4.21c-.1.1-.17.17-.24.24.02-.01.12-.09.2-.17-.05.04-.04.02.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.2,4.17s-.07.06-.12.11c.03-.02.06-.05.12-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.34,3.91s-.12.12-.15.16l.15-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.35,3.91h0s0,.02,0,.02c0,0,0,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.34,3.91h0s.02-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.48,3.69c.09-.08.19-.16.31-.3-.11.1-.18.18-.31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.52,3.72l.03-.04s-.1.1-.14.14l.12-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "25.58 3.67 25.52 3.72 25.52 3.73 25.58 3.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.33,4.01c.07-.06.08-.06.1-.07.02-.03.04-.06.03-.06-.05.05-.14.13-.13.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.35,3.95h0s.02-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "25.47 4 25.5 3.97 25.47 4 25.47 4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.48,3.86s-.01,0-.06.04c.02-.01.03-.02.04-.02.02-.02.04-.03.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.29,4.11s.05-.06.08-.09c-.05.05-.12.13-.08.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.32,3.99h0s-.02.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.32,3.99s.06-.06.1-.09c-.01.01-.03.02-.06.04-.01.01-.03.03-.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.47,3.06c-.14.14-.29.25-.14.1-.12.09-.58.55-.83.82.06-.06.12-.12.21-.19.07-.08.16-.2.3-.31.09-.06-.04.06-.11.14.17-.18.27-.23.53-.49l-.1.08s.11-.1.14-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.5,3.94h-.02s-.07.1-.18.21c.08-.06.13-.11.18-.16v-.04s.02-.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.46,3.93c.16-.15.23-.2.39-.37-.02,0-.14.12-.21.18.06-.02-.09.08-.17.18-.03.02-.04.03-.05.03-.02.02-.04.05-.06.08h0s0,0,0,0h0s.03-.03.02-.02h0s.04-.04.06-.06c-.03.04-.04.04-.06.06l-.02.02h0s.1-.06.1-.06c.02-.02,0-.03-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.13,3.08s-.02.02-.03.04c.02-.02.03-.03.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.05,3.18s-.09.08-.07.06c.04-.05.07-.07.12-.12-.04.04-.12.1-.19.18l.02-.02c-.04.06-.23.26-.25.28.13-.14.23-.24.36-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.79,3.52l.09-.06.12-.14-.08.08s-.07.06-.14.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "25.4 4.07 25.23 4.23 25.47 4.02 25.4 4.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "25.44 4.08 25.29 4.21 25.38 4.13 25.44 4.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.38,3.67l.05-.03-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.36,3.63l-.08.06s.08-.06.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.93,4.56c-.13.13-.34.33-.17.18l.16-.15s-.02,0,.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.22,4.07l.05-.05c-.06.05-.11.09-.16.13.04-.03.07-.06.11-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.9,3.48l-.1.1.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.74,3.74l.18-.13s-.09.07-.18.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.69,4.23c-.06.06-.08.09-.08.1.08-.09.21-.23.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.6,5.14s.07-.05.1-.08c-.03.02-.06.05-.1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.63,4.35s.02-.02.03-.04c-.03.02-.06.04-.05.02-.06.07-.1.11.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.22,4.66s-.01,0-.02.02c.02-.02.02-.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.64,6.19s-.02,0-.02,0c-.01.01,0,.01.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.45,4.22s-.02.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.04,3.61s.04-.04.08-.07c-.04.04-.06.06-.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.65,3.47h0s.02-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.51,4.15s-.03.04-.04.05c.01-.01.02-.03.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.44,4.22s0-.01.01-.02c-.03.02-.04.04-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.46,4.22s0,0,0-.02c-.01.01-.02.02-.02.02,0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.44,4.58s0,0-.02.01c.07-.05.06-.04.02-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "27.71 3.17 27.7 3.18 27.69 3.19 27.71 3.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.84,3.08c-.21.17-.19.15-.15.1l-.46.42.61-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.51,3.73l.14-.14c.26-.19.18-.11.39-.29-.52.43-.1,0-.62.43l.1-.1s.03-.02.02-.01c.24-.23-.39.3-.33.22.03-.04.1-.11.17-.16l-.14.09s.1-.09.09-.08h-.06s.02,0,.02,0c-.09.06-.22.16-.27.2.07-.07.06-.04.12-.1l-.14.09c.13-.12.27-.22.26-.19.51-.45-.14.1.14-.18l.08-.04c.29-.26.17-.18.34-.35-.09.08-.44.42-.58.52.04-.04.05-.06-.06.02.18-.16.13-.13.11-.13l.24-.21c-.08.05-.2.16-.32.24.01-.03.2-.2.36-.33.02-.05-.29.27-.36.29.08-.1-.03-.02-.19.08.07-.08.15-.13.22-.19l-.2.16s.06-.06.09-.08c-.08.06-.24.21-.32.25-.27.23.37-.36.05-.12.07-.06.15-.13.24-.21-.22.15-.16.11-.44.32l.15-.15c-.17.17-.4.34-.58.48-.08.08-.16.15-.19.18l-.15.09s.12-.11.23-.19l-.06.05c.08-.08.23-.2.36-.32-.05.04-.09.09-.14.14.15-.12.31-.26.46-.38-.03.02-.06.04-.07.05.04-.03.08-.06.1-.09.02-.02-.03.02-.09.07l.26-.24-.11.09.15-.17c-.29.22-.7.55-.83.62.2-.17.32-.28.55-.49-.24.22.12-.07.09-.01.02-.03.13-.13.17-.16l-.25.17c.19-.17.14-.13.21-.21-.37.34-.27.2-.39.29.13-.11.26-.22.24-.18.27-.26-.46.37-.23.14,0,0-.01.02.05-.04-.12.09-.05,0,.07-.1h0c.03-.06-.06-.07-.38.21.04-.04.39-.34.45-.4l-1.1.92c.27-.24.91-.84,1.08-.96.03-.04.07-.09-.03-.01-.04.04-.38.36-.41.38.29-.29.15-.16.4-.4-.05.06-.48.44-.48.42.06-.06.42-.38.47-.42l-.44.36c.08-.06.35-.32.47-.43-.08.08,0-.02-.06,0l-.09.1c.04-.08-.61.51-.6.47.09-.08.53-.48.58-.53-.22.19-1.04.91-1.22,1.04l.12-.12-.15.11c.33-.28,1.03-.87,1.3-1.1.09-.1.14-.13.12-.14.11-.11.18-.15.19-.15l.05-.1c-.25.23-.27.2-.47.4l.29-.2c-.25.23-.72.63-.7.56.1-.09.44-.4.53-.48-.09.08-.18.13-.12.07l.14-.11c.08-.1-.35.28-.12.05.01-.02.3-.31.16-.17-.28.26-1.15,1.07-1.36,1.27.02-.02.25-.27.38-.41.22-.2.53-.48.72-.66-.07.06-.16.13-.18.16.05-.06.21-.19.17-.17-.25.23,0-.04-.22.19-.08.06.04-.06.02-.06-.16.15-.56.5-.64.56.06-.06.14-.14.18-.17,0-.04.1-.16.09-.18.06-.06.12-.14.23-.23-.05.04-.13.12-.15.11.2-.21.05-.02.3-.27-.14.14-.21.17-.31.25-.22.21-.02.06.08-.02-.31.29-.64.58-.8.69-.09.06.19-.19.15-.16.02-.08-.56.48-.36.25.18-.2.39-.37.52-.51.09-.06-.1.14-.09.14l.08-.1c.07-.06.13-.1.07-.04.17-.17-.02-.08.12-.26-.07.06-.14.12-.22.19l.03-.02c-.15.16-.23.19-.29.27-.12.1-.3.25-.23.15l.22-.22c-.06.06-.12.14-.05.07-.1.09.28-.31-.02-.04l-.14.16c-.12.1-.37.31-.31.23-.21.22.02-.02-.22.23.31-.31.02.04.34-.29-.29.29-.11.14-.35.39.07-.07.14-.14.11-.09.02-.02.05-.04.07-.06h0s0,0,0,0c.01-.01.01-.01,0,0,.03-.03.07-.07.11-.11.17-.16.18-.13.27-.21-.03.04-.09.08-.16.16l.14-.12c-.16.16-.25.27-.36.35v.02c-.08.09-.11.14-.03.08-.03.04.19-.16.06-.04l.12-.08-.04.04s.31-.21.04.09c.05-.03.1-.07.07-.02l-.14.14c.06-.04-.12.16.03.02-.37.37-.05.12-.1.2l.19-.17s.06-.02.15-.07l.16-.15c.15-.11-.09.14-.06.14-.06.06-.05.04-.02,0-.35.36.31-.2.06.06.06-.05.05-.03,0,.01,0,0,0,0,0,0h0s-.06.06-.08.09c.04-.04.07-.07.08-.09,0,0,.03-.01.08-.04l-.18.16h0c-.06.06.09-.08.22-.2.03-.02.07-.05.11-.09-.28.27.11-.07-.19.21.15-.13.14-.07.46-.36-.04.04-.06.06-.06.06-.03.04-.06.08.03,0l-.23.21.32-.26c-.13.13-.21.21-.39.36.29-.22.11-.08.4-.3l-.15.13s.22-.17.1-.05c-.27.26.02.1-.21.37.43-.39-.18.19.16-.11-.1.09-.16.15-.25.22.12-.07-.14.17.16-.07-.1.09-.15.13-.22.19.02-.02.09-.07.03-.02-.06.06-.09.07-.14.11.03,0,.35-.27.66-.54-.13.13-.11.12.09-.04-.1.09-.19.18-.24.2,0,.02-.11.17.13-.04-.06.06-.01.02.02,0,0,.03-.02.05.01.04l.04-.04c.3-.25.08-.04.12-.06l-.03.03c-.19.21.11-.08-.11.16l.18-.16c.39-.33-.21.22-.05.11l.1-.09c.14-.11-.51.48-.56.53-.03.03-.06.04-.08.06-.21.22.24-.2.31-.23-.13.11-.33.28-.35.31-.1.09.45-.32.21-.1.1-.09.19-.18.28-.23.05-.02-.35.35-.03.1l-.08.07c.09-.06.16-.08.33-.22-.63.54.36-.2-.23.29h.05s-.06.05-.06.05c-.02.05.12-.06.27-.17-.04.04-.09.08-.13.1-.1.12-.07.11.24-.11l-.19.16c.12-.08-.27.28-.03.13-.02.02-.06.05-.09.07.25-.15-.48.5.23-.06l.19-.12c.03-.07.31-.24.42-.35.05-.02-.19.2-.24.21l.03-.03c-.37.29-.1.14-.36.34.06.03-.11.24-.09.3l.28-.23v.03c-.07.06-.22.18-.22.16-.16.13.15-.09.21-.14-.1.11-.34.26-.34.27h.03s.03-.04.03-.04c.12-.08.25-.18.24-.16-.05.05-.17.14-.18.16-.02.02-.03.02,0,.01v.04s.21-.19.21-.19c.12-.08,0,.03.25-.18-.39.32-.08.19-.2.29.18-.12.18-.1.17-.07.04-.04.3-.24.28-.2-.53.4-.21.2-.59.51.25-.2.09-.01.44-.3-.03.04-.2.15-.32.26.23-.13-.09.16,0,.14.07-.05.17-.14.28-.21l-.34.28s.41-.3.18-.1c.06-.05.15-.12.17-.13-.29.32.38-.08-.22.47.13-.11.15-.11.16-.11.03-.03.18-.13.27-.2l-.25.22c.27-.19.04.02.3-.17l-.05.02c.31-.21.66-.51,1.05-.79-.35.24.48-.41-.03-.07.07-.06.13-.09.21-.16-.17.12-.21.13-.14.07l.04-.03c-.07,0,.08-.14.16-.26l-.19.14s.08-.07.12-.11c-.3.21,0,.04-.32.26.38-.3-.04-.07.39-.4,0-.02-.22.17-.22.15l.12-.09-.16.11s.16-.14.26-.22c-.01.01.03-.02.04-.02.13-.12-.07,0-.03-.04l-.06.07c-.14.05-.02-.12-.28.03l-.09.07c-.18.1.08-.1-.02-.07l.02-.02c-.09.06-.14.09-.14.07.11-.07.19-.17.31-.25-.2.11-.15.09-.49.33l.14-.12c-.14.1-.21.15-.26.16.14-.09.22-.18.39-.3.3-.28-.36.21.1-.17-.42.3-.2.2-.3.26-.13.11-.31.22-.28.18,0-.02.5-.42.48-.44l.03-.02c.1-.09-.15.09,0-.05-.25.19,0-.03-.31.22l.09-.03c-.09.05-.46.33-.3.17.07-.05.15-.11.2-.14.09-.08-.07.04.02-.04.31-.24.09-.03.34-.2.13-.11-.25.15.1-.11-.44.33.03-.07-.31.17l.19-.15s-.12.08-.12.08l.25-.18c-.22.15.16-.17.04-.09.03.02-.22.18-.35.3-.27.16.47-.41.35-.37.03-.02-.1.11-.19.17.03-.04.1-.1.19-.19-.06,0-.19.16-.31.24.22-.19-.1.06-.18.11l.19-.15c.1-.13-.4.31-.27.17l.27-.2-.08.04.22-.17c-.17.11-.13.08-.08.01-.13.11-.34.27-.36.27.1-.1.18-.14.14-.14.12-.09.27-.21.1-.06.06-.05.12-.09.18-.14.12-.11.01-.05,0-.05,0,0-.01.02-.04.04l-.28.19c.07-.06.13-.1.18-.15-.02.01-.11.08-.14.08.15-.12.31-.25.39-.3l-.19.11c.06-.06.17-.16.23-.2.08-.09-.32.21-.22.09-.03.02-.06.04-.08.06.02-.05.19-.21-.03-.06l.26-.24c-.07.04-.33.3-.45.36-.1.05.23-.2.3-.27-.14.1-.43.32-.23.12.06-.04.02,0,.04-.01ZM28.23,3.64s.17-.12.06-.03c-.21.17-.12.09-.06.03ZM27.54,3.73c.06-.05.04-.02-.03.04-.02,0-.01,0,.03-.04ZM25.63,4.13h0c-.06.06-.04.04,0,0ZM25.7,4.05l-.07.07s.05-.04.04-.03c.04-.04.07-.08.03-.04ZM27.2,5.64l.05-.04c.06-.04,0,0-.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.82,3.55s-.06.06-.1.09c.03-.03.07-.06.1-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "28.7 3.77 28.7 3.77 28.74 3.74 28.7 3.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.41,2.88s-.05.06-.09.09c.04-.04.08-.08.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.33,4.25l.05-.03s.02-.03.05-.06c-.04.04-.1.1-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.32,3.13s0,0-.03.02l-.08.08s.08-.06.11-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.89,3.69c.15-.14.09-.1.06-.08h0c-.21.2-.13.14-.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.94,3.61s-.01,0,0,0c-.08.08-.01.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M25.58,4.12s-.19.18-.13.12c-.19.18.25-.2.13-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "26.37 3.22 26.19 3.39 26.34 3.26 26.37 3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.29,3.4l.04-.06s-.05.04-.06.06c0,.01-.03.05.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.26,3.4s0,0-.04.02c0,0,.01,0,.04-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "26.44 3.18 26.4 3.22 26.4 3.24 26.44 3.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.37,3.55l.06-.04c.06-.06.1-.1.07-.08-.05.04-.07.06-.13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.83,3.04s-.08.08-.13.14l.23-.21-.09.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M26.92,3.03c.06-.06.2-.15.17-.15-.06.06-.13.09-.17.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "26.8 3.48 26.8 3.48 26.42 3.83 26.8 3.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.85,2.83c.08-.1-.24.21-.14.09-.09.08-.08.1-.16.16.1-.08.05-.02.3-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.56,3.08s-.04.03-.06.05c.03-.02.04-.03.06-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "27.44 6.39 27.36 6.46 27.5 6.35 27.44 6.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M27.76,6.18l-.26.19.24-.17s-.04.02.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M28.7,3.19l-.06.05c-.06.06-.07.06-.07.08l.13-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "28.63 3.48 28.64 3.48 28.42 3.67 28.63 3.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M29.02,3.36s-.05.02-.04.01c.05-.02-.24.22.04-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.53.61s-.18.07-.21.09c.05,0,.26-.11.21-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "39.03 .55 38.95 .58 39.15 .51 39.03 .55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.07.67c.32-.16-.07-.02.03-.1l.07-.04-.27.11c.05,0,.24-.04.16.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.4,1.05c.12-.06.12-.03.03-.03-.01,0-.02.01-.03.02,0,0,0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.4,1.04s-.1.06,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.5,1.07l-.12.03c-.07.04-.08.06-.14.08.07-.01.14-.05.26-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.74.97h-.05s-.04.04.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.58,1.01l.11-.03c.05-.03.16-.07-.04,0,.1-.04,0,0-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.63.98c.07-.04.11-.07.23-.11-.06-.01-.29.1-.23.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.41.53l.09-.06-.11.04c.06-.02-.08.06.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.38,1.25c.07-.03.18-.09.27-.13l-.08.02s-.08.06-.19.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.65,1.12l.13-.03s-.05,0-.13.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "39.11 .82 38.84 .9 39.11 .82 39.11 .82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "38.4 1.32 38.23 1.38 38.49 1.29 38.4 1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.45,1.36c-.14.05-.22.11-.31.14.03,0,.15-.04.25-.07-.06.02-.05,0,.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.55,1.37s-.09.03-.16.05c.03,0,.08-.02.16-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.75,1.13s-.15.07-.19.1l.19-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.76,1.14h0s0,.02,0,.02c0,0,0,0,.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.75,1.13h0s.03-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.95.94c.11-.04.24-.07.4-.16-.14.05-.23.11-.4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.99,1.01l.04-.04c-.05.02-.12.06-.18.08l.15-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "39.06 .99 38.99 1.01 38.98 1.02 39.06 .99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.72,1.26c.09-.03.1-.02.12-.02.03-.03.05-.05.04-.06-.06.03-.17.07-.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.76,1.19h.01s.02-.02-.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "38.88 1.34 38.92 1.33 38.89 1.34 38.88 1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.92,1.16s-.02,0-.08.01c.02,0,.04,0,.04,0,.03-.01.05-.02.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.66,1.36s.07-.04.1-.06c-.06.03-.15.08-.1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.72,1.21h0s-.02.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.72,1.21s.08-.03.12-.04c-.02,0-.04,0-.07.01-.01,0-.03.02-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M40.15.82c-.18.08-.36.13-.17.02-.14.04-.73.32-1.06.49.08-.03.15-.07.27-.1.1-.05.21-.15.38-.2.1-.02-.05.05-.14.11.22-.11.34-.11.67-.27l-.13.03c.05-.02.14-.05.18-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.92,1.28h-.03s-.1.06-.23.14c.09-.03.16-.05.22-.08v-.05s.04,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.88,1.25c.2-.08.29-.1.5-.21-.02-.02-.17.06-.26.08.07.02-.11.04-.21.12-.04,0-.05,0-.06,0-.02.02-.05.04-.08.06h.01s0,0,0,0h0s.04-.02.02-.01h0s.05-.02.07-.03c-.04.03-.05.02-.07.03h-.03s0,.01,0,.01h.12s.01-.04-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.78.61s-.03.02-.05.02c.03,0,.04-.01.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.67.68s-.11.04-.09.02c.06-.03.09-.04.16-.07-.05.02-.15.04-.24.1h.03c-.06.04-.3.17-.33.18.17-.09.3-.15.47-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.32.94h.11s.16-.1.16-.1l-.1.05s-.09.02-.17.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "38.79 1.39 38.58 1.48 38.88 1.37 38.79 1.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "38.83 1.42 38.65 1.5 38.76 1.46 38.83 1.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.11,2.81h.06s-.06,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.09,2.73l-.09.04c.05-.02.09-.03.09-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.3,2.44c-.16.09-.42.22-.22.13l.2-.09s-.02-.01.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M40.79,2.62l.06-.03c-.07.03-.13.05-.19.07.04-.01.09-.03.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.61,2.28l-.12.07s.08-.05.12-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.48,3.09l.21-.08s-.11.03-.21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.09,1.82c-.07.05-.1.07-.11.08.11-.06.27-.15.11-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.98,3.69s.08-.02.12-.04c-.04,0-.08.02-.12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39,1.93s.03-.02.04-.03c-.04,0-.07,0-.06,0-.08.05-.13.08.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.91,4.54s-.01,0-.02.01c.03-.01.03-.01.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.06,5.77s-.02,0-.02,0c-.01,0,0,.01.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.82,1.63s-.02,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.58,1.24s.05-.02.1-.04c-.05.02-.08.03-.1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M40.27,1.48h0s.03-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.9,1.58s-.04.03-.05.04c.01,0,.03-.02.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.81,1.62s.01-.01.02-.02c-.03.01-.05.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.83,1.64s0-.01.01-.02c-.01,0-.02.01-.03.02,0,0,0,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.06,4.03s-.01,0-.02,0c.09-.03.07-.02.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "41.46 1.76 41.45 1.77 41.44 1.77 41.46 1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.62,1.73c-.25.09-.23.07-.18.04l-.57.26.75-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.24,2.95l.17-.1c.31-.1.21-.04.46-.17-.63.26-.1-.06-.73.2l.12-.07s.03,0,.03,0c.29-.16-.46.17-.39.1.04-.03.13-.08.21-.1l-.17.04s.12-.06.11-.04l-.07-.02h.02c-.1.03-.26.08-.33.1.08-.05.07-.02.15-.06l-.16.04c.16-.08.32-.13.31-.1.61-.29-.17.05.18-.16h.09c.35-.18.21-.14.42-.26-.11.06-.53.29-.7.33.04-.03.06-.05-.07,0,.22-.1.16-.09.14-.1l.29-.13c-.09.02-.24.08-.38.13.02-.03.25-.14.43-.22.03-.05-.35.18-.43.16.1-.08-.03-.04-.22,0,.09-.06.18-.07.26-.12l-.24.08s.08-.04.11-.05c-.1.02-.29.13-.38.14-.33.13.45-.25.07-.12.08-.04.18-.07.29-.13-.26.07-.19.04-.53.15l.18-.11c-.21.12-.48.2-.71.27-.1.05-.19.1-.24.12l-.17.03s.15-.07.27-.11l-.07.02c.1-.06.27-.13.44-.19-.06.03-.12.06-.18.09.18-.07.38-.15.55-.22-.03.01-.07.02-.08.02.05-.02.09-.04.12-.05.03-.01-.04,0-.11.04l.32-.15-.13.05.18-.14c-.34.11-.84.29-1,.3.25-.09.39-.17.68-.29-.29.15.15-.01.1.04.03-.03.16-.08.21-.1l-.29.07c.23-.1.17-.09.26-.14-.45.21-.32.1-.47.14.15-.07.31-.13.29-.09.33-.18-.55.2-.27.05,0,0-.02.02.06-.01-.14.05-.05-.04.09-.09h0c.04-.06-.05-.12-.44.05.05-.02.47-.2.55-.23l-1.34.5c.34-.14,1.12-.51,1.33-.56.04-.03.09-.07-.03-.03-.04.03-.48.23-.51.23.36-.19.19-.1.5-.27-.07.04-.6.26-.59.24.08-.03.52-.22.57-.25l-.53.19c.1-.03.44-.19.58-.26-.1.05,0-.04-.06-.02l-.11.07c.06-.08-.74.28-.73.22.11-.04.66-.27.72-.33-.27.11-1.29.51-1.51.57l.15-.07-.18.05c.41-.15,1.26-.47,1.6-.59.11-.07.18-.08.15-.1.14-.07.22-.08.23-.08l.07-.1c-.31.14-.33.09-.58.21l.35-.08c-.31.14-.89.35-.85.29.12-.06.55-.23.65-.28-.11.04-.22.05-.15.01l.17-.06c.11-.07-.42.14-.14-.01.02-.02.38-.2.2-.12-.34.17-1.43.65-1.7.76.02-.01.31-.2.48-.28.27-.14.67-.27.9-.38-.09.03-.19.07-.23.08.07-.04.26-.11.21-.11-.31.13,0-.05-.27.11-.1.02.05-.05.03-.07-.2.1-.69.28-.79.3.08-.04.18-.08.23-.11.01-.05.14-.14.13-.18.07-.04.16-.1.29-.15-.06.02-.17.06-.18.05.26-.14.05,0,.37-.15-.18.08-.26.08-.38.11-.28.13-.04.06.08.03-.39.17-.8.32-1,.36-.11.01.24-.12.19-.11.04-.09-.7.25-.44.07.24-.13.49-.22.66-.3.1-.01-.14.11-.12.12l.11-.07c.09-.03.16-.04.09,0,.21-.11,0-.12.18-.26-.09.03-.18.05-.27.1h.04c-.19.1-.29.09-.37.15-.15.04-.38.12-.28.04l.28-.13c-.08.04-.16.09-.07.06-.13.04.36-.21-.01-.06l-.19.11c-.15.04-.46.15-.38.09-.27.13.03,0-.28.15.4-.19.01.07.42-.14-.37.19-.15.1-.46.27.09-.04.17-.09.14-.05.03-.01.06-.02.08-.03h0s.01,0,.01,0c.01,0,.02,0,0,0,.04-.02.09-.05.14-.07.22-.08.22-.05.34-.09-.04.03-.11.04-.2.09l.17-.06c-.2.09-.33.18-.46.21v.03c-.11.07-.14.11-.05.08-.04.03.24-.07.08,0l.15-.02-.05.02c0,.05.38-.07.03.14.06,0,.13-.02.08.02l-.18.08c.07,0-.16.13.03.06-.47.23-.07.13-.14.2l.23-.1s.07.02.18,0l.2-.09c.18-.05-.12.12-.08.15-.08.03-.06.01-.02-.01-.45.25.38-.06.06.13.08-.02.06,0,0,.02,0,0,0,0-.01,0h0s-.07.05-.1.07c.05-.03.09-.05.1-.06,0,0,.04,0,.09,0l-.22.1h0c-.08.05.11-.04.27-.12.04-.01.08-.03.14-.04-.35.17.13-.02-.24.16.19-.07.16,0,.56-.17-.05.02-.07.04-.08.03-.04.03-.08.06.04.03l-.28.13.39-.14c-.16.09-.26.14-.48.22.35-.11.14-.02.48-.13l-.18.08s.26-.08.12,0c-.33.18,0,.15-.28.36.53-.25-.23.14.19-.04-.12.06-.19.1-.31.14.14-.02-.18.14.18.01-.13.05-.19.08-.26.11.03,0,.11-.04.04,0-.07.04-.11.04-.17.06.04.03.43-.14.79-.3-.17.09-.14.09.11,0-.12.06-.24.12-.29.12-.01.02-.14.15.15.03-.07.04-.01.03.02.02,0,.04-.03.05,0,.07l.04-.03c.36-.14.09-.01.14,0l-.04.02c-.23.16.13-.03-.14.15l.22-.1c.48-.2-.26.17-.07.12l.12-.06c.17-.05-.62.32-.68.36-.04.02-.07.02-.1.03-.26.16.29-.12.37-.12-.15.07-.4.16-.42.2-.12.06.53-.16.25,0,.12-.06.23-.12.33-.14.05,0-.43.26-.04.11l-.09.04c.1-.03.19-.01.4-.09-.75.34.42-.05-.29.25l.06.04-.07.03c-.03.05.14,0,.31-.07-.04.03-.11.05-.15.07-.12.11-.09.1.28,0l-.23.1c.14-.05-.33.22-.04.16-.03,0-.07.03-.1.04.29-.06-.58.4.26.06l.22-.05c.04-.07.36-.15.49-.22.06,0-.23.15-.28.15l.04-.02c-.44.18-.13.12-.42.25.06.08-.14.27-.12.36l.33-.15v.04c-.08.04-.27.12-.26.09-.19.09.18-.03.25-.06-.12.1-.4.15-.4.17h.03s.04-.01.04-.01c.14-.04.29-.1.28-.07-.06.04-.2.1-.21.11-.02,0-.03.02,0,.01v.05s.25-.13.25-.13c.14-.04,0,.04.3-.1-.45.22-.11.21-.24.29.2-.06.21-.03.2,0,.05-.03.35-.16.32-.12-.62.25-.25.16-.68.36.29-.14.1.04.51-.16-.04.04-.23.1-.37.17.26-.05-.11.17,0,.2.08-.03.2-.1.33-.13l-.39.2s.47-.18.2-.05c.07-.03.17-.08.2-.08-.34.28.43.1-.26.53.15-.08.17-.08.18-.07.03-.02.2-.08.31-.13l-.28.18c.31-.12.04.04.34-.07h-.06c.35-.12.75-.34,1.2-.52-.4.14.55-.3-.02-.11.09-.05.15-.05.25-.1-.19.07-.24.07-.16.02l.05-.02c-.07-.04.1-.15.2-.27l-.22.1s.09-.06.14-.09c-.34.12,0,.05-.37.19.44-.21-.04-.11.46-.33,0-.02-.25.11-.26.09l.13-.06-.18.07s.19-.11.31-.16c-.01,0,.04,0,.05,0,.15-.09-.08-.03-.03-.06l-.07.06c-.16,0,0-.16-.31-.11l-.1.05c-.21.03.1-.08-.01-.1h.03c-.11.02-.16.03-.16.01.13-.04.22-.12.36-.16-.23.04-.17.04-.57.17l.17-.08c-.16.05-.24.09-.3.08.16-.04.25-.13.46-.18.35-.21-.41.08.12-.18-.48.17-.24.16-.35.19-.15.08-.36.13-.32.09,0-.02.59-.28.56-.32,0,0,.04,0,.04,0,.11-.07-.18.04.01-.06-.29.11,0-.03-.36.12h.1c-.1.02-.54.18-.35.06.07-.03.18-.06.23-.07.1-.06-.08,0,.03-.05.37-.15.1.01.39-.08.15-.08-.28.07.12-.09-.51.2.05-.07-.35.06l.22-.09s-.14.04-.14.03l.29-.1c-.25.08.19-.13.05-.1.03.04-.26.12-.41.21-.32.07.56-.28.42-.3.03,0-.12.09-.22.12.04-.03.12-.08.23-.14-.06-.02-.22.1-.36.14.26-.13-.12.02-.21.04l.22-.09c.12-.11-.47.18-.32.07l.32-.11h-.09s.25-.09.25-.09c-.2.05-.15.03-.09-.03-.15.07-.4.17-.42.15.13-.07.21-.08.17-.1.14-.05.32-.12.12-.02.07-.03.14-.05.21-.08.14-.08.02-.06.01-.07,0,0-.02.02-.05.03l-.33.09c.08-.04.15-.07.22-.09-.03,0-.13.04-.16.03.18-.07.37-.15.46-.17l-.22.04c.08-.04.21-.11.27-.14.1-.07-.38.09-.25,0-.04.01-.07.02-.1.03.03-.05.24-.17-.02-.1l.31-.16c-.09,0-.4.2-.54.21-.12.01.27-.13.36-.18-.17.05-.51.17-.26.03.06-.02.02.01.05.01ZM41.95,2.67s.2-.06.07,0c-.26.1-.14.04-.07,0ZM41.19,2.39c.08-.03.04,0-.04.04-.02,0-.02,0,.04-.04ZM39.04,1.65h.01c-.08.05-.05.03-.01,0ZM39.12,1.57s-.06.02-.09.04c.06-.02.06-.02.05,0,.06-.03.1-.05.04-.04ZM40.6,4.75l.06-.03c.07-.01.01,0-.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.52,2.32s-.08.04-.12.06c.04-.01.08-.03.12-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "42.44 3.11 42.44 3.11 42.48 3.09 42.44 3.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.19,1.21s-.07.04-.11.06c.05-.02.1-.05.11-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.68,1.58h.07s.03-.04.06-.06c-.05.02-.12.06-.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.97.81s0,0-.03,0l-.1.05s.1-.02.14-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.4,1.24c.18-.08.12-.07.08-.07h0c-.26.11-.17.09-.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.47,1.17s-.02,0-.01-.01c-.1.04-.02.02.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M38.98,1.59s-.24.1-.16.06c-.24.1.3-.08.16-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "40.01 .95 39.78 1.06 39.97 .99 40.01 .95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.89,1.14l.05-.05s-.06.02-.08.03c0,.02-.04.05.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.86,1.11s0-.01-.05,0c0,0,.02,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "40.09 .95 40.04 .98 40.03 1 40.09 .95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M39.94,1.39h.08c.08-.04.12-.07.09-.06-.06.02-.09.02-.17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M40.54,1.04s-.1.05-.17.09l.28-.13-.11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M40.64,1.08c.08-.03.24-.07.21-.09-.08.03-.16.04-.21.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "40.43 1.59 40.42 1.59 39.96 1.79 40.43 1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.68,1.42c.1-.08-.29.12-.16.03-.11.04-.1.07-.2.11.12-.03.06,0,.36-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.32,1.55s-.04.01-.07.02c.03,0,.05-.02.07-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "40.84 5.94 40.75 6 40.9 5.93 40.84 5.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M41.2,5.83l-.3.13.28-.1s-.04,0,.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.52,2.36l-.07.03c-.08.04-.08.04-.09.06l.16-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "CateringTitleText-3",
    points: "42.41 2.7 42.41 2.7 42.15 2.82 42.41 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CateringTitleText-3",
    d: "M42.84,2.76s-.06,0-.05-.01c.06,0-.29.16.05.01Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCateringTitleText);
export default __webpack_public_path__ + "static/media/CateringTitleText.c4bf2b1e326511528b3004a232cd7412.svg";
export { ForwardRef as ReactComponent };